<template>
    <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
    <h2 class="vy-kojin-title">{{ title }}</h2>
    <article style="padding: 0 10px;">
      <!--メインコンテンツ-->
      <hr>
      <!-- パンくずリスト -->
      <nav style="--bs-breadcrumb-divider:'>';" aria-label="breadcrumb" v-if="type!=2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" v-on:click="Return_home">Home</a></li>
          <li class="breadcrumb-item" ><a href="#" v-on:click="Return_list">体験プログラム一覧</a></li>

          <template v-if="type == 0">
            <!--新規登録時-->
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
          </template>
          <template v-else>
            <!--詳細 or 編集時-->
            <template v-if="mode == 0">
              <!--詳細時-->
              <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
            </template>
            <template v-if="mode == 1">
              <!--編集時-->
              <li class="breadcrumb-item" ><a href="#" v-on:click="Change_detail">体験プログラム詳細</a></li>
              <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
            </template>
          </template>
        </ol>
       </nav>
  
       <div id="manual_area">

          <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />体験プログラムのマニュアル</span>
          <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

      </div>
      <div id="detail_button_area" v-if="type==1">
        <span v-if="mode == 0">

            <button style="width: 200px; height: 50px;padding: 0;margin:5px;background-color:green" class="btn btn-secondary mx-aut" v-on:click="rireki_disp()">申込者情報</button>
            <button v-if="isButtonVisible" style="width: 200px; height: 50px;padding: 0;margin:5px;background-color:green" class="btn btn-secondary mx-aut" v-on:click="checkin()">チェックイン状況</button>
        </span>
          
          
        
        <span v-if="mode == 1">
          <button  class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;"  v-on:click="Change_detail()">確認へ戻る</button>
          
        </span>
      </div>

      <span v-if="mode == 0">
        <!--タイトル画像が存在する場合は表示
        <img v-if="taiken_list.title_image" v-bind:src="taiken_list.title_image" style="max-width:100%;margin-bottom:10px">
-->
        <div id="tab" v-if="taiken_list.shubetsu==1">
            <ul class="tabMenu">
                <li @click="TabSelect('tab_detail')" id="tab_detail" v-bind:class="detail_color" style="width: 100%;">詳細内容</li>
<!--                
                <li @click="TabSelect('tab_list')" id="tab_list" v-bind:class="list_color" style="width:34%">日程一覧</li>
                <li @click="TabSelect('tab_calendar')" id="tab_calendar" v-bind:class="calendar_color">カレンダー</li>
-->
            </ul>
        </div>
        <div class="TabContents">
          <div v-if="TabActive === 'tab_detail'" >
                
                <span style="text-align: left;float: left;padding:5px">
                    <span :style="{ color: shosai_color[0] ,fontWeight:shosai_bold[0] == '0' ? 400 : 700 }">{{ taiken_list.bunrui1 }}</span>
                    <span v-if="shosai_disp[1] == 1" :style="{ color: shosai_color[1] ,fontWeight:shosai_bold[1] == '0' ? 400 : 700 }"><br>{{ taiken_list.bunrui2 }}</span>
                </span>
                
                <!-- 施設・地域活動 -->
                <table class="vy-form-table" v-if="taiken_list.shubetsu == 1"  style="margin-bottom:0px">
                  
                    <!-- No. プログラム名称 -->
                     <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;">
                            <b :style="{ color: shosai_color[2] ,fontWeight:shosai_bold[2] == '0' ? 400 : 700 }">{{ taiken_list.taiken_no_text }}：{{ taiken_list.name }}</b>
                        </td>
                    </tr>
                    
                    <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && (taiken_list.s_comment != null && taiken_list.s_comment != '')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th>
                                <label for="">受入先からのコメント</label>
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[6] ,fontWeight:shosai_bold[6] == '0' ? 400 : 700 }">
                                {{taiken_list.s_comment}}
                            </td>
                        </tr>
                    </template>
                     <template v-if="taiken_list.all_teiin_flg == 1">
                      <!--プログラム全体の定員-->
                      <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label >
                                    プログラム全体の定員
                                </label>
                                
                                
                            </th>
                            <td style="text-align: left;font-size:16px" >
                              <span :style="{ color: shosai_color[25] ,fontWeight:shosai_bold[25] == '0' ? 400 : 700 }">
                                {{ taiken_list.seisaku_teiin }} 人
                              </span>
                            </td>
                        </tr>
                    </template>
                    
                </table>
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="taiken_list.shubetsu == 1 && sub_list.length != 0">
                  <ul id="katsudou_tabMenu" class="edit_tabMenu">
                    <template v-if="KatsudouActive=='main'">
                        <li class="tabblue">活動1</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                      </template>
                      <template v-for="(result,s) in sub_list" v-bind:key="s">
                        <template v-if="KatsudouActive=='sub'+s">
                          <li class="tabblue" >活動{{s+2}}</li>
                        </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <table  class="vy-form-table edit_komoku_area" v-if="taiken_list.shubetsu == 1"  style="margin-bottom:0px;margin-top:0px">
                   
                    <tbody v-show="KatsudouActive=='main'">

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ taiken_list.naiyou }}
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                    <template v-if="sub_list.length != 0">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[taiken_list.hissu_flg ]}}
                          </td>
                      </tr>
                    </template>

                     <!-- 開催地名 -->
                     <template v-if="shosai_disp[18] == 1 && taiken_list.k_name != null && taiken_list.k_name != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    開催地名
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        開催地名
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[18] ,fontWeight:shosai_bold[18] == '0' ? 400 : 700 }">
                            {{ taiken_list.k_name }}
                            </td>
                        </tr>
                    </template>
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(taiken_list.k_jusyo)">
                                <u :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">{{ taiken_list.k_jusyo }}</u>
                            </td>
                        </tr>
                    </template>
                    <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && taiken_list.k_access != null && taiken_list.k_access != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }">
                              {{ taiken_list.k_access }}
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken_list.k_tel != null && taiken_list.k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" >
                                <u :style="{ color: shosai_color[19] ,fontWeight:shosai_bold[19] == '0' ? 400 : 700 }">{{ taiken_list.k_tel }}</u>
                            </td>
                        </tr>
                    </template>

                    <template v-if="taiken_list.nittei_sentaku == 0">
                        <!-- 日程選択方法が日程ごと（nittei_sentaku == 1）であれば以下の項目は非表示 -->
                      <template v-if="shosai_disp[5] == 1">
                        <!-- 活動日数 -->
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label for="">活動日数</label>
                              </th>
                              <td style="text-align: left" :style="{ color: shosai_color[5] ,fontWeight:shosai_bold[5] == '0' ? 400 : 700 }">
                                <template v-if="taiken_list.nissu_mongon != '' && taiken_list.nissu_mongon != null">
                                  {{taiken_list.nissu_mongon}}
                                </template>
                                <template v-else>
                                  <span v-if=" taiken_list.nissu_min == taiken_list.nissu_max ">
                                  {{ taiken_list.nissu_min  }}日
                                  </span>                            
                                  <span v-else-if="taiken_list.nissu_min != taiken_list.nissu_max ">
                                  <span v-if="taiken_list.nissu_max == '' || taiken_list.nissu_max == null ">
                                      {{ taiken_list.nissu_min  }}日以上
                                  </span>
                                  <span v-else-if="taiken_list.nissu_min == '' || taiken_list.nissu_min == null ">
                                      {{ taiken_list.nissu_max  }}日以下
                                  </span>
                                  <span v-else>
                                      {{taiken_list.nissu_min}} ～ {{taiken_list.nissu_max}}日
                                  </span>
                                  </span>&nbsp;&nbsp;
                                  <span v-if="taiken_list.nissu_joken == 1">連続</span>
                                  
                                </template>
                              </td>
                          </tr>
                      </template>
                    
                      <template v-if="taiken_list.teiin_settei == 1" >
                          <tr >
                              <td colspan="2"><div class="vy-dotted"></div></td>
                          </tr>
                          <tr>
                              <th>
                                  <label for="">1日の定員</label>
                              </th>
                              <td style="text-align: left" :style="{ color: shosai_color[26] ,fontWeight:shosai_bold[26] == '0' ? 400 : 700 }">
                                <template v-if="taiken_list.teiin_mongon != '' || taiken_list.teiin_mongon != null">
                                  {{  taiken_list.teiin_mongon }}
                                  
                                </template>
                                <template v-else>
                                  {{  taiken_list.teiin_oneday }}&nbsp;名まで&nbsp;
                                </template>
                              </td>
                          </tr>

                      </template>
                    </template>
                    <!-- 日程 -->
                    <!-- 「table」内でv-forを使うときは「template」で囲む -->
                    <template v-for="(result,i) in disp_nittei_list" v-bind:key="i" >
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- 日程 -->
                        <tr>
                            <th>
                                <label for="">
                                    日程{{ result[0].nittei_group }}
                                </label>
                            </th>
                            <td style="text-align: left"  :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[22] == '0' ? 400 : 700 }">
                            
                              <b>開催日：</b>
                              <template v-if="result[0].kaisai_start">
                                {{DateSetting(result[0].kaisai_start)}} <span v-if="result[0].kaisai_end && result[0].kaisai_end != result[0].kaisai_start">～{{DateSetting(result[0].kaisai_end)}}</span>
                              </template>
                              <br>
                              <span  v-if="taiken_list.shubetsu == 1">
                                <span style="display:flex;align-items: center;">
                                  <div>
                                    <b>時間帯<template v-if="result.length > 1">1</template>：</b>

                                    <span v-if="result[0].jikantai_start">{{TimeSetting(result[0].jikantai_start)}} ～ {{TimeSetting(result[0].jikantai_end)}}</span>
                                    <span v-if="taiken_list.teiin_settei == 0">
                                      &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[0].teiin_mongon != '' && result[0].teiin_mongon != null">
                                          {{result[0].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[0].teiin >= 999">無し</span><span v-else-if="result[0].teiin">{{result[0].teiin}} 名まで</span>
                                        </template>
                                    </span><br> 
                                    <template v-if="result[1].nittei_group != ''">
                                       <b>時間帯2：</b>
                                      <span v-if="result[1].jikantai_start">{{TimeSetting(result[1].jikantai_start)}} ～ {{TimeSetting(result[1].jikantai_end)}}</span>
                                      <span v-if="taiken_list.teiin_settei == 0">
                                        &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[1].teiin_mongon != '' && result[1].teiin_mongon != null">
                                          {{result[1].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[1].teiin >= 999">無し</span><span v-else-if="result[1].teiin">{{result[1].teiin}} 名まで</span>
                                        </template>
                                      </span><br> 
                                    </template>
                                    <template v-if="result[2].nittei_group != ''">
                                       <b>時間帯3：</b>
                                      <span v-if="result[2].jikantai_start">{{TimeSetting(result[2].jikantai_start)}} ～ {{TimeSetting(result[2].jikantai_end)}}</span>
                                      <span v-if="taiken_list.teiin_settei == 0">
                                        &nbsp;&nbsp;<b>定員：</b>
                                        
                                        <template v-if="result[2].teiin_mongon != '' && result[2].teiin_mongon != null">
                                          {{result[2].teiin_mongon}}
                                        </template>
                                        <template v-else>
                                          <span v-if="result[2].teiin >= 999">無し</span><span v-else-if="result[2].teiin">{{result[2].teiin}} 名まで</span>
                                        </template>
                                      </span><br> 
                                    </template>
                                  </div>
                                </span>
                                <span v-if="taiken_list.shubetsu == 1">
                                  <span v-if="result[0].kaisai_youbi != null && result[0].kaisai_youbi != ''"><b>開催曜日：</b>{{youbi_irekae(result[0].kaisai_youbi)}} <br></span>
                                  <span v-if="result[0].jogai != null && result[0].jogai != ''"><b>除外曜日：</b>{{youbi_irekae(result[0].jogai)}} <br></span>
                                  <span v-if="result[0].jogai_date != null && result[0].jogai_date != ''"><b>除外日：</b>{{result[0].jogai_date}} <br></span>
                                  
                                </span>
                                <span v-if="result[0].comment != null && result[0].comment != ''"><b>コメント：</b>{{ result[0].comment }}</span>
                              </span>
                                    
                            </td>
                        </tr>
                    </template>
                    
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;" >
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝開催日から〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1"  :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken_list.shimekiri_date"  :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(taiken_list.shimekiri_date)}}</span>
                            <span v-else  :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{taiken_list.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    
                        <!-- 参加条件（対象者） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">参加条件（対象者）</label>
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                              <template v-if="taiken_list.joken_mongon != '' && taiken_list.joken_mongon != null">
                                {{taiken_list.joken_mongon }}
                              </template>
                              <template v-else-if="taiken_list.joken_all_start != null && taiken_list.joken_all_end != null">
                                {{createJokenText(taiken_list.joken_all_start,taiken_list.joken_all_end)}}
                              </template>
                              <template v-else>
                                小学生～一般
                              </template>
                            </td>
                        </tr>
                        
                    
                        <!-- 参加にあたって（参加費、検便、検温等、マスク着用、昼食、持ち物） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                        <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;" >
                              <template v-if="shosai_disp[9] == 1">
                                <span :style="{ color: shosai_color[9] ,fontWeight:shosai_bold[9] == '0' ? 400 : 700 }">
                                <b>参加費：</b>
                                  <span v-if="taiken_list.sankahi == null || taiken_list.sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{taiken_list.sankahi}}
                                  </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                <span :style="{ color: shosai_color[10] ,fontWeight:shosai_bold[10] == '0' ? 400 : 700 }">
                                <b>検温等：</b>
                                    <span v-if="taiken_list.kensa == null || taiken_list.kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{taiken_list.kensa}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                <span :style="{ color: shosai_color[17] ,fontWeight:shosai_bold[17] == '0' ? 400 : 700 }">
                                <b>検便：</b>
                                 <span v-if="taiken_list.kenben == null || taiken_list.kenben == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken_list.kenben}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <span :style="{ color: shosai_color[11] ,fontWeight:shosai_bold[11] == '0' ? 400 : 700 }">
                                <b>マスク着用：</b>
                                <span v-if="taiken_list.mask == null || taiken_list.mask == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{taiken_list.mask}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <span :style="{ color: shosai_color[12] ,fontWeight:shosai_bold[12] == '0' ? 400 : 700 }">
                                <b>昼食：</b>
                                <span v-if="taiken_list.chusyoku == null || taiken_list.chusyoku == '' || taiken_list.chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="taiken_list.chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{taiken_list.chusyoku}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (taiken_list.mochimono != null && taiken_list.mochimono != '')">
                                <br>
                                <span :style="{ color: shosai_color[13] ,fontWeight:shosai_bold[13] == '0' ? 400 : 700 }">
                                <b>持ち物：</b>
                                {{taiken_list.mochimono}}
                                </span>
                              </template>
                              <template v-if="shosai_disp[21] == 1 && (taiken_list.fukusou != null && taiken_list.fukusou != '')">
                                <br>
                                <span :style="{ color: shosai_color[21] ,fontWeight:shosai_bold[21] == '0' ? 400 : 700 }">
                                <b>服装：</b>
                                {{taiken_list.fukusou}}
                                </span>
                              </template>
                            </td>
                        </tr>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken_list.shiryo_url!=null && taiken_list.shiryo_url!='')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{taiken_list.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;" >
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken_list.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken_list.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="shosai_disp[8] == 1 && taiken_list.bikou!=null ">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- その他（特記事項） -->
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{taiken_list.bikou}}
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    </tbody>
                </table>

                
                <!--サブプログラム（活動2～）-->
                <template v-for="(result,s) in sub_list" v-bind:key="s">

                  <!-- 施設・地域活動 -->
                <table class="vy-form-table edit_komoku_area" v-if="taiken_list.shubetsu == 1"  style="margin-bottom:0px;margin-top:0px">
                   

                    <tbody v-show="KatsudouActive=='sub' + s">
                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1">
                        <tr>
                            <td colspan="2"></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ sub_list[s].naiyou }}
                            </td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[sub_list[s].hissu_flg ]}}
                          </td>
                      </tr>
                     <!-- 開催地名 -->
                     <template v-if="shosai_disp[18] == 1 && sub_list[s].k_name != null && sub_list[s].k_name != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    開催地名
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        開催地名
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[18] ,fontWeight:shosai_bold[18] == '0' ? 400 : 700 }" >
                            {{ sub_list[s].k_name }}
                            </td>
                        </tr>
                    </template>
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、開催場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        施設住所
                                    </label>
                                    <span class="balloon_parent ">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、開催場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(sub_list[s].k_jusyo)" >
                                <u :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">{{ sub_list[s].k_jusyo }}</u>
                            </td>
                        </tr>
                    </template>
                    <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && sub_list[s].k_access != null && sub_list[s].k_access != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }" >
                                {{ sub_list[s].k_access }}
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && sub_list[s].k_tel != null && sub_list[s].k_tel != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" :style="{ color: shosai_color[19] ,fontWeight:shosai_bold[19] == '0' ? 400 : 700 }">
                                <u>{{ sub_list[s].k_tel }}</u>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="sub_list[s].nittei_sentaku == 0">
                        <!-- 日程選択方法が日程ごと（nittei_sentaku == 1）であれば以下の項目は非表示 -->
                        <!-- 活動日数 -->
                        <template v-if="shosai_disp[5] == 1">
                            <tr >
                                <td colspan="2"><div class="vy-dotted"></div></td>
                            </tr>
                            <tr>
                                <th>
                                    <label for="">活動日数</label>
                                </th>
                                <td style="text-align: left" :style="{ color: shosai_color[5] ,fontWeight:shosai_bold[5] == '0' ? 400 : 700 }">
                                  
                                <template v-if="sub_list[s].nissu_mongon != '' && sub_list[s].nissu_mongon != null">
                                  {{sub_list[s].nissu_mongon}}
                                </template>
                                <template v-else>
                                    <span v-if=" sub_list[s].nissu_min == sub_list[s].nissu_max ">
                                    {{ sub_list[s].nissu_min  }}日
                                    </span>                            
                                    <span v-else-if="sub_list[s].nissu_min != sub_list[s].nissu_max ">
                                    <span v-if="sub_list[s].nissu_max == '' || sub_list[s].nissu_max == null ">
                                        {{ sub_list[s].nissu_min  }}日以上
                                    </span>
                                    <span v-else-if="sub_list[s].nissu_min == '' || sub_list[s].nissu_min == null ">
                                        {{ sub_list[s].nissu_max  }}日以下
                                    </span>
                                    <span v-else>
                                        {{sub_list[s].nissu_min}} ～ {{sub_list[s].nissu_max}}日
                                    </span>
                                    </span>&nbsp;&nbsp;
                                    <span v-if="sub_list[s].nissu_joken == 1">連続</span>
                                </template>
                                </td>
                            </tr>
                        </template>
                        
                        <template v-if="sub_list[s].teiin_settei == 1" >
                            <tr >
                                <td colspan="2"><div class="vy-dotted"></div></td>
                            </tr>
                            <tr>
                                <th>
                                    <label for="">1日の定員</label>
                                </th>
                                <td style="text-align: left" :style="{ color: shosai_color[26] ,fontWeight:shosai_bold[26] == '0' ? 400 : 700 }">
                                  
                                  <template v-if="sub_list[s].teiin_mongon != '' || sub_list[s].teiin_mongon != null">
                                    {{  sub_list[s].teiin_mongon }}
                                  
                                  </template>
                                  <template v-else>
                                    {{ sub_list[s].teiin_oneday }}&nbsp;名まで&nbsp;
                                  </template>
                                </td>
                            </tr>

                        </template>
                    </template>
                    <!-- 日程 -->
                    <!-- 「table」内でv-forを使うときは「template」で囲む -->
                    <template v-for="(result,i) in sub_disp_nittei_list[s]" v-bind:key="i" >
                      
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- 日程 -->
                        <tr>
                            <th>
                                <label for="">
                                    日程{{ result[0].nittei_group }}
                                </label>
                            </th>
                            <td style="text-align: left" :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[22] == '0' ? 400 : 700 }">
                            
                        <b>開催日：</b>
                      
                        <template v-if="result[0].kaisai_start">
                          {{DateSetting(result[0].kaisai_start)}} <span v-if="result[0].kaisai_end && result[0].kaisai_end != result[0].kaisai_start">～{{DateSetting(result[0].kaisai_end)}}</span>
                        </template>
                        <br>
                      <span  v-if="taiken_list.shubetsu == 1">
                        <span style="display:flex">
                        <div>
                          
                          <b>時間帯<template v-if="result.length > 1">1</template>：</b>
                          <span v-if="result[0].jikantai_start">{{TimeSetting(result[0].jikantai_start)}} ～ {{TimeSetting(result[0].jikantai_end)}}</span>
                          <span v-if="sub_list[s].teiin_settei == 0">
                            &nbsp;&nbsp;<b>定員：</b>
                            
                              <template v-if="result[0].teiin_mongon != '' && result[0].teiin_mongon != null">
                                {{result[0].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[0].teiin >= 999">無し</span><span v-else-if="result[0].teiin">{{result[0].teiin}} 名まで</span>
                              </template>
                          </span><br> 
                          <template v-if="result[1].nittei_group != ''">
                             <b>時間帯2：</b>
                            <span v-if="result[1].jikantai_start">{{TimeSetting(result[1].jikantai_start)}} ～ {{TimeSetting(result[1].jikantai_end)}}</span>
                            <span v-if="sub_list[s].teiin_settei == 0">
                              &nbsp;&nbsp;<b>定員：</b>
                              
                              <template v-if="result[1].teiin_mongon != '' && result[1].teiin_mongon != null">
                                {{result[1].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[1].teiin >= 999">無し</span><span v-else-if="result[1].teiin">{{result[1].teiin}} 名まで</span>
                              </template>
                            </span><br> 
                          </template>
                          <template v-if="result[2].nittei_group != ''">
                             <b>時間帯3：</b>
                            <span v-if="result[2].jikantai_start">{{TimeSetting(result[2].jikantai_start)}} ～ {{TimeSetting(result[2].jikantai_end)}}</span>
                            <span v-if="sub_list[s].teiin_settei == 0">
                              &nbsp;&nbsp;<b>定員：</b>
                              
                              <template v-if="result[2].teiin_mongon != '' && result[2].teiin_mongon != null">
                                {{result[2].teiin_mongon}}
                              </template>
                              <template v-else>
                                <span v-if="result[2].teiin >= 999">無し</span><span v-else-if="result[2].teiin">{{result[2].teiin}} 名まで</span>
                              </template>
                            </span><br> 
                          </template>
                        </div>
                        </span>
                        <span v-if="taiken_list.shubetsu == 1">
                          <span v-if="result[0].kaisai_youbi != null && result[0].kaisai_youbi != ''"><b>開催曜日：</b>{{youbi_irekae(result[0].kaisai_youbi)}} <br></span>
                          <span v-if="result[0].jogai != null && result[0].jogai != ''"><b>除外曜日：</b>{{youbi_irekae(result[0].jogai)}} <br></span>
                          <span v-if="result[0].jogai_date != null && result[0].jogai_date != ''"><b>除外日：</b>{{result[0].jogai_date}} <br></span>
                       
                        </span>
                        <span v-if="result[0].comment != null && result[0].comment != ''"><b>コメント：</b>{{ result[0].comment }}</span>
                      </span>
                                    
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝開催日から〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="sub_list[s].shimekiri_date"  :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(sub_list[s].shimekiri_date)}}</span>
                            <span v-else  :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{sub_list[s].shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    
                        <!-- 参加条件（対象者） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label for="">参加条件（対象者）</label>
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                              
                              <template v-if="sub_list[s].joken_mongon != '' && sub_list[s].joken_mongon != null">
                                {{sub_list[s].joken_mongon }}
                              </template>
                              <template v-else-if="sub_list[s].joken_all_start != null && sub_list[s].joken_all_end != null">
                                {{createJokenText(sub_list[s].joken_all_start,sub_list[s].joken_all_end)}}
                              </template>
                              <template v-else>
                                小学生～一般
                              </template>
                            </td>
                        </tr>
                        
                    
                        <!-- 参加にあたって（参加費、検便、検温等、マスク着用、昼食、持ち物） -->
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                        <tr>
                            <th>
                                <label for="">参加にあたって</label>
                            </th>
                            <td style="text-align: left;">
                              <template v-if="shosai_disp[9] == 1">
                                <span  :style="{ color: shosai_color[9] ,fontWeight:shosai_bold[9] == '0' ? 400 : 700 }">
                                <b>参加費：</b>
                                  <span v-if="sub_list[s].sankahi == null || sub_list[s].sankahi == ''">
                                      不要
                                  </span>
                                  <span v-else>
                                  {{sub_list[s].sankahi}}
                                  </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[10] == 1">
                                  <br>
                                <span  :style="{ color: shosai_color[10] ,fontWeight:shosai_bold[10] == '0' ? 400 : 700 }">
                                <b>検温等：</b>
                                    <span v-if="sub_list[s].kensa == null || sub_list[s].kensa == ''">
                                        不要
                                    </span>
                                    <span v-else>
                                    {{sub_list[s].kensa}}
                                    </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[17] == 1">
                                  <br>
                                <span  :style="{ color: shosai_color[17] ,fontWeight:shosai_bold[17] == '0' ? 400 : 700 }">
                                <b>検便：</b>
                                 <span v-if="sub_list[s].kenben == null || sub_list[s].kenben == ''">
                                    不要
                                  </span>
                                  <span v-else>
                                  {{sub_list[s].kenben}}
                                  </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[11] == 1">
                                <br>
                                <span  :style="{ color: shosai_color[11] ,fontWeight:shosai_bold[11] == '0' ? 400 : 700 }">
                                <b>マスク着用：</b>
                                <span v-if="sub_list[s].mask == null || sub_list[s].mask == ''">
                                    不要
                                </span>
                                <span v-else>
                                {{sub_list[s].mask}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[12] == 1">
                                <br>
                                <span  :style="{ color: shosai_color[12] ,fontWeight:shosai_bold[12] == '0' ? 400 : 700 }">
                                <b>昼食：</b>
                                <span v-if="sub_list[s].chusyoku == null || sub_list[s].chusyoku == '' || sub_list[s].chusyoku == '不要'">
                                    無し
                                </span>
                                <span v-else-if="sub_list[s].chusyoku == '要'">
                                    有り
                                </span>
                                <span v-else>
                                {{sub_list[s].chusyoku}}
                                </span>
                                </span>
                              </template>
                              <template v-if="shosai_disp[13] == 1 && (sub_list[s].mochimono != null && sub_list[s].mochimono != '')">
                                <br>
                                <span  :style="{ color: shosai_color[13] ,fontWeight:shosai_bold[13] == '0' ? 400 : 700 }">
                                <b>持ち物：</b>
                                {{sub_list[s].mochimono}}
                                </span>
                              </template>
                              
                              <template v-if="shosai_disp[21] == 1 && (sub_list[s].fukusou != null && sub_list[s].fukusou != '')">
                                <br>
                                <span  :style="{ color: shosai_color[21] ,fontWeight:shosai_bold[21] == '0' ? 400 : 700 }">
                                <b>服装：</b>
                                {{sub_list[s].fukusou}}
                                </span>
                              </template>
                            </td>
                        </tr>
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (sub_list[s].shiryo_url!=null && sub_list[s].shiryo_url!='')">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr >
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{sub_list[s].shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(sub_list[s].shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="sub_list[s].shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                    </template>
                    
                    <template v-if="shosai_disp[8] == 1 && sub_list[s].bikou!=null ">
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <!-- その他（特記事項） -->
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;"  :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{sub_list[s].bikou}}
                            </td>
                        </tr>
                    </template>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    </tbody>
                </table>
                </template>
                
                <!-- 制作・寄付活動 -->
                <table class="vy-form-table" v-if="taiken_list.shubetsu == 2" style="margin-bottom:0px">

                    <!-- No. プログラム名称 -->
                    <tr>
                        <th>
                            <label for=""  class="pc_only">No.：名称（施設名等） </label>
                        </th>
                        <td style="text-align: left;font-size:22px;" :style="{ color: shosai_color[2] ,fontWeight:shosai_bold[2] == '0' ? 400 : 700 }">
                            <b>{{ taiken_list.taiken_no_text }}：{{ taiken_list.name }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"><div class="vy-dotted pc_only"></div></td>
                    </tr>
                    
                    <!-- 受入先からのコメント -->
                    <template v-if="shosai_disp[6] == 1 && (taiken_list.s_comment != null && taiken_list.s_comment != '')">
                     
                        <tr >
                            <th>
                                <label for="">受入先からのコメント</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;"  :style="{ color: shosai_color[6] ,fontWeight:shosai_bold[6] == '0' ? 400 : 700 }">
                                {{taiken_list.s_comment}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>

                    <!-- 活動内容 -->
                    <template v-if="shosai_disp[3] == 1 ">
                        <tr>
                            <th>
                                <label for="">活動内容</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;" :style="{ color: shosai_color[3] ,fontWeight:shosai_bold[3] == '0' ? 400 : 700 }">
                                {{ taiken_list.naiyou }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    
                    <!-- 参加の義務 -->
                    <template v-if="sub_list.length != 0">
                      <tr>
                          <td colspan="2"><div class="vy-dotted"></div></td>
                      </tr>
                      
                      <tr>
                        <th>
                            <label for="">参加の義務</label>
                        </th>
                        <td style="text-align: left;" :style="{ color: shosai_color[27] ,fontWeight:shosai_bold[27] == '0' ? 400 : 700 }">
                          {{ hissu_list[taiken_list.hissu_flg ]}}
                          </td>
                      </tr>
                    </template>

                    
                        <!-- 施設住所 -->
                    <template v-if="shosai_disp[4] == 1 ">
                        <tr>
                            <th>

                                <label class="sp_only">
                                    施設住所
                                    <img class="q_icon " src="../../images/mark/qmark.png"  v-on:click="q_open('住所をタップすると、提出場所までの道案内を行います。<br>（Google Map等の地図アプリを利用します。）')" />
                                </label>
                                
                                <span class="pc_only">
                                    <label for="">施設住所</label>
                                    <span class="balloon_parent">
                                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                                        <span class="balloon">
                                            住所をタップすると、提出場所までの道案内を行います。<br>
                                            （Google Map等の地図アプリを利用します。）
                                        </span>
                                    </span>
                                </span>    
                            </th>
                            <td style="text-align: left;cursor:pointer" v-on:click="jusho(taiken_list.k_jusyo)" >
                                <u :style="{ color: shosai_color[4] ,fontWeight:shosai_bold[4] == '0' ? 400 : 700 }">{{ taiken_list.k_jusyo }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    
                    <!-- アクセス方法 -->
                     <template v-if="shosai_disp[20] == 1 && taiken_list.k_access != null && taiken_list.k_access != ''">
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                        <tr>
                            <th>
                                <label class="sp_only">
                                    アクセス方法
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        アクセス方法
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[20] ,fontWeight:shosai_bold[20] == '0' ? 400 : 700 }">
                            {{ taiken_list.k_access }}
                            </td>
                        </tr>
                    </template>
                     <!-- 連絡先 -->
                     <template v-if="shosai_disp[19] == 1 && taiken_list.k_tel != null && taiken_list.k_tel != ''">
                        <tr>
                            <th>
                                <label class="sp_only">
                                    連絡先
                                </label>
                                
                                <span class="pc_only">
                                    <label >
                                        連絡先
                                    </label>
                                </span>
                                
                            </th>
                            <td style="text-align: left;cursor:pointer" :style="{ color: shosai_color[19] ,fontWeight:shosai_bold[19] == '0' ? 400 : 700 }">
                                <u>{{ taiken_list.k_tel }}</u>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                    <!-- 開催期間 -->
                    <tr>
                        <th>
                            <label for="">開催期間</label>
                        </th>
                        <td style="text-align: left" :style="{ color: shosai_color[22] ,fontWeight:shosai_bold[22] == '0' ? 400 : 700 }">
                            
                            {{DateSetting(taiken_list.kaisai_start)}}
                            <span v-if="taiken_list.kaisai_end && taiken_list.kaisai_end != taiken_list.kaisai_start"> ～ {{DateSetting(taiken_list.kaisai_end)}}</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>

                    <!-- 申込〆切 -->
                    <tr>
                        <th>
                            <label for="">申込〆切</label>
                        </th>
                        <td style="text-align: left;">
                            
                            <!--
                            〆切日パターン
                            1:事業単位で〆切日を設定（end_shubetsu == 1）＝事業全体の受付〆切日
                            2:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日を設定している＝プログラムの受付〆切日
                            3:プログラム単位で〆切日を設定（end_shubetsu == 2)かつプログラムに〆切日が設定されていない＝申込日の〇日前まで申込可能
                            -->
                            <span v-if="end_shubetsu == 1" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{DateTimeSetting(end_datetime)}}</span>
                            <span v-else-if="taiken_list.shimekiri_date" :style="{ color: shosai_color[23] ,fontWeight:shosai_bold[23] == '0' ? 400 : 700 }">{{EuDateTimeSetting(taiken_list.shimekiri_date)}}</span>
                            <span v-else :style="{ color: shosai_color[16] ,fontWeight:shosai_bold[16] == '0' ? 400 : 700 }">開催日の{{taiken_list.shimekiri_nissu}}日前まで申込可能</span>
                        </td>
                    </tr>
                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    <!-- 制作・寄付活動条件 -->
                    <template v-if="shosai_disp[14] == 1 && taiken_list.seisaku_joken!=null ">
                        <tr>
                            <th>
                                <label for="seisaku_joken">制作・寄付活動条件</label>
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[14] ,fontWeight:shosai_bold[14] == '0' ? 400 : 700 }">
                                {{taiken_list.seisaku_joken}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                     
                    </template>
                    
                    <!-- 届け先 -->
                    <template v-if="shosai_disp[15] == 1 ">
                        <tr>
                            <th>
                                <label for="todokesaki">届け先</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[15] ,fontWeight:shosai_bold[15] == '0' ? 400 : 700 }">
                                {{taiken_list.todokesaki}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                    </template>

                     <!--定員（制作）-->
                      <template v-if="taiken_list.shubetsu== 2">
                        <tr>
                            <th>
                                <label for="seisaku_teiin">申込人数 / 定員</label>
                            </th>
                            <td style="text-align: left;"  :style="{ color: shosai_color[25] ,fontWeight:shosai_bold[25] == '0' ? 400 : 700 }">
                              {{jyokyo_ninzu}} 人 / {{taiken_list.seisaku_teiin}} 人
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>

                      </template>

                    <!-- 参加条件（対象者） -->
                    <tr>
                        <th>
                            <label for="">参加条件（対象者）</label>
                        </th>
                        <td style="text-align: left;"  :style="{ color: shosai_color[24] ,fontWeight:shosai_bold[24] == '0' ? 400 : 700 }">
                          
                              <template v-if="taiken_list.joken_mongon != '' && taiken_list.joken_mongon != null">
                                {{taiken_list.joken_mongon }}
                              </template>
                              <template v-else>
                                {{createJokenText(taiken_list.joken_all_start,taiken_list.joken_all_end)}}
                              </template>
                        </td>
                    </tr>

                    <tr >
                        <td colspan="2"><div class="vy-dotted"></div></td>
                    </tr>
                    
                    
                    <!-- 添付資料 -->
                    <template v-if="shosai_disp[7] == 1 && (taiken_list.shiryo_url!=null && taiken_list.shosai_disp!='')">
                        <tr v-if="taiken_list.shiryo_url!=null && taiken_list.shiryo_url!=''">
                            <th rowspan=2>
                                <label for="">添付資料</label>
                            </th>
                            <td style="text-align: left;" :style="{ color: shosai_color[7] ,fontWeight:shosai_bold[7] == '0' ? 400 : 700 }">
                                {{taiken_list.shiryo_setsumei}}
                            </td>
                        </tr>
                        <!-- 添付資料 -->
                        <tr >
                            <td style="text-align: left;">
                                
                                <u class="pc_only" style="color:red;cursor:pointer" v-on:click="shiryo_open(taiken_list.shiryo_url)">資料を閲覧する</u>
                                <a v-bind:href="taiken_list.shiryo_url" class="sp_only" style="color:red;cursor:pointer" target="_blank">資料を閲覧する</a>
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>

                    <!-- その他（特記事項） -->
                    <template v-if="shosai_disp[8] == 1 && taiken_list.bikou!=null">
                        <tr>
                            <th>
                                <label for="">その他（特記事項）</label>
                            </th>
                            <td style="text-align: left;white-space: pre-wrap;"  :style="{ color: shosai_color[8] ,fontWeight:shosai_bold[8] == '0' ? 400 : 700 }">
                                {{taiken_list.bikou}}
                            </td>
                        </tr>
                        <tr >
                            <td colspan="2"><div class="vy-dotted"></div></td>
                        </tr>
                    </template>
                </table>

            </div>
          <div v-else-if="TabActive === 'tab_list'" style="margin: 10px auto; max-width: 1300px; ">
            
                <div style="width: 100%;margin-bottom:10px;text-align: left;display: flex;align-items: center;">
                    <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                </div>
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="sub_list.length != 0">
                  <ul id="katsudou_tabMenu" class="edit_tabMenu">
                    <template v-if="KatsudouActive=='main'">
                        <li class="tabblue">活動1</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                      </template>
                      <template v-for="(result,s) in sub_list" v-bind:key="s">
                        <template v-if="KatsudouActive=='sub'+s">
                          <li class="tabblue" >活動{{s+2}}</li>
                        </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <div class="edit_komoku_area"  v-if="KatsudouActive=='main'">
                  <div id="katsudou_area" >  
                    <div>
                      <b>活動内容：</b>{{taiken_list.naiyou}}
                    </div>
                    <div>
                       <span style="margin-right:10px">
                        <b>参加の義務：</b>{{ hissu_list[taiken_list.hissu_flg ]}} 
                       </span>
                      <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                         <span style="margin-right:10px">
                        <b >開催地名：</b>{{taiken_list.k_name}}
                         </span>
                      </template>
                      <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                        <b >施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                      </template>
                    </div>
                    <div>
                        <b>申込条件：</b>
                        <template  v-if="taiken_list.nittei_sentaku == 0">
                            {{taiken_list.nissu_mongon}}
                        </template>
                        <template v-else>
                            各日程ごとの全対象日に参加が必要
                        </template>
                    </div>
                  </div>
                  <template v-if="taiken_list.nittei_sentaku == 0">
                  
                      <div id="tab" style="display: flex;justify-content: space-between;" v-if="disp_nittei_list.length > 1">
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in disp_nittei_list" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group }}</li>
                            </template>
                          </template>
                        </ul>
                      </div>
                  <template v-for="(row,i2) in moushikomi_list" v-bind:key="i2">
                    
                  <div class="edit_komoku_area" style="padding-top:10px" v-if="i2 == NitteiActive">
                  <div id="title_area">
                      <div class="list_column_header list_column_left">開催日</div>
                      <div class="list_column_header list_column_center">時間帯</div>
                      <div class="list_column_header list_column_standard">申込人数 / 定員</div>
                  </div>
                   <div v-for="(result,i) in row" v-bind:key="i" class="vy-search-result-row">

                    <div id="list_column_area">
                      <!--一番最初の日付、または前の日と別日の場合-->
                      <div class="list_column_left" style="border-top:1px solid #000 ;" v-if=" i==0 || moushikomi_list[i2][i-1].hyoji_date != result.hyoji_date  ">{{ result.hyoji_date }}({{ result.youbi }})</div>                      
                      
                      <!--前の日と同じ日の場合-->
                      <div class="list_column_left" v-else-if=" moushikomi_list[i2][i-1].hyoji_date == result.hyoji_date"></div>
                      
                      <!--時間帯（v-ifで背景色を変えているが中身は一緒なので変更するときは両方直すこと）-->

                      <!--選択済み時間帯の時-->
                      <div  class="list_column_center" v-bind:id="['set_id' + i]" v-bind:class="['set_id' + i]">
                        <!-- 参加代行の時かつ定員がオーバーしていない場合はクリック可 -->
                        <span v-if="props.param.type==2 && result.teiin > result.ninzu && result.moushikomi_flg == 0">
                          
                          <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango)" class="vy-search-result-row-a">
                           
                            <u>
                                {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                             
                            </u>
                          </a>
                        </span>
                        <!-- それ以外はクリック不可 -->
                        <span v-else>
                                {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                            
                        </span>
                      </div>
                      
                      <!--申込人数-->
                      <div class="list_column_standard" style="border-top:1px solid #000" v-if="taiken_list.teiin_settei == 0">
                        <!--定員の扱いが「時間帯ごと」の場合は時間帯ごとに人数を表示-->
                          <span >
                            <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sankasha_check(result.check_date,result.check_date,result.jikantai_start)">
                              {{ result.ninzu }}名
                            </u>
                            <span v-else>
                              {{ result.ninzu }}名
                            </span>
                          </span>
                          <span v-if="result.teiin != null"> / {{ result.teiin }}名まで</span>
                      </div>
                      <div class="list_column_standard" style="border-top:1px solid #000;" v-else-if="i==0 || (moushikomi_list[i2][i-1].hyoji_date != result.hyoji_date)">
                        
                        <span >
                            <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sankasha_check(result.check_date,result.check_date,result.jikantai_start)">
                              {{ result.ninzu }}名
                            </u>
                            <span v-else>
                              {{ result.ninzu }}名
                            </span>
                          </span>
                          <span v-if="taiken_list.teiin_oneday != null"> / {{ taiken_list.teiin_oneday }}名まで</span>
                      </div>
                      
                      <div  class="list_column_standard"  v-else></div>
                    </div>
                  </div>
                  <hr style="margin:0;border: 1px solid #000;">
                  </div>
                  </template>
                  </template>
                  <template v-else>
                    <div id="title_area">
                        <div class="list_column_header list_column_left" style="flex: 3 3 0%;">開催日</div>
                        <div class="list_column_header list_column_standard" style="flex: 1 1 0%;">申込人数 / 定員</div>
                    </div>
                    <template v-for="(result,i) in set_nittei_list" v-bind:key="i">
                      <div class="vy-search-result-row" style="display: flex;align-items: center;border:1px solid #000">
                        <div class="list_column_header list_column_left"  
                            style="flex: 3 3 0%;text-align:left;
                                            display: flex;
                                            height:auto;
                                            border:0;
                                            border-right:1px solid #000;
                                            align-items: center;
                                            justify-content: center;
                                            flex-direction: column;">
                                            <div>
                              日程：{{i+1}}<br>
                              {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                              {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                              <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                              <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                              <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                                            </div>
                          </div>

                        <div class="list_column_header list_column_standard" style="flex: 1 1 0%;border:0">
                          <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sankasha_check(result.kaisai_start,result.kaisai_end,result.jikantai_start)">{{result.ninzu}} 名</u> 
                          <template v-else>{{result.ninzu}}</template> /
                          
                          <template v-if="result.teiin >= 999">
                            定員なし
                          </template>
                          <template v-else>
                            {{result.teiin}} 名まで
                          </template>
                        </div>
                      </div>
                    </template>
                  <hr style="margin:0;border: 1px solid #000;">
                    </template>
                </div>
                <template v-if="sub_list.length !=0">
                  <template v-for="(sub,s) in sub_list" v-bind:key="s">
                  <!--活動2以降の表示-->
                  <div class="edit_komoku_area" v-if="KatsudouActive=='sub'+s">
                  <div id="katsudou_area">
                    <div>
                      <b>活動内容：</b>{{sub_list[s].naiyou}}
                    </div>
                    <div>
                       <template v-if="sub_list.length !=0">
                        <span style="margin-right:10px">
                          <b>参加の義務：</b>{{ hissu_list[sub_list[s].hissu_flg ]}} 
                        </span>
                       </template>
                      <template v-if="sub_list[s].k_name != '' && sub_list[s].k_name != null">
                         <span style="margin-right:10px"><b>開催地名：</b>{{sub_list[s].k_name}}</span>
                      </template>
                      <template v-if="sub_list[s].k_jusyo != '' && sub_list[s].k_name != null">
                         <span style="margin-right:10px"><b>施設住所：</b><u style="color:red">{{ sub_list[s].k_jusyo}}</u></span>
                      </template>
                    </div>
                    
                                <div>
                                    
                                <b>申込条件：</b>
                                <template  v-if="sub_list[s].nittei_sentaku == 0">
                                     {{sub_list[s].nissu_mongon}}
                                </template>
                                <template v-else>
                                    各日程ごとの全対象日に参加が必要
                                </template>
                                </div>
                  </div>
                  <template v-if="sub_list[s].nittei_sentaku == 0">
                     <div id="tab" style="display: flex;justify-content: space-between;"  v-if="sub_disp_nittei_list[s].length > 1">
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in sub_disp_nittei_list[s]" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group }}</li>
                            </template>
                          </template>
                        </ul>
                      </div>
                      
                  <template v-for="(row,i2) in moushikomi_list_sub[s]" v-bind:key="i2">

                    <div class="edit_komoku_area" style="padding-top:10px" v-if="i2 == NitteiActive">
                    <div id="title_area">
                        <div class="list_column_header list_column_left">開催日</div>
                        <div class="list_column_header list_column_center">時間帯</div>
                        <div class="list_column_header list_column_standard">申込人数 / 定員</div>
                    </div>
                    <div v-for="(result,i) in row" v-bind:key="i" class="vy-search-result-row">

                      <div id="list_column_area">
                        <!--一番最初の日付、または前の日と別日の場合-->
                        <div class="list_column_left" style="border-top:1px solid #000 ;" v-if=" i==0 || moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date  ">{{ result.hyoji_date }}({{ result.youbi }})</div>                      
                        
                        <!--前の日と同じ日の場合-->
                        <div class="list_column_left" v-else-if="moushikomi_list_sub[s][i2][i-1].hyoji_date == result.hyoji_date"></div>
                        
                        <!--時間帯（v-ifで背景色を変えているが中身は一緒なので変更するときは両方直すこと）-->

                        <!--選択済み時間帯の時-->
                        <div  class="list_column_center" v-bind:id="['set_id' + i]" v-bind:class="['set_id' + i]">
                          <!-- 参加代行の時かつ定員がオーバーしていない場合はクリック可 -->
                          <span v-if="props.param.type==2 && result.teiin > result.ninzu && result.moushikomi_flg == 0">
                            
                            <a href="#" v-on:click.prevent.stop="Set_id(result.check_date,result.jikantai_start,result.jikantai_end,i,1,result.date_bango)" class="vy-search-result-row-a">
                            
                              <u>
                                  {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                              
                              </u>
                            </a>
                          </span>
                          <!-- それ以外はクリック不可 -->
                          <span v-else>
                                  {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                              
                          </span>
                        </div>
                        
                        <!--申込人数-->
                        <div class="list_column_standard" style="border-top:1px solid #000" v-if="sub_list[s].teiin_settei == 0">
                          <!--定員の扱いが「時間帯ごと」の場合は時間帯ごとに人数を表示-->
                            <span >
                              <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sub_Sankasha_check(result.check_date,result.check_date,result.jikantai_start,s)">
                                {{ result.ninzu }}名
                              </u>
                              <span v-else>
                                {{ result.ninzu }}名
                              </span>
                            </span>
                            <span v-if="result.teiin != null"> / {{ result.teiin }}名まで</span>
                        </div>
                        <div class="list_column_standard"  style="border-top:1px solid #000;" v-else-if="i==0 || (moushikomi_list_sub[s][i2][i-1].hyoji_date != result.hyoji_date)">
                          <span >
                              <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sub_Sankasha_check(result.check_date,result.check_date,result.jikantai_start,s)">
                                {{ result.ninzu }}名
                              </u>
                              <span v-else>
                                {{ result.ninzu }}名
                              </span>
                            </span>
                            <span v-if="sub_list[s].teiin_oneday != null"> / {{ sub_list[s].teiin_oneday }}名まで</span>
                        </div>
                        
                        <div  class="list_column_standard"  v-else></div>
                      </div>
                    </div>
                    <hr style="margin:0;border: 1px solid #000;">
                    </div>
                  </template>
                  </template>
                  <template v-else>
                    <div id="title_area">
                        <div class="list_column_header list_column_left" style="flex: 3 3 0%;">開催日</div>
                        <div class="list_column_header list_column_standard" style="flex: 1 1 0%;">申込人数 / 定員</div>
                    </div>
                    <template v-for="(result,i) in sub_set_nittei_list[s]" v-bind:key="i">
                      <div class="vy-search-result-row" style="display: flex;align-items: center;">
                        <div class="list_column_header list_column_left"  style="flex: 3 3 0%;text-align:left;
                                            height:auto;
                                            border:0;
                                            border-right:1px solid #000;
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            flex-direction: column;">
                              <div>
                                日程：{{i+1}}<br>
                                {{DateSetting(result.kaisai_start)}}～ {{DateSetting(result.kaisai_end)}}<br>
                                {{TimeSetting(result.jikantai_start)}} ～ {{TimeSetting(result.jikantai_end)}}
                                <span v-if="(result.kaisai_youbi != null)"><br><b>開催曜日：</b>{{youbi_irekae(result.kaisai_youbi)}} </span>
                                <span v-if="(result.jogai != null)"><br><b>除外曜日：</b>{{youbi_irekae(result.jogai)}}</span>
                                <span v-if="(result.jogai_date != null)"><br><b>除外日：</b>{{result.jogai_date}} </span>
                              </div>
                        </div>

                        <div class="list_column_header list_column_standard" style="flex: 1 1 0%;border:0;">
                          <u v-if="result.ninzu != 0" style="cursor: pointer;" v-on:click="Sub_Sankasha_check(result.kaisai_start,result.kaisai_end,result.jikantai_start,s)">{{result.ninzu}} 名</u> 
                          <template v-else>{{result.ninzu}}名 </template> / 
                          <template v-if="result.teiin >= 999">
                            定員なし
                          </template>
                          <template v-else>
                            {{result.teiin}} 名まで
                          </template>
                        </div>
                      </div>
                    </template>
                  <hr style="margin:0;border: 1px solid #000;">
                  
                    </template>
                  </div>
                </template>
            </template>

          </div>
          <div v-else-if="TabActive === 'tab_calendar'" >
            
                <div style="width: 100%;text-align: left;padding-top: 10px;margin-bottom:10px;display: flex;align-items: center;">
                    <span style="font-size:20px;color:#030ba0"><b>{{ taiken_list.taiken_no_text  }}：{{ taiken_list.name  }}</b></span>
                </div>
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="sub_list.length != 0">
                  <ul id="katsudou_tabMenu" class="edit_tabMenu">
                    <template v-if="KatsudouActive=='main'">
                        <li class="tabblue">活動1</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
                      </template>
                      <template v-for="(result,s) in sub_list" v-bind:key="s">
                        <template v-if="KatsudouActive=='sub'+s">
                          <li class="tabblue" >活動{{s+2}}</li>
                        </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <div class="edit_komoku_area" v-if="KatsudouActive=='main'">
                  <div id="katsudou_area">  
                    <div>
                      <b>活動内容：</b>{{taiken_list.naiyou}}
                    </div>
                    <div>
                      <template v-if="sub_list.length !=0">
                        <span style="margin-right:10px">
                        <b>参加の義務：</b>{{ hissu_list[taiken_list.hissu_flg ]}} 
                        </span>
                      </template>
                      <template v-if="taiken_list.k_name != '' && taiken_list.k_name != null">
                        <span style="margin-right:10px">
                        <b >開催地名：</b>
                        {{taiken_list.k_name}}
                        </span>
                      </template>
                      <template v-if="taiken_list.k_jusyo != '' && taiken_list.k_jusyo != null">
                        <b >施設住所：</b><u style="color:red">{{ taiken_list.k_jusyo}}</u>
                      </template>
                    </div>
                    
                    <div >
                     <b>申込条件：</b>
                     <template v-if="taiken_list.nittei_sentaku == 0">{{taiken_list.nissu_mongon}}</template>
                      <template v-else>
                        各日程ごとの全対象日に参加が必要
                     </template>
                    </div>
                  </div>
                  
                      <div id="tab" style="display: flex;justify-content: space-between;" v-if="disp_nittei_list.length > 1">
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in disp_nittei_list" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group }}</li>
                            </template>
                          </template>
                        </ul>
                      </div>
                  <div id="calendar_area" class="edit_komoku_area" v-html="Calendar" v-on:click="htmlColumnClick">

                  </div>
                </div>
                  
                <div class="edit_komoku_area" v-else>
                  
                  <div id="katsudou_area">  
                    <div>
                      <b>活動内容：</b>{{sub_list[KatsudouActive_no].naiyou}}
                    </div>
                    <div>
                      <template v-if="sub_list.length !=0">
                        <span style="margin-right:10px">
                        <b>参加の義務：</b>{{ hissu_list[sub_list[KatsudouActive_no].hissu_flg ]}} 
                        </span>
                      </template>
                      <template v-if="sub_list[KatsudouActive_no].k_name != '' && sub_list[KatsudouActive_no].k_name != null">
                        <span style="margin-right:10px">
                        <b >開催地名：</b>
                        {{sub_list[KatsudouActive_no].k_name}}
                        </span>
                      </template>
                      <template v-if="sub_list[KatsudouActive_no].k_jusyo != '' && sub_list[KatsudouActive_no].k_jusyo != null">
                        <b >施設住所：</b><u style="color:red">{{ sub_list[KatsudouActive_no].k_jusyo}}</u>
                      </template>
                    </div>
                    
                    <div>
                     <b>申込条件：</b>
                     <template  v-if="sub_list[KatsudouActive_no].nittei_sentaku == 0">
                     {{sub_list[KatsudouActive_no].nissu_mongon}}
                     </template>
                        <template v-else>
                        各日程ごとの全対象日に参加が必要
                     </template>
                    </div>
                  </div>
                  <div id="tab" style="display: flex;justify-content: space-between;" v-if="sub_disp_nittei_list[KatsudouActive_no].length > 1">
                        <ul id="nittei_tabMenu" class="edit_tabMenu">
                          <template v-for="(result,i3) in sub_disp_nittei_list[KatsudouActive_no]" v-bind:key="i3">
                            <template v-if="NitteiActive == i3">
                              <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                            </template>
                            <template v-else>
                              <li class="tabgray" v-on:click="Change_nittei(i3)">日程：{{ result[0].nittei_group }}</li>
                            </template>
                          </template>
                        </ul>
                      </div>
                  <div id="calendar_area" class="edit_komoku_area" v-html="Calendar_sub" v-on:click="sub_htmlColumnClick">

                  </div>
                </div>
            </div>
        </div>
      </span>

      <div v-if="mode == 0 && delete_disp == true" style="width:100%;text-align:right" >
        <button class="btn btn-primary mx-aut" style="width: 210px; height: 50px;padding: 0;background-color: red;color:white"  v-on:click="Delete_check()">このプログラムを削除する</button>
      </div>


      <!-- 編集モード -->
      <!-- 必須項目を含むエリアは「Form」で囲む -->
      <Form @submit="Update_check" @invalid-submit="InvalidSubmit" :validation-schema="schema" v-if="mode == 1">
        <br clear="all" v-if="type==0">
        <div id="tab">
          <ul class="edit_tabMenu">
            <li class="tabblue" style="width:100%">共通項目</li>
          </ul>
        </div>
        <div class="edit_komoku_area">
        <table class="vy-form-table">
          <!-- プログラムNo. -->
          <tr>
            <th>
                <label for="">プログラムNo.</label>
                  
                <span class="balloon_parent">
                <img class="q_icon" src="../../images/mark/qmark.png"  />
                <span class="balloon" >
                  プログラムNo.が未入力の場合、自動でNo.を附番します。
                </span>
              </span>
            </th>
            <td style="text-align: left;">
                <input type="text" class="form-control enter_forcus" id="taiken_no_text" name="taiken_no_text" 
                style="width:100px" v-on:change="Henshu_check(),Background_change('taiken_no_text')"
                    v-model="taiken_list.taiken_no_text"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
              </td>
          </tr>
        <!--プログラム種別-->
        <tr >
            <td colspan="2"><div class="vy-dotted"></div></td>
        </tr>
        <tr >
          <th >
              <label for="">プログラム種別</label>
              <span class="balloon_parent">
              <img class="q_icon" src="../../images/mark/qmark.png"  />
              <span class="balloon" >
                選択した種別に応じて選べる「分類１」が切り替わります。
              </span>
            </span>
          </th>
          <td style="text-align: left;">
            
            <select class="form-select enter_forcus" v-model="taiken_list.shubetsu" v-on:change="shubetsu_change(),change_seisaku(),Henshu_check()">
              <option v-if="shubetsu_list[i]!='（未設定）'" v-for:="i in shubetsu_list.length-1" v-bind:value="i">{{ shubetsu_list[i] }}</option>
            </select>
          </td>
        </tr>
          <!-- 分類１ -->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
                <label for="">分類１<span class="vy-required" >（必須）</span></label>
                <span class="balloon_parent">
              <img class="q_icon" src="../../images/mark/qmark.png"  />
              <span class="balloon" >
                選択した分類１に応じて選べる「分類２」が切り替わります。
              </span>
            </span>
            </th>
            <td style="text-align: left;">
              
                <div class="form-group">

                  <Field as="select" name="bunrui1"   id="bunrui1" v-model="taiken_list.bunrui1"  style="height:30px"
                   @keydown.enter.exact.prevent
                    v-on:change="bunrui1_change(),Henshu_check()" 
                    @keyup.enter.prevent="moveNext">
                    <option v-for:="(bunrui1_row,i) in bunrui1_list" v-bind:value="bunrui1_row">{{i+1}}．{{ bunrui1_row }}</option>
                  </Field>

                  <!--                <input type="button" v-on:click="bunrui1_set(),Background_change('bunrui1')" value="選択">-->
                </div>
                <!--
                  <Field type="text" class="form-control enter_forcus" id="bunrui1" name="bunrui1" 
                  placeholder="分類1をプルダウンメニューから選択するか、こちらに入力してください。"
                  v-model="taiken_list.bunrui1" v-on:change="Henshu_check(),Background_change('bunrui1')"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext" maxlength="100"/>-->
                  <!-- エラーメッセージ -->
                  <span class="error"><ErrorMessage name="bunrui1" /></span>
            </td>
          </tr>
          <!-- 分類２ -->
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.bunrui2 != null && taiken_list.bunrui2 != '')">
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.bunrui2 != null && taiken_list.bunrui2 != '')">
            <th>
                <label for="">分類２</label>
            </th>
            <td style="text-align: left;">
              
                <div class="form-group">
                  <select class="enter_forcus" v-model="taiken_list.bunrui2" style="height:30px" v-on:change="Henshu_check()">
                    <option value="">なし</option>
                    <option v-for:="(bunrui2_row,i) in bunrui2_list_Extract" v-bind:value="bunrui2_row">{{i+1}}．{{ bunrui2_row }}</option>
                  </select>
                  <!--<input type="button" v-on:click="bunrui2_set()" value="選択"> -->
                  
                </div>
                <!--
                  <input type="text" class="form-control enter_forcus" id="bunrui2" name="bunrui2" 
                  placeholder="分類2をプルダウンメニューから選択するか、こちらに入力してください。" v-model="taiken_list.bunrui2" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext" maxlength="100"/>-->
              </td>
          </tr><tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="" id="shomeisho">証明書</label>
                <span class="balloon_parent">
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                  <span class="balloon" >
                    「参加証明書情報」で作成した証明書を設定します。<br>
                    「なし」に設定すると、このプログラムでは証明書を発行できなくなります。
                  </span>
                </span>
            </th>
            <td style="text-align: left;">
              
            <select class="enter_forcus" v-model="taiken_list.shomeisho" id="shomeisho" name="shomeisho" v-on:change="Henshu_check()"
                    style="height:30px;">
                  <option value="0">なし</option>
                  
                  <template v-for="(shomei,i) in shomei_list" v-bind:key="i">
                    <option v-bind:value="shomei.no">{{shomei.no}}：{{ shomei.name }}</option>
                  </template>
                </select>
                <template v-if="taiken_list.shomeisho != 0 && type == 1">
                  <!--証明書「なし」以外、かつ、編集時のみ表示-->
                  <input type="button" value="プレビュー" v-on:click="ShomeiPreview()" style="height:30px">
                </template>
            </td>
          </tr>
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="" id="google_form">報告書番号</label>
                <span class="balloon_parent">
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                  <span class="balloon" >
                    「アンケート・報告書情報」で作成した報告書を設定します。<br>
                    「なし」に設定すると、このプログラムでは報告書の提出ができなくなります。
                  </span>
                </span>
                
            </th>
            <td style="text-align: left;">
              
            <select class="enter_forcus" v-model="taiken_list.google_form" id="google_form" name="google_form" v-on:change="Henshu_check()"
                    style="height:30px;width:70px;text-align:center">
                    <option value="0">なし</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
            </td>
          </tr>
           <!--プログラム名称 -->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
                <label for="">プログラム名称（施設名）<span class="vy-required" >（必須）</span></label>
            </th>
            <td style="text-align: left;">
              
                <Field type="text" class="form-control enter_forcus" id="name" name="name" 
                v-on:change="Henshu_check(),Background_change('name')"
                    v-model="taiken_list.name"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
                  <!-- エラーメッセージ -->
                  <span class="error"><ErrorMessage name="name" /></span>
              </td>
          </tr>
           <!--タイトル画像 -->
           <!--
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
                <label for="">タイトル画像<input type="button" @click="imgDelete" value="削除" style="margin-left:10px" v-if="taiken_list.title_image"><br>
                 <input type='file' id="img_file" @change="imgUpload" accept="image/*" style="margin-top:10px"/></label>
            </th>
            <td style="text-align: left;">
              <img v-if="taiken_list.title_image" v-bind:src="taiken_list.title_image" style="max-width:100%">
              <template v-else>
                画像がアップロードされていません。
              </template>
              </td>
          </tr>
          -->
           <!--受入先選択 -->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
                <label for="" >受入先選択</label><br>
                <img src="../../images/facility_set.png"  v-on:click="Facility_select()" style="cursor:pointer">&nbsp;&nbsp;
                <span v-if="facility_name != ''"> 
                  <img src="../../images/delete.png"  v-on:click="Facility_delete()" style="cursor:pointer">
                </span>
            </th>
            <td style="text-align: left;">
               <input type="text" class="form-control" id="facility_name" name="facility_name" 
                    v-model="facility_name"
                    readonly=readonly maxlength="100"/>
            </td>
          </tr>
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th>
                <label for="">受入先情報の申込者表示</label>
            </th>
            <td style="text-align: left;">
              <div  style="text-align: left;display: flex;align-items: center;height:40px">
                <div class="form-check form-check-inline" style="height:100%;display: flex;align-items: center;">
                  <input type="radio" class="form-check-input enter_forcus" style="margin-top: 0;margin-right: 10px;"
                   id="s_disp1" name="s_disp" :value="0" v-model="taiken_list.s_disp" @keydown.enter.exact.prevent
                  v-on:change="Henshu_check()"
                      @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="s_disp1">表示する</label>
                </div>
                <div class="form-check form-check-inline" style="height:100%;display: flex;align-items: center;">
                  <input type="radio" class="form-check-input enter_forcus" style="margin-top: 0;margin-right: 10px;"
                   id="s_disp2" name="s_disp" :value="1" v-model="taiken_list.s_disp"  @keydown.enter.exact.prevent
                  v-on:change="Henshu_check()"
                      @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="s_disp2">表示しない</label>
                </div>
              </div>
            </td>
          </tr>
          <template v-if="taiken_list.s_disp == 0">
              <!--受入先情報 -->
          <tr >
              
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr >
            <th >
                <label for="">受入先情報</label><br>
                
            <span style="color:red">※申込者（マイページ）のみに表示されます。</span>
            </th>
            <td >
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_name != null && taiken_list.s_name != '')">
                  <b>表示名称</b>
                <input type="text" class="form-control enter_forcus" id="s_name" name="s_name"  v-on:change="Henshu_check()"
                    v-model="taiken_list.s_name"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
              </div>

              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_jusyo != nulll && taiken_list.s_jusyo != '')">
                    
                <b>住所</b> 
                <input type="text" class="form-control enter_forcus" id="s_jusyo" name="s_jusyo"  v-on:change="Henshu_check()"
                    v-model="taiken_list.s_jusyo"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
                
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_tel != null && taiken_list.s_tel != '')">
                
                <b>TEL</b>
                <input type="tel" class="form-control enter_forcus" id="s_tel" name="s_tel"  v-on:change="Henshu_check()"
                  placeholder="0492123456" maxlength="11" v-model="taiken_list.s_tel"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_fax != null && taiken_list.s_fax != '')">
                <b>FAX</b>
                <input type="tel" class="form-control enter_forcus" id="s_fax" name="s_fax"  v-on:change="Henshu_check()"
                  placeholder="0492123456" maxlength="11" v-model="taiken_list.s_fax"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_email != null && taiken_list.s_email != '')">
                <b>E-Mail</b>
                <input type="text" class="form-control enter_forcus" id="s_email" name="s_email"  v-on:change="Henshu_check()"
                    v-model="taiken_list.s_email"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_tantou != null && taiken_list.s_tantou != '')">
                <b>担当者</b>
                <input type="text" class="form-control enter_forcus" id="s_tantou" name="s_tantou"  v-on:change="Henshu_check()"
                    v-model="taiken_list.s_tantou"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext" maxlength="100"/>
              </div>
              
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.s_bikou != null && taiken_list.s_bikou != '')">
                <b>その他の情報</b>
              <textarea class="form-control enter_forcus" id="s_bikou" name="s_bikou" rows="3" v-model="taiken_list.s_bikou" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="moveNext"
                  @keydown.enter.alt.exact="NewLine_s_bikou" maxlength="5000"></textarea>
              </div>
            </td>
          </tr>
          </template>
          <!--受入先からのコメント-->
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.s_comment != null && taiken_list.s_comment != '')">
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.s_comment != null && taiken_list.s_comment != '')">
            <th >
                <label for="">受入先からのコメント</label>
            </th>
            
            <td style="text-align: left;">
              <div style="text-align: left;">
                  <textarea class="form-control enter_forcus" id="s_comment" name="s_comment" rows="3" v-model="taiken_list.s_comment" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="moveNext"
                  @keydown.enter.alt.exact="NewLine_ukeire" maxlength="5000"></textarea>
                      <span class="by-sub">※改行は「alt + Enter」で行います。</span>
              </div>
            </td>
          </tr>
          
          
          <!-- 施設・地域専用項目-->
          <template v-if="taiken_list.shubetsu == 1">
            
          <!-- 全体の定員（施設・地域）-->
          <tr >
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr style="height:50px;">
            <th >
                <label for="">プログラム申込者数の制限</label>
                <span class="balloon_parent" >
                   <img class="q_icon" src="../../images/mark/qmark.png"  />
                   <span class="balloon"  >
                     プログラム申込者数の制限を利用する場合、日程の定員に関わらず、この定員数に達すると申し込めなくなります。
                   </span>
                </span>
            </th>
            <td>
              <div  style="text-align: left;display: flex;align-items: center;height:40px">
                <div class="form-check form-check-inline" style="height:100%;display: flex;align-items: center;">
                  <Field type="radio" class="form-check-input enter_forcus" style="margin-top: 0;margin-right: 10px;"
                   id="radio1" name="all_teiin_flg" :value="0" v-model="taiken_list.all_teiin_flg" @keydown.enter.exact.prevent
                  v-on:change="Henshu_check()"
                      @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="radio1">利用しない</label>
                </div>
                <div class="form-check form-check-inline" style="height:100%;display: flex;align-items: center;">
                  <Field type="radio" class="form-check-input enter_forcus" style="margin-top: 0;margin-right: 10px;"
                   id="radio2" name="all_teiin_flg" :value="1" v-model="taiken_list.all_teiin_flg"  @keydown.enter.exact.prevent
                  v-on:change="Henshu_check()"
                      @keyup.enter.prevent="moveNext"/>
                  <label class="form-check-label" for="radio2">利用する</label>
                </div>
                <template v-if="taiken_list.all_teiin_flg == 1">
                最大申込者数：
                <Field type="number" size="3" style="width:75px;text-align: center;" class="form-control enter_forcus" id="all_teiin" name="all_teiin"
                  v-on:change="nittei_sanka_check(),Background_change('all_teiin')"
                   v-model="taiken_list.seisaku_teiin"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>&nbsp;人&nbsp;
                </template>
              </div>
            </td>
          </tr>
          </template>

          <!-- 制作・寄付専用項目-->
          <template v-if="taiken_list.shubetsu== 2">
          <!-- 制作・寄付活動条件-->
          <tr >
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="taiken_list.shubetsu== 2">
            <th >
                <label for="">制作・寄付活動条件</label>
            </th>
            <td style="text-align: left;">
              
              <input type="text" class="form-control enter_forcus" id="seisaku_joken" name="seisaku_joken"  v-on:change="nittei_sanka_check()"
                  v-model="taiken_list.seisaku_joken"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                  
              </td>
          </tr>
          
          <!--届け先-->
          
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr >
            <th >
                <label for="">届け先<span class="vy-required" >（必須）</span></label>
            </th>
            <td style="text-align: left;">
              <Field type="text" class="form-control enter_forcus" id="todokesaki" name="todokesaki"
              v-on:change="Henshu_check(),Background_change('todokesaki')"
                   v-model="taiken_list.todokesaki"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                <span class="error"><ErrorMessage name="todokesaki" /></span>
              </td>
          </tr>
          
          <!--定員（制作）-->
          
          <tr >
            <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="">定員<span class="vy-required" >（必須）</span></label>
                <span class="balloon_parent" >
                             <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="min-width:300px" >
                              プログラム全体の定員を入力します。
                              </span>
                        </span>
            </th>
            <td style="text-align: left;display: flex;align-items: center;">
              <Field type="number" size="3" style="width:75px;text-align: center;" class="form-control enter_forcus" id="seisaku_teiin" name="seisaku_teiin"
              v-on:change="nittei_sanka_check(),Background_change('seisaku_teiin')"
                   v-model="taiken_list.seisaku_teiin"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>&nbsp;人&nbsp;
                <span class="error"><ErrorMessage name="seisaku_teiin" /></span>
              </td>
          </tr>
          </template>

          </table>

          </div>
          <div id="tab" style="display: flex;justify-content: space-between;">
            <ul id="katsudou_tabMenu" class="edit_tabMenu">

              <template v-if="KatsudouActive=='main'">
                <li class="tabblue">活動1</li>
              </template>
              <template v-else>
                <li class="tabgray" v-on:click="Change_katsudou(9999)" >活動1</li>
              </template>
                  <template v-for="(result,s) in sub_list" v-bind:key="s">
                    <template v-if="KatsudouActive=='sub'+s">
                      <li class="tabblue" >活動{{s+2}}</li>
                    </template>
                    <template v-else>
                      <li class="tabgray" v-on:click="Change_katsudou(s)" >活動{{s+2}}</li>
                    </template>
                  </template>
            </ul>
            <input type="button" style="margin-left:10px" value="活動を追加" v-on:click="katsudou_add()" v-if="taiken_list.shubetsu == 1">
          </div>
          <div class="edit_komoku_area">
          <table class="vy-form-table">
            <tbody v-show="KatsudouActive=='main'">

              <template v-if="sub_list.length != 0">
                <!-- 参加の義務（活動2以降がある場合） -->
                <tr>
                  <th>
                      <label for="">参加の義務<span class="vy-required" >（必須）</span></label>
                  </th>
                  <td style="text-align: left;">
                    
                    <select class="enter_forcus" v-model="taiken_list.hissu_flg" id="hissu_flg" name="hissu_flg" v-on:change="Henshu_check()"
                            style="height:30px;width:70px;text-align:center">
                            <option value="0">{{ hissu_list[0] }}</option>
                            <option value="1">{{ hissu_list[1] }}</option>
                            <option value="2">{{ hissu_list[2] }}</option>
                      </select>
                    </td>
                </tr>
                <tr>
                    <td colspan="2"><div class="vy-dotted"></div></td>
                </tr>
              </template>
           <!-- 活動内容 -->
          <tr>
            <th >
                <label for="">活動内容<span class="vy-required" >（必須）</span></label><br>
            </th>
            <td style="text-align: left;">
              
              <Field as="textarea" class="form-control enter_forcus" id="naiyou" name="naiyou" rows="3" v-model="taiken_list.naiyou"
              v-on:change="Henshu_check(),Background_change('naiyou')"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="moveNext"
                  @keydown.enter.alt.exact="NewLine_naiyou(9999)" maxlength="5000"></Field>
                <span class="by-sub">※改行は「alt + Enter」で行います。<br></span>
                <span class="error"><ErrorMessage name="naiyou" /></span>

              </td>
          </tr>
           <!--開催場所 -->
           <tr >
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="">開催場所</label>
                
                <span class="balloon_parent">
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                  <span class="balloon" >
                    プログラム種別が「施設・地域」の場合は「活動を行う会場」、<br>「制作・寄付」の場合は「寄付品をお届けする場所」となります。
                  </span>
                </span>
                
            </th>
            <td>
            <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.k_name != null && taiken_list.k_name != '')">
                <b>開催地名</b>
                <input type="text" class="form-control enter_forcus" id="k_name" name="k_name" 
                v-on:change="Henshu_check()"
                  v-model="taiken_list.k_name"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
            </div>
            <div style="text-align: left;">
                <b>住所<span class="vy-required" >（必須）</span></b>
                
                <Field type="text" class="form-control enter_forcus" id="k_jusyo" name="k_jusyo" 
                  v-on:change="Henshu_check(),Background_change('k_jusyo')"
                  v-model="taiken_list.k_jusyo"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                  
                  <span class="error"><ErrorMessage name="k_jusyo" /></span>
            </div>
            <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.k_access != null && taiken_list.k_access != '')">
                <b>アクセス方法</b>
                <input type="text" class="form-control enter_forcus" id="k_access" name="k_access"  v-on:change="Henshu_check()"
                  v-model="taiken_list.k_access"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
            </div>
            <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && taiken_list.k_tel != null && taiken_list.k_tel != '')">
                <b>連絡先</b>
                <input type="tel" class="form-control enter_forcus" id="k_tel" name="k_tel"  v-on:change="Henshu_check()"
                  placeholder="0492123456" maxlength="11" v-model="taiken_list.k_tel"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
            </div>
            </td>
          </tr>
          

          
          <!--申込〆切日時（HOMEの受付〆切日の種別が2の時のみ表示）-->
          <template v-if="end_shubetsu == 2">
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="">申込〆切日時</label>
                <span class="balloon_parent">
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="min-width:350px;" >
                      申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。
                    </span>
                  </span>
            </th>
            <td style="text-align: left;">
              <div style="display:flex">
                <Field type="date" class="form-control enter_forcus" id="shimekiri_day" name="shimekiri_day" v-on:change="Henshu_check(),Background_change('shimekiri_day')"
                  v-model="shimekiri_day"
                  style="width:150px"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
                  
                <Field type="time" class="form-control enter_forcus" id="shimekiri_time" name="shimekiri_time"  v-on:change="Henshu_check(),Background_change('shimekiri_time')"
                  v-model="shimekiri_time"
                  style="width:100px"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
              </div>
            </td>
          </tr>
        <!--申込〆切日数-->
        <tr v-if="taiken_list.shubetsu== 1">
          <th >
              <label for="">申込〆切日数</label>
              
              <span class="balloon_parent">
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="min-width:350px">
                    申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。
                    </span>
                  </span>
          </th>
          <td style="text-align: left;">
            
            <div style="display: flex;align-items: center;">
              開催日の<Field type="number" size="2" min="1" v-on:change="Henshu_check(),Background_change('shimekiri_nissu')"
                      class="form-control enter_forcus" id="shimekiri_nissu" name="shimekiri_nissu" 
                      v-model="taiken_list.shimekiri_nissu"
                      style="width:80px;text-align: center;margin:0 5px;"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>日前まで申込み可能
            </div>
          </td>
        </tr>
      </template>

          <template v-if="taiken_list.shubetsu == 1">
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
           <tr>
            <th >
                <label for="" id="nittei_henshu">体験者の日程ごとの申込方法
                  <span class="vy-required" >（必須）</span>
                </label>
            </th>
            <td>
              <select class="form-select enter_forcus" v-model="taiken_list.nittei_sentaku" 
                  v-on:change="nittei_sentaku_change(9999)" style="width: auto;" >
                            <option value="0">活動条件で申込</option>
                            <option value="1">設定日全て申込</option>
                  </select>
            </td>
          </tr>
          <!--活動条件-->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
           <tr>
            <th >
                <label for="" id="nittei_henshu">活動条件
                  <span class="vy-required" >（必須）</span>
                </label>
            </th>
            <td>

                <div class="joken_div" style="margin:0">
                </div>
                <template v-if="taiken_list.nittei_sentaku == 0">
                    
                  <div class="joken_div">
                    <b>活動日数：</b>
                    <input type="number" size="2" 
                        class="form-control  enter_forcus" id="nissu_min" name="nissu_min" 
                        v-model="taiken_list.nissu_min"
                        v-on:change="nissu_change(9999)"
                        style="width:70px;text-align: center;"/>
                        &nbsp;～&nbsp;
                    <input type="number" size="2" 
                        class="form-control  enter_forcus" id="nissu_max" name="nissu_max" 
                        v-model="taiken_list.nissu_max"
                        v-on:change="nissu_change(9999)"
                        style="width:70px;text-align: center;"/>&nbsp;日&nbsp;
                  </div>
                  <div class="joken_div" >
                    <b>連続日参加義務：</b>
                    <input type="checkbox" style="width:23px;height:23px" v-model="taiken_list.nissu_joken" v-on:change="nissu_change(9999)" :true-value="1" :false-value="2">
                    
                    <template v-if="taiken_list.nissu_joken == 1">
                       &nbsp;&nbsp;&nbsp;&nbsp;<b>除外日・除外曜日の飛ばし：</b>
                       <select class="form-select enter_forcus" v-model="taiken_list.nissu_jogai" style="width:auto"
                        v-on:change="nissu_change(9999)">
                      <option value="true">可</option>
                      <option value="false">不可</option>
                    </select>&nbsp;
                    </template>
                  </div>
                  <div class="joken_div">
                    <b>活動日数の表示文：</b>
                    <input type="text" class="form-control  enter_forcus" id="nissu_mongon" name="nissu_mongon" 
                        v-model="taiken_list.nissu_mongon"
                        style="width:500px;text-align: left;"/>
                  </div>

                  <div class="joken_div">
                  <b>定員割当：</b>
                  <select class="form-select enter_forcus" 
                      v-on:change="teiin_settei_change(9999)"
                      v-model="taiken_list.teiin_settei" style="width: auto;">
                        <option value="0">時間帯ごとに割当</option>
                        <option value="1">1日単位で割当</option>
                      </select>&nbsp;&nbsp;

                      <span v-if="taiken_list.teiin_settei == 1" style="display: flex;align-items: center;">
                        <b>1日の定員：</b>
                        <input type="number" size="2" 
                            class="form-control enter_forcus" id="teiin_oneday" name="teiin_oneday" 
                            v-model="taiken_list.teiin_oneday"
                            v-on:change="teiin_oneday_change(9999)"
                            style="width:75px;text-align: center;"/>&nbsp;人&nbsp;
                      </span>
                  </div>
                  <div  class="joken_div" v-if="taiken_list.teiin_settei == 1">
                    <b>定員割当の表示文：</b>
                        <input type="text" 
                            class="form-control enter_forcus" id="teiin_mongon" name="teiin_mongon" 
                            v-model="taiken_list.teiin_mongon"
                            style="width: 200px; text-align: left;"/>
                  </div>
                   
                </template>
            </td>
        </tr>
        </template>
          <!--日程（開催期間等）-->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <!-- 編集の場合の日程表示 -->
          <tr>
            <th >
                <label for="" id="nittei_henshu">日程
                  <span class="vy-required" >（必須）</span>
                  <br>
                  
                  <img src="../../images/add.png" v-on:click="nittei_add(9999)"  v-if="taiken_list.shubetsu == 1" style="cursor:pointer">
                  
                </label>
            </th>
            <td style="text-align: left;" >
              <div id="tab" style="display: flex;justify-content: space-between;" v-if="disp_nittei_list.length > 1">
                <ul id="nittei_tabMenu" class="edit_tabMenu">
                  <template v-for="(result,i) in disp_nittei_list" v-bind:key="i">
                    <template v-if="NitteiActive == i">
                      <li class="tabblue">日程：{{ result[0].nittei_group}}</li>
                    </template>
                    <template v-else>
                      <li class="tabgray" v-on:click="Change_nittei(i)">日程：{{ result[0].nittei_group }}</li>
                    </template>
                  </template>
                </ul>
              </div>
              <div class="edit_komoku_area" style="padding-top:10px">
               <div v-show="KatsudouActive=='main'" v-if="disp_nittei_list[NitteiActive] != undefined">

                  <div style="text-align:center">
                    <input style="border-radius:10px;background: blue;color: white;" type="button" value="この日程を複製する" v-on:click="nittei_copy(NitteiActive,9999)"   >
                    <input style="border-radius:10px;background: red;color: white;margin-left:10px" type="button" value="この日程を削除する" v-on:click="nittei_delete(NitteiActive,9999)" v-if="NitteiActive != 0" >
                  </div>
                  <hr>
                  <b class="nittei_title">開催日、開催期間</b>
                    <div style="padding: 10px 0px ;display: flex;align-items: center;">
                      <input type="date" class="form-control enter_forcus"
                        v-bind:id="['kaisai_start']"
                        v-bind:name="['kaisai_start']"
                        v-model="disp_nittei_list[NitteiActive][0].kaisai_start"
                        style="width:150px"/>
                        &nbsp;～&nbsp;
                      <input type="date" class="form-control enter_forcus"
                        v-bind:id="['kaisai_end']"
                        v-bind:name="['kaisai_end']"
                        v-model="disp_nittei_list[NitteiActive][0].kaisai_end"
                        style="width:150px"/>
                        &nbsp;&nbsp;
                        
                        <img src="../../images/calendar_set.png" v-on:click="calendar_open(9999,NitteiActive,'kaisai')"   style="cursor:pointer">    
                    </div>

                  <b class="nittei_title">開催曜日、除外曜日指定</b>
                  <div style="padding-top:10px;">
                    <div >
                      <b>
                        開催曜日
                      <span class="balloon_parent" >
                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                        <span class="balloon" style="width:550px" >
                          「水曜日のみ開催」のように、開催する曜日が固定されている場合に利用します。<br>
                          ※ 開催曜日を設定する場合、除外曜日は設定できません。
                          </span>
                        </span>
                         </b>
                    </div>
                    <span style="display: flex;align-items: center" >
                      <div v-for="(youbi,y) in youbi_list" v-bind:key="y">
                        <input type="checkbox" class="form-check-input"
                        v-bind:value="youbi"
                        v-bind:id="['kaisai_youbi9999' + y + NitteiActive]"
                        v-bind:name="['kaisai_youbi9999' + y + NitteiActive]"
                        v-on:click="set_kaisai_youbi(y,NitteiActive,9999)"
                        checked="checked"
                        v-if="disp_nittei_list[NitteiActive][0].kaisai_array != '' && disp_nittei_list[NitteiActive][0].kaisai_array != null && disp_nittei_list[NitteiActive][0].kaisai_array.includes(youbi)">
                        <input type="checkbox"  class="form-check-input" 
                        v-bind:value="youbi"
                        v-bind:id="['kaisai_youbi9999' + y + NitteiActive]"
                        v-bind:name="['kaisai_youbi9999' + y + NitteiActive]"
                        v-on:click="set_kaisai_youbi(y,NitteiActive,9999)"
                        v-else>
                        <label class="form-check-label" v-bind:for="y" style="padding:0 10px">{{ youbi }}</label>
                      </div>
                    </span>
                    
                    </div>
                    
                  <div style="padding: 10px 0px 25px ">
                    <div>
                      <b>
                        除外曜日
                      <span class="balloon_parent" >
                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                        <span class="balloon" style="width:600px" >
                          「土・日・祝は開催しない」のように、開催しない曜日が決まっている場合に利用します。<br>
                          ※ 除外曜日を設定する場合、開催曜日は設定できません。
                          </span>
                        </span>
                         </b>
                    </div>
                    <span style="display: flex;align-items: center;" >

                      <div v-for="(youbi,y) in youbi_list" v-bind:key="y" >
                        <input type="checkbox" class="form-check-input" 
                        v-bind:value="youbi"
                        v-bind:id="['jogai_youbi9999' + y + NitteiActive]"
                        v-bind:name="['jogai_youbi9999' + y + NitteiActive]"
                        v-on:click="set_jogai_youbi(y,NitteiActive,9999)"
                        checked="checked"
                        v-if="disp_nittei_list[NitteiActive][0].jogai_array != '' && disp_nittei_list[NitteiActive][0].jogai_array != null && disp_nittei_list[NitteiActive][0].jogai_array.includes(youbi)">
                        <input type="checkbox"  class="form-check-input" 
                        v-bind:value="youbi"
                        v-bind:id="['jogai_youbi9999' + y + NitteiActive]"
                        v-bind:name="['jogai_youbi9999' + y + NitteiActive]"
                        v-on:click="set_jogai_youbi(y,NitteiActive,9999)"
                        v-else>
                        <label class="form-check-label" v-bind:for="y" style="padding:0 10px">{{ youbi }}</label>
                      </div>

                    </span>
                    
                    </div>
                      <b class="nittei_title">除外日</b>
                      <div style="display: flex;align-items: center;padding: 10px 0px 25px " >
                       
                        <input type="text" class="form-control enter_forcus" v-bind:id="['jogai_date']" v-bind:name="['jogai_date']" 
                        placeholder="カレンダーから日付を選択してください。"
                        style="max-width: 500px;margin-right:10px;background: #eee;"
                        disabled
                        v-model="disp_nittei_list[NitteiActive][0].jogai_date"/>
                        
                        <img src="../../images/calendar_set.png" v-on:click="calendar_open(9999,NitteiActive,'jogai')"   style="cursor:pointer">    
                      </div>

                <template v-if="taiken_list.shubetsu == 1">
                      
                    <b class="nittei_title">活動時間
                      <template v-if="taiken_list.teiin_settei == 0">、時間帯ごと定員</template>
                      
                    </b>
                  <div style="padding: 10px 0px 25px ">
                    <span style="display: flex;align-items: center;margin:5px 0" >
                      <div>
                      &nbsp;&nbsp;[1]&nbsp;&nbsp;
                      </div>
                      
                      <div style="display: flex;flex-direction: column;margin:10px 0">
                        
                        <div style="display: flex;align-items: center" >
                          
                         &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                        <input type="time" class="form-control enter_forcus"
                          v-bind:id="['jikantai_start0']"
                          v-bind:name="['jikantai_start0']"
                          v-model="disp_nittei_list[NitteiActive][0].jikantai_start"
                          style="width:100px"/>
                          &nbsp;～&nbsp;
                        <input type="time" class="form-control enter_forcus" 
                          v-bind:id="['jikantai_end0']"
                          v-bind:name="['jikantai_end0']"
                          v-model="disp_nittei_list[NitteiActive][0].jikantai_end"
                          style="width:100px"/>
                        </div>
                        <div style="display: flex;align-items: center;padding-top:10px" v-if="taiken_list.teiin_settei == 0">
                          <span style="display: flex;align-items: center" >
                          &nbsp;&nbsp;
                            <b>定員</b>&nbsp;&nbsp;
                            <input type="number" size="3" 
                              class="form-control enter_forcus" v-bind:id="['teiin0']" v-bind:name="['teiin0']" 
                              v-model="disp_nittei_list[NitteiActive][0].teiin"
                              v-on:change="teiin_change(0,9999)"
                              style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                          
                          </span>
                        <span style="display: flex;align-items: center" >
                        &nbsp;&nbsp;
                          <b>定員の文言</b>
                          <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon0']" v-bind:name="['teiin_mongon0']" 
                            v-model="disp_nittei_list[NitteiActive][0].teiin_mongon"
                            style="margin-left:10px;width:185px;text-align: left;" />
                        
                        </span>
                      </div>
                    </div>
                    </span>
                    <template v-if="taiken_list.nittei_sentaku == 0">
                      <span style="display: flex;align-items: center;margin:5px 0" >
                        <div>
                        &nbsp;&nbsp;[2]&nbsp;&nbsp;
                        </div>
                        
                        <div style="display: flex;flex-direction: column;margin:10px 0">
                          
                          <div style="display: flex;align-items: center;" >
                            
                            &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                            <input type="time" class="form-control enter_forcus"
                              v-bind:id="['jikantai_start1']"
                              v-bind:name="['jikantai_start1']"
                              v-model="disp_nittei_list[NitteiActive][1].jikantai_start"
                              style="width:100px"/>
                              &nbsp;～&nbsp;
                            <input type="time" class="form-control enter_forcus" 
                              v-bind:id="['jikantai_end1']"
                              v-bind:name="['jikantai_end1']"
                              v-model="disp_nittei_list[NitteiActive][1].jikantai_end"
                              style="width:100px"/>
                            </div>
                            <div style="display: flex;align-items: center;padding-top:10px" v-if="taiken_list.teiin_settei == 0">
                            <span style="display: flex;align-items: center" >
                            &nbsp;&nbsp;
                              <b>定員</b>&nbsp;&nbsp;
                              <input type="number" size="3" 
                                class="form-control enter_forcus" v-bind:id="['teiin1']" v-bind:name="['teiin1']" 
                                v-model="disp_nittei_list[NitteiActive][1].teiin"
                                  v-on:change="teiin_change(1,9999)"
                                style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                            
                            </span>
                            <span style="display: flex;align-items: center" >
                            &nbsp;&nbsp;
                              <b>定員の文言</b>
                              <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon1']" v-bind:name="['teiin_mongon1']" 
                                v-model="disp_nittei_list[NitteiActive][1].teiin_mongon"
                                style="margin-left:10px;width:185px;text-align: left;" />
                            
                            </span>
                          </div>
                        </div>
                      </span>

                      <span style="display: flex;align-items: center;margin:5px 0" >
                        <div>
                        &nbsp;&nbsp;[3]&nbsp;&nbsp;
                        </div>
                        
                        <div style="display: flex;flex-direction: column;margin:10px 0">
                          
                          <div style="display: flex;align-items: center;" >
                            &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                            <input type="time" class="form-control enter_forcus"
                              v-bind:id="['jikantai_start2']"
                              v-bind:name="['jikantai_start2']"
                              v-model="disp_nittei_list[NitteiActive][2].jikantai_start"
                              style="width:100px"/>
                              &nbsp;～&nbsp;
                            <input type="time" class="form-control enter_forcus" 
                              v-bind:id="['jikantai_end2']"
                              v-bind:name="['jikantai_end2']"
                              v-model="disp_nittei_list[NitteiActive][2].jikantai_end"
                              style="width:100px"/>
                            </div>
                            <div style="display: flex;align-items: center;padding-top:10px" v-if="taiken_list.teiin_settei == 0">
                            <span style="display: flex;align-items: center" >
                            &nbsp;&nbsp;
                              <b>定員</b>&nbsp;&nbsp;
                              <input type="number" size="3" 
                                class="form-control enter_forcus" v-bind:id="['teiin2']" v-bind:name="['teiin2']" 
                                  v-model="disp_nittei_list[NitteiActive][2].teiin"
                                  v-on:change="teiin_change(2,9999)"
                                style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                            
                            </span>
                            <span style="display: flex;align-items: center" >
                            &nbsp;&nbsp;
                              <b>定員の文言</b>
                              <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon2']" v-bind:name="['teiin_mongon2']" 
                                v-model="disp_nittei_list[NitteiActive][2].teiin_mongon"
                                style="margin-left:10px;width:185px;text-align: left;" />
                            
                            </span>
                          </div>
                        </div>
                      </span>
                    </template>
                  </div>
                </template>
                
                <b class="nittei_title">この開催募集に関するコメント</b>
                <div style="padding:10px 0">
                  <input type="text" class="form-control enter_forcus" v-bind:id="['comment']" v-bind:name="['comment']" 
                        v-model="disp_nittei_list[NitteiActive][0].comment"/>
                  </div>
                </div>

              </div>
              </td>
          </tr>
          <!-- 参加条件（対象者） -->
          <tr>
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr>
            <th >
                <label for="">参加条件（対象者）</label><span class="vy-required" >（必須）</span>
                <span class="balloon_parent" >
                  <img class="q_icon" src="../../images/mark/qmark.png"  />
                  <span class="balloon" style="width:650px">
                    参加できる体験ユーザーを範囲指定します。<br>
                    【例①】「小学」「5」～「中学」「（未指定）」→小学5、6年生～中学生（全学年）が対象<br>
                    【例②】「小学」「（未指定）」～「小学」「（未指定）」→小学生のみ対象<br>
                    【例③】「小学」「（未指定）」～「高校」「（未指定）」→小学生、中学生、高校生が対象<br>
                  </span>
                 </span>
            </th>
            <td style="text-align: left;">
                <select class="enter_forcus" v-model="disp_all_start" id="disp_all_start" name="disp_all_start"
                    style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(0,'main')"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                    <template v-if="gakusei_kbn_list[i] != 0">
                      <option v-bind:value="joken_kubun_keys[i]">{{ gakusei_meisho_list[i]}}</option>
                    </template>
                  </template>
                      <option value="一般">一般</option>
                </select>
                <select class="enter_forcus" v-model="disp_all_start_gakunen" id="disp_all_start_gakunen" name="disp_all_start_gakunen"
                    style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(0,'main')"
                    :disabled = "disp_all_start=='一般'"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <option value="0">（未指定）</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>年
                &nbsp;
                ～
                &nbsp;
                <select class="enter_forcus" v-model="disp_all_end" id="disp_all_end" name="disp_all_end"
                    style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(0,'main')"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                      <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                        <template v-if="gakusei_kbn_list[i] != 0">
                          <option v-bind:value="joken_kubun_keys[i]">{{ gakusei_meisho_list[i]}}</option>
                        </template>
                      </template>
                      <option value="一般">一般</option>
                  </select>
                <select class="enter_forcus" v-model="disp_all_end_gakunen" id="disp_all_end_gakunen" name="disp_all_end_gakunen"
                    style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(0,'main')"
                    :disabled = "disp_all_end=='一般'"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <option value="0">（未指定）</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>年
                <div style="display: flex;align-items: center;padding-top:10px">
                  体験者に表示される文言：
                  <input type="text" v-model="taiken_list.joken_mongon" id="joken_mongon" name="joken_mongon" class="form-control enter_forcus"
                  style="width:275px">
                </div>
            </td>
          </tr>
          <tr v-if="taiken_list.shubetsu == 1 && null_disp==false">
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="taiken_list.shubetsu == 1 && (null_disp==false || (null_disp==true && taiken_list.sankahi != null && taiken_list.sankahi != ''))">
            <th >
                <label for="">参加にあたって</label>
            </th>
            <td style="text-align: left;">
              <span class="sanka_span">
                <b style="width:85px">参加費</b>
                <select class="enter_forcus" v-model="taiken_list.sankahi" id="sankahi" name="sankahi"
                    style="height:30px;text-align:center" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <option value="不要">不要</option>
                  <option value="要">要</option>
                  
                </select>&nbsp;
                <span v-if="taiken_list.sankahi == '要' " style="display: flex;align-items: center;">
                  <input type="text" class="form-control enter_forcus" id="disp_sankahi" name="disp_sankahi" 
                      style="height: 30px;" v-on:change="Henshu_check()"
                      v-model="disp_sankahi"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                </span>
              </span>
                 
                <span class="sanka_span">
                  <b style="width:85px">検温等</b>
                  <select class="enter_forcus" v-model="taiken_list.kensa" id="kensa" name="kensa"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="taiken_list.kensa == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="form-control enter_forcus" id="disp_kensa" name="disp_kensa" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="disp_kensa"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                </span>
                <span class="sanka_span">
                  <b style="width:85px">検便</b>
                  <select class="enter_forcus" v-model="taiken_list.kenben" id="kenben" name="kenben"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="taiken_list.kenben == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="form-control enter_forcus" id="disp_kenben" name="disp_kenben" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="disp_kenben"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                </span>
              <span class="sanka_span">
                <b style="width:85px">マスク着用</b>
                <select class="enter_forcus" v-model="taiken_list.mask" id="mask" name="mask"
                    style="height:30px;text-align:center" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <option value="不要">不要</option>
                  <option value="要">要</option>
                  
                </select>&nbsp;
                <span v-if="taiken_list.mask == '要' " style="display: flex;align-items: center;">
                  <input type="text" class="form-control enter_forcus" id="disp_mask" name="disp_mask" 
                      style="height: 30px;" v-on:change="Henshu_check()"
                      v-model="disp_mask"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                </span>
              </span>
              <span class="sanka_span">
                <b style="width:85px">昼食</b>
                <select class="enter_forcus" v-model="taiken_list.chusyoku" id="chusyoku" name="chusyoku"
                    style="height:30px;text-align:center" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext">
                  <option value="不要">不要</option>
                  <option value="要">要</option>
                  
                </select>&nbsp;
                <span v-if="taiken_list.chusyoku == '要' " style="display: flex;align-items: center;">
                  <input type="text" class="form-control enter_forcus" id="disp_chusyoku" name="disp_chusyoku" 
                      style="height: 30px;" v-on:change="Henshu_check()"
                      v-model="disp_chusyoku"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                </span>
              </span>
              <span class="sanka_span">
                <b style="width:85px">持ち物</b>
                <input type="text" class="form-control enter_forcus" id="mochimono" name="mochimono" 
                style="max-width:450px"
                    v-model="taiken_list.mochimono" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
              </span>
              
              <span class="sanka_span">
                <b style="width:85px">服装</b>
                <input type="text" class="form-control enter_forcus" id="fukusou" name="fukusou" 
                style="max-width:450px"
                    v-model="taiken_list.fukusou" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
              </span>
            </td>
          </tr>
          <!-- 添付資料 -->
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.shiryo_url != null && taiken_list.shiryo_url != '')">
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.shiryo_url != null && taiken_list.shiryo_url != '')">
            <th rowspan=2>
                <label for="">添付資料</label>
            </th>
            <td style="text-align: left;">
              <b>説明：</b><input type="text" class="form-control enter_forcus" id="shiryo_setsumei" name="shiryo_setsumei" 
                  v-model="taiken_list.shiryo_setsumei" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
              </td>
          </tr>
          
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.shiryo_url != null && taiken_list.shiryo_url != '')">
           
            <td style="text-align: left;">
              <b>URL：</b><input type="text" class="form-control enter_forcus" id="shiryo_url" name="shiryo_url" 
                  v-model="taiken_list.shiryo_url" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.prevent="moveNext"/>
              </td>
          </tr>
          <!-- その他（特記事項、備考） -->
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.bikou != null && taiken_list.bikou != '')">
              <td colspan="2"><div class="vy-dotted"></div></td>
          </tr>
          <tr v-if="null_disp==false || (null_disp==true && taiken_list.bikou != null && taiken_list.bikou != '')">
            <th >
                <label for="">その他（特記事項、備考）</label>
            </th>
            <td style="text-align: left;">
               <textarea class="form-control enter_forcus" id="bikou" name="bikou" rows="3" v-model="taiken_list.bikou" v-on:change="Henshu_check()"
                  @keydown.enter.exact.prevent
                  @keyup.enter.exact="moveNext"
                  @keydown.enter.alt.exact="NewLine_bikou" maxlength="5000"></textarea>
              </td>
          </tr>
           
            </tbody>

          <!--サブプログラム（活動2～）-->
          <template v-for="(result,s) in sub_list" v-bind:key="s" >
            <tbody v-show="KatsudouActive=='sub'+s">
              <tr>
                <td colspan="2">
                  <input style="background: red;color: white;" type="button" value="この活動を削除する" v-on:click="katsudou_delete(s)" >
                </td>
              </tr>
              <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
              <!--
            <tr>
                <th colspan="2">
                  
                  <input type="button" class="katsudou_white" v-on:click="link_katsudou(9999)" value="活動1">
                  <template v-if="sub_list.length != 0">
                    <template v-for="(result,s2) in sub_list" v-bind:key="s2">
                      <template v-if="s2 == s">
                        <input type="button" class="katsudou_blue" style="margin-left:10px" v-bind:value="'活動' + (s2+2)" v-bind:id="'link_katsudou'+s2">
                      </template>
                      <template v-else>
                        <input type="button" class="katsudou_white" style="margin-left:10px" v-on:click="link_katsudou(s2)" v-bind:value="'活動' + (s2+2)">
                      </template>
                    </template>
                  </template>
                      <input style="background: red;color: white;margin-left:10px" type="button" value="削除" v-on:click="katsudou_delete(s)" >
                      

                </th>
            </tr>-->
            <!--プログラム名称 -->
            
            <!--
            <tr>
              <th>
                  <label for="">施設名<span class="vy-required" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                
                  <input type="text" class="form-control enter_forcus" 
                    v-bind:id="'name' + s"
                    v-on:change="Henshu_check()"
                      v-model="sub_list[s].name"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext" maxlength="100"/>
                </td>
            </tr>
            -->
            <!--参加の義務-->
            <tr>
              <th>
                  <label for="">参加の義務<span class="vy-required" >（必須）</span></label>
              </th>
              <td style="text-align: left;">
                
                <select class="enter_forcus" v-model="sub_list[s].hissu_flg" id="hissu_flg" name="hissu_flg" v-on:change="Henshu_check()"
                        style="height:30px;width:70px;text-align:center">
                        <option value="0">{{ hissu_list[0] }}</option>
                        <option value="1">{{ hissu_list[1] }}</option>
                        <option value="2">{{ hissu_list[2] }}</option>
                  </select>
                </td>
            </tr>

            <!-- 活動内容 -->
            <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th >
                  <label for="">活動内容<span class="vy-required" >（必須）</span></label><br>
              </th>
              <td style="text-align: left;">
                
                <textarea as="textarea" class="form-control enter_forcus" id="naiyou" name="naiyou" rows="3" v-model="sub_list[s].naiyou"
                v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.exact="moveNext"
                    @keydown.enter.alt.exact="NewLine_naiyou(s)" maxlength="5000"></textarea>
                  <span class="by-sub">※改行は「alt + Enter」で行います。<br></span>

                </td>
            </tr>
            <!--開催場所 -->
            <tr >
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th >
                  <label for="">開催場所</label>
                  
                  <span class="balloon_parent">
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" >
                      プログラム種別が「施設・地域」の場合は「活動を行う会場」、<br>「制作・寄付」の場合は「寄付品をお届けする場所」となります。
                    </span>
                  </span>
                  
              </th>
              <td>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && sub_list[s].k_name != null && sub_list[s].k_name != '')">
                  <b>開催地名</b>
                  <input type="text" class="form-control enter_forcus" id="k_name" name="k_name" 
                  v-on:change="Henshu_check()"
                    v-model="sub_list[s].k_name"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
              </div>
              <div style="text-align: left;">
                  <b>住所<span class="vy-required" >（必須）</span></b>
                  
                  <input type="text" class="form-control enter_forcus" id="k_jusyo" name="k_jusyo" 
                    v-on:change="Henshu_check()"
                    v-model="sub_list[s].k_jusyo"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
                    
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && sub_list[s].k_access != null && sub_list[s].k_access != '')">
                  <b>アクセス方法</b>
                  <input type="text" class="form-control enter_forcus" id="k_access" name="k_access"  v-on:change="Henshu_check()"
                    v-model="sub_list[s].k_access"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
              </div>
              <div style="text-align: left;" v-if="null_disp==false || (null_disp==true && sub_list[s].k_tel != null && sub_list[s].k_tel != '')">
                  <b>連絡先</b>
                  <input type="tel" class="form-control enter_forcus" id="k_tel" name="k_tel"  v-on:change="Henshu_check()"
                    placeholder="0492123456" maxlength="11" v-model="sub_list[s].k_tel"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
              </div>
              </td>
            </tr>
            

            
            <!--申込〆切日時（HOMEの受付〆切日の種別が2の時のみ表示）-->
            <template v-if="end_shubetsu == 2">
              <tr>
                  <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr>
                <th >
                    <label for="">申込〆切日時</label>
                    <span class="balloon_parent">
                      <img class="q_icon" src="../../images/mark/qmark.png"  />
                        <span class="balloon" style="min-width:350px;" >
                          申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。
                        </span>
                      </span>
                </th>
                <td style="text-align: left;">
                  <div style="display:flex">
                    <input type="date" class="form-control enter_forcus" id="sub_shimekiri_day" name="sub_shimekiri_day" v-on:change="Henshu_check()"
                      v-model="sub_shimekiri_day[s]"
                      style="width:150px"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                      
                    <input type="time" class="form-control enter_forcus" id="sub_shimekiri_time" name="shimekiri_time"  v-on:change="Henshu_check()"
                      v-model="sub_shimekiri_time[s]"
                      style="width:100px"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                  </div>
                </td>
              </tr>
              <!--申込〆切日数-->
              <tr v-if="taiken_list.shubetsu== 1">
                <th >
                    <label for="">申込〆切日数</label>
                    
                    <span class="balloon_parent">
                        <img class="q_icon" src="../../images/mark/qmark.png"  />
                          <span class="balloon" style="min-width:350px">
                          申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。
                          </span>
                        </span>
                </th>
                <td style="text-align: left;">
                  
                  <div style="display: flex;align-items: center;">
                    開催日の<input type="number" size="2" min="1" v-on:change="Henshu_check()"
                            class="form-control enter_forcus" id="shimekiri_nissu" name="shimekiri_nissu" 
                            v-model="sub_list[s].shimekiri_nissu"
                            style="width:80px;text-align: center;margin:0 5px;"
                            @keydown.enter.exact.prevent
                            @keyup.enter.prevent="moveNext"/>日前まで申込み可能
                  </div>
                </td>
              </tr>
            </template>

            <template  v-if="taiken_list.shubetsu == 1">
              
              <tr>
                  <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr>
                <th >
                    <label for="" id="nittei_henshu">体験者の日程ごとの申込方法
                      <span class="vy-required" >（必須）</span>
                    </label>
                </th>
                <td>
                  <select class="form-select enter_forcus" v-model="sub_list[s].nittei_sentaku" 
                      v-on:change="nittei_sentaku_change(s)" style="width: auto;" >
                                <option value="0">活動条件で申込</option>
                                <option value="1">設定日全て申込</option>
                      </select>
                </td>
              </tr>
              <!--活動条件-->
              <tr>
                  <td colspan="2"><div class="vy-dotted"></div></td>
              </tr>
              <tr>
                <th >
                    <label for="" id="nittei_henshu">活動条件
                      <span class="vy-required" >（必須）</span>
                      
                    </label>
                </th>
                <td>

                    <template v-if="sub_list[s].nittei_sentaku == 0">
                        
                      <div class="joken_div">
                        <b>活動日数：</b>
                        <input type="number" size="2" 
                            class="form-control  enter_forcus" id="nissu_min" name="nissu_min" 
                            v-model="sub_list[s].nissu_min"
                            v-on:change="nissu_change(s)"
                            style="width:70px;text-align: center;"/>
                            &nbsp;～&nbsp;
                        <input type="number" size="2" 
                            class="form-control  enter_forcus" id="nissu_max" name="nissu_max" 
                            v-model="sub_list[s].nissu_max"
                            v-on:change="nissu_change(s)"
                            style="width:70px;text-align: center;"/>&nbsp;日&nbsp;
                      </div>
                      <div class="joken_div" >
                        <b>連続日参加義務：</b>
                        <input type="checkbox" style="width:23px;height:23px" v-model="sub_list[s].nissu_joken" 
                         v-on:change="nissu_change(s)"
                        :true-value="1" :false-value="2">
                        
                        <template v-if="sub_list[s].nissu_joken == 1">
                          &nbsp;&nbsp;&nbsp;&nbsp;<b>除外日・除外曜日の飛ばし：</b>
                          <select class="form-select enter_forcus" v-model="sub_list[s].nissu_jogai" style="width:auto"
                            v-on:change="nissu_change(s)">
                          <option value="true">可</option>
                          <option value="false">不可</option>
                        </select>&nbsp;
                        </template>
                      </div>
                      <div class="joken_div">
                        <b>活動日数の表示文：</b>
                        <input type="text" class="form-control  enter_forcus" id="nissu_mongon" name="nissu_mongon" 
                            v-model="sub_list[s].nissu_mongon"
                            style="width:500px;text-align: left;"/>
                      </div>

                      <div class="joken_div">
                      <b>定員割当：</b>
                      <select class="form-select enter_forcus" 
                          v-on:change="teiin_settei_change(s)"
                          v-model="sub_list[s].teiin_settei" style="width: auto;">
                            <option value="0">時間帯ごとに割当</option>
                            <option value="1">1日単位で割当</option>
                          </select>&nbsp;&nbsp;

                          <span v-if="sub_list[s].teiin_settei == 1" style="display: flex;align-items: center;">
                            <b>1日の定員：</b>
                            <input type="number" size="2" 
                                class="form-control enter_forcus" id="teiin_oneday" name="teiin_oneday" 
                                v-model="sub_list[s].teiin_oneday"
                                v-on:change="teiin_oneday_change(s)"
                                style="width:75px;text-align: center;"/>&nbsp;人&nbsp;
                          </span>
                      </div>
                      <div  class="joken_div" v-if="sub_list[s].teiin_settei == 1">
                        <b>定員割当の表示文：</b>
                            <input type="text" 
                                class="form-control enter_forcus" id="teiin_mongon" name="teiin_mongon" 
                                v-model="taiken_list.teiin_mongon"
                                style="width: 200px; text-align: left;"/>
                      </div>
                      
                    </template>
                </td>
              </tr>
            </template>
              
            <!--日程（開催期間等）-->
            <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <!-- 編集の場合の日程表示 -->
            <tr>
              <th >
                  <label for="" id="nittei_henshu">日程
                    <span class="vy-required" >（必須）</span>
                    <br>
                    <img src="../../images/add.png" v-on:click="nittei_add(s)" style="cursor:pointer">
                    
                  </label>
              </th>
              <td style="text-align: left;">
                  
                <div id="tab" style="display: flex;justify-content: space-between;" v-if="sub_disp_nittei_list[s].length > 1">
                  <ul id="nittei_tabMenu" class="edit_tabMenu" >
                    <template v-for="(result,i) in sub_disp_nittei_list[s]" v-bind:key="i">
                      
                      <template v-if="NitteiActive == i">
                        <li class="tabblue">日程：{{ result[0].nittei_group }}</li>
                      </template>
                      <template v-else>
                        <li class="tabgray" v-on:click="Change_nittei(i)">日程：{{ result[0].nittei_group }}</li>
                      </template>
                    </template>
                  </ul>
                </div>
                <div class="edit_komoku_area" style="padding-top:10px">
                  
                  <div v-show="KatsudouActive=='sub'+s" v-if="sub_disp_nittei_list[s][NitteiActive] != undefined">

                  <div style="text-align:center">
                    <input style="border-radius:10px;background: blue;color: white;" type="button" value="この日程を複製する" v-on:click="nittei_copy(NitteiActive,s)"   >
                    <input style="border-radius:10px;background: red;color: white;margin-left:10px" type="button" value="この日程を削除する" v-on:click="nittei_delete(NitteiActive,s)"  v-if="NitteiActive != 0" >
                  </div>
                  <hr>
                    <b class="nittei_title">開催日、開催期間</b>
                        <div style="padding: 10px 0px ;display: flex;align-items: center;">
                          <input type="date" class="form-control enter_forcus"
                            v-bind:id="['kaisai_start']"
                            v-bind:name="['kaisai_start']"
                            v-model="sub_disp_nittei_list[s][NitteiActive][0].kaisai_start"
                            style="width:150px"/>
                            &nbsp;～&nbsp;
                          <input type="date" class="form-control enter_forcus"
                            v-bind:id="['kaisai_end']"
                            v-bind:name="['kaisai_end']"
                            v-model="sub_disp_nittei_list[s][NitteiActive][0].kaisai_end"
                            style="width:150px"/>
                            &nbsp;&nbsp;
                            
                            <img src="../../images/calendar_set.png" v-on:click="calendar_open(s,NitteiActive,'kaisai')"   style="cursor:pointer">    
                        </div>

                      <b class="nittei_title">開催曜日、除外曜日指定</b>
                      <div style="padding-top:10px;">
                        <div >
                          <b>
                            開催曜日
                          <span class="balloon_parent" >
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:550px" >
                              「水曜日のみ開催」のように、開催する曜日が固定されている場合に利用します。<br>
                              ※ 開催曜日を設定する場合、除外曜日は設定できません。
                              </span>
                            </span>
                            </b>
                        </div>
                        <span style="display: flex;align-items: center" >
                          <div v-for="(youbi,y) in youbi_list" v-bind:key="y">
                            <input type="checkbox" class="form-check-input"
                            v-bind:value="youbi"
                            v-bind:id="['kaisai_youbi'+s + y + NitteiActive]"
                            v-bind:name="['kaisai_youbi'+s + y + NitteiActive]"
                            v-on:click="set_kaisai_youbi(y,NitteiActive,s)"
                            checked="checked"
                            v-if="sub_disp_nittei_list[s][NitteiActive][0].kaisai_array != '' && sub_disp_nittei_list[s][NitteiActive][0].kaisai_array != null && sub_disp_nittei_list[s][NitteiActive][0].kaisai_array.includes(youbi)">
                            <input type="checkbox"  class="form-check-input" 
                            v-bind:value="youbi"
                            v-bind:id="['kaisai_youbi'+ s + y + NitteiActive]"
                            v-bind:name="['kaisai_youbi'+ s + y + NitteiActive]"
                            v-on:click="set_kaisai_youbi(y,NitteiActive,s)"
                            v-else>
                            <label class="form-check-label" v-bind:for="y" style="padding:0 10px">{{ youbi }}</label>
                          </div>
                        </span>
                        
                        </div>
                        
                      <div style="padding: 10px 0px 25px ">
                        <div>
                          <b>
                            除外曜日
                          <span class="balloon_parent" >
                            <img class="q_icon" src="../../images/mark/qmark.png"  />
                            <span class="balloon" style="width:600px" >
                              「土・日・祝は開催しない」のように、開催しない曜日が決まっている場合に利用します。<br>
                              ※ 除外曜日を設定する場合、開催曜日は設定できません。
                              </span>
                            </span>
                            </b>
                        </div>
                        <span style="display: flex;align-items: center;" >

                          <div v-for="(youbi,y) in youbi_list" v-bind:key="y" >
                            <input type="checkbox" class="form-check-input" 
                            v-bind:value="youbi"
                            v-bind:id="['jogai_youbi' + s + y + NitteiActive]"
                            v-bind:name="['jogai_youbi' + s + y + NitteiActive]"
                            v-on:click="set_jogai_youbi(y,NitteiActive,s)"
                            checked="checked"
                            v-if="sub_disp_nittei_list[s][NitteiActive][0].jogai_array != '' && sub_disp_nittei_list[s][NitteiActive][0].jogai_array != null && sub_disp_nittei_list[s][NitteiActive][0].jogai_array.includes(youbi)">
                            <input type="checkbox"  class="form-check-input" 
                            v-bind:value="youbi"
                            v-bind:id="['jogai_youbi' + s + y + NitteiActive]"
                            v-bind:name="['jogai_youbi' + s + y + NitteiActive]"
                            v-on:click="set_jogai_youbi(y,NitteiActive,s)"
                            v-else>
                            <label class="form-check-label" v-bind:for="y" style="padding:0 10px">{{ youbi }}</label>
                          </div>

                        </span>
                        
                        </div>
                          <b class="nittei_title">除外日</b>
                          <div style="display: flex;align-items: center;padding: 10px 0px 25px " >
                          
                            <input type="text" class="form-control enter_forcus" v-bind:id="['jogai_date']" v-bind:name="['jogai_date']" 
                            placeholder="カレンダーから日付を選択してください。"
                            style="max-width: 500px;margin-right:10px;background: #eee;"
                            disabled
                            v-model="sub_disp_nittei_list[s][NitteiActive][0].jogai_date"/>
                            
                            <img src="../../images/calendar_set.png" v-on:click="calendar_open(s,NitteiActive,'jogai')"   style="cursor:pointer">    
                          </div>

                    <template v-if="taiken_list.shubetsu == 1">
                          
                        <b class="nittei_title">活動時間
                          <template v-if="taiken_list.teiin_settei == 0">、時間帯ごと定員</template>
                          
                        </b>
                      <div style="padding: 10px 0px 25px ">
                        <span style="display: flex;align-items: center;margin:5px 0" >
                          <div>
                          &nbsp;&nbsp;[1]&nbsp;&nbsp;
                          </div>
                          
                          <div style="display: flex;flex-direction: column;margin:10px 0">
                            
                            <div style="display: flex;align-items: center" >
                              
                            &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                            <input type="time" class="form-control enter_forcus"
                              v-bind:id="['jikantai_start0']"
                              v-bind:name="['jikantai_start0']"
                              v-model="sub_disp_nittei_list[s][NitteiActive][0].jikantai_start"
                              style="width:100px"/>
                              &nbsp;～&nbsp;
                            <input type="time" class="form-control enter_forcus" 
                              v-bind:id="['jikantai_end0']"
                              v-bind:name="['jikantai_end0']"
                              v-model="sub_disp_nittei_list[s][NitteiActive][0].jikantai_end"
                              style="width:100px"/>
                            </div>
                            <div style="display: flex;align-items: center;padding-top:10px" v-if="sub_list[s].teiin_settei == 0">
                              <span style="display: flex;align-items: center" >
                              &nbsp;&nbsp;
                                <b>定員</b>&nbsp;&nbsp;
                                <input type="number" size="3" 
                                  class="form-control enter_forcus" v-bind:id="['teiin0']" v-bind:name="['teiin0']" 
                                  v-model="sub_disp_nittei_list[s][NitteiActive][0].teiin"
                                  v-on:change="teiin_change(0,s)"
                                  style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                              
                              </span>
                            <span style="display: flex;align-items: center" >
                            &nbsp;&nbsp;
                              <b>定員の文言</b>
                              <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon0']" v-bind:name="['teiin_mongon0']" 
                                v-model="sub_disp_nittei_list[s][NitteiActive][0].teiin_mongon"
                                style="margin-left:10px;width:185px;text-align: left;" />
                            
                            </span>
                          </div>
                        </div>
                        </span>
                        <template v-if="sub_list[s].nittei_sentaku == 0">
                          <span style="display: flex;align-items: center;margin:5px 0" >
                            <div>
                            &nbsp;&nbsp;[2]&nbsp;&nbsp;
                            </div>
                            
                            <div style="display: flex;flex-direction: column;margin:10px 0">
                              
                              <div style="display: flex;align-items: center;" >
                                
                                &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                                <input type="time" class="form-control enter_forcus"
                                  v-bind:id="['jikantai_start1']"
                                  v-bind:name="['jikantai_start1']"
                                  v-model="sub_disp_nittei_list[s][NitteiActive][1].jikantai_start"
                                  style="width:100px"/>
                                  &nbsp;～&nbsp;
                                <input type="time" class="form-control enter_forcus" 
                                  v-bind:id="['jikantai_end1']"
                                  v-bind:name="['jikantai_end1']"
                                  v-model="sub_disp_nittei_list[s][NitteiActive][1].jikantai_end"
                                  style="width:100px"/>
                                </div>
                                <div style="display: flex;align-items: center;padding-top:10px" v-if="sub_list[s].teiin_settei == 0">
                                <span style="display: flex;align-items: center" >
                                &nbsp;&nbsp;
                                  <b>定員</b>&nbsp;&nbsp;
                                  <input type="number" size="3" 
                                    class="form-control enter_forcus" v-bind:id="['teiin1']" v-bind:name="['teiin1']" 
                                    v-model="sub_disp_nittei_list[s][NitteiActive][1].teiin"
                                      v-on:change="teiin_change(1,s)"
                                    style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                                
                                </span>
                                <span style="display: flex;align-items: center" >
                                &nbsp;&nbsp;
                                  <b>定員の文言</b>
                                  <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon1']" v-bind:name="['teiin_mongon1']" 
                                    v-model="sub_disp_nittei_list[s][NitteiActive][1].teiin_mongon"
                                    style="margin-left:10px;width:185px;text-align: left;" />
                                
                                </span>
                              </div>
                            </div>
                          </span>

                          <span style="display: flex;align-items: center;margin:5px 0" >
                            <div>
                            &nbsp;&nbsp;[3]&nbsp;&nbsp;
                            </div>
                            
                            <div style="display: flex;flex-direction: column;margin:10px 0">
                              
                              <div style="display: flex;align-items: center;" >
                                &nbsp;&nbsp;<b>時間帯</b>&nbsp;
                                <input type="time" class="form-control enter_forcus"
                                  v-bind:id="['jikantai_start2']"
                                  v-bind:name="['jikantai_start2']"
                                  v-model="sub_disp_nittei_list[s][NitteiActive][2].jikantai_start"
                                  style="width:100px"/>
                                  &nbsp;～&nbsp;
                                <input type="time" class="form-control enter_forcus" 
                                  v-bind:id="['jikantai_end2']"
                                  v-bind:name="['jikantai_end2']"
                                  v-model="sub_disp_nittei_list[s][NitteiActive][2].jikantai_end"
                                  style="width:100px"/>
                                </div>
                                <div style="display: flex;align-items: center;padding-top:10px" v-if="sub_list[s].teiin_settei == 0">
                                <span style="display: flex;align-items: center" >
                                &nbsp;&nbsp;
                                  <b>定員</b>&nbsp;&nbsp;
                                  <input type="number" size="3" 
                                    class="form-control enter_forcus" v-bind:id="['teiin2']" v-bind:name="['teiin2']" 
                                      v-model="sub_disp_nittei_list[s][NitteiActive][2].teiin"
                                      v-on:change="teiin_change(2,s)"
                                    style="margin-left:10px;width:75px;text-align: center;" />&nbsp;人&nbsp;
                                
                                </span>
                                <span style="display: flex;align-items: center" >
                                &nbsp;&nbsp;
                                  <b>定員の文言</b>
                                  <input type="text" class="form-control enter_forcus" v-bind:id="['teiin_mongon2']" v-bind:name="['teiin_mongon2']" 
                                    v-model="sub_disp_nittei_list[s][NitteiActive][2].teiin_mongon"
                                    style="margin-left:10px;width:185px;text-align: left;" />
                                
                                </span>
                              </div>
                            </div>
                          </span>
                        </template>
                      </div>
                    </template>
                    
                    <b class="nittei_title">この開催募集に関するコメント</b>
                    <div style="padding:10px 0">
                  <input type="text" class="form-control enter_forcus" v-bind:id="['comment']" v-bind:name="['comment']" 
                        v-model="sub_disp_nittei_list[s][NitteiActive][0].comment"/>
                  </div>
                </div>

                </div>
              </td>
            </tr>
            <!-- 参加条件（対象者） -->
            <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th >
                  <label for="">参加条件（対象者）</label><span class="vy-required" >（必須）</span>
                  <span class="balloon_parent" >
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="width:650px">
                      参加できる体験ユーザーを範囲指定します。<br>
                      【例①】「小学」「5」～「中学」「（未指定）」→小学5、6年生～中学生（全学年）が対象<br>
                      【例②】「小学」「（未指定）」～「小学」「（未指定）」→小学生のみ対象<br>
                      【例③】「小学」「（未指定）」～「高校」「（未指定）」→小学生、中学生、高校生が対象<br>
                    </span>
                  </span>
              </th>
              <td style="text-align: left;">
                  <select class="enter_forcus" v-model="sub_disp_all_start[s]" id="disp_all_start" name="disp_all_start"
                      style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(s,'sub')"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                      
                    <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                      <template v-if="gakusei_kbn_list[i] != 0">
                        <option v-bind:value="joken_kubun_keys[i]">{{ gakusei_meisho_list[i]}}</option>
                      </template>
                    </template>
                        <option value="一般">一般</option>
                  </select>
                  <select class="enter_forcus" v-model="sub_disp_all_start_gakunen[s]" id="disp_all_start_gakunen" name="disp_all_start_gakunen"
                      style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(s,'sub')"
                      :disabled = "sub_disp_all_start[s]=='一般'"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="0">（未指定）</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>年
                  &nbsp;
                  ～
                  &nbsp;
                  <select class="enter_forcus" v-model="sub_disp_all_end[s]" id="disp_all_end" name="disp_all_end"
                      style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(s,'sub')"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                      <template v-for="(result,i) in gakusei_kbn_list" v-bind:key="i">
                        <template v-if="gakusei_kbn_list[i] != 0">
                          <option v-bind:value="joken_kubun_keys[i]">{{ gakusei_meisho_list[i]}}</option>
                        </template>
                      </template>
                        <option value="一般">一般</option>
                  </select>
                  <select class="enter_forcus" v-model="sub_disp_all_end_gakunen[s]" id="disp_all_end_gakunen" name="disp_all_end_gakunen"
                      style="text-align:center;height:30px" v-on:change="Henshu_check();Joken_change(s,'sub')"
                      :disabled = "sub_disp_all_end[s]=='一般'"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="0">（未指定）</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                  </select>年
                  <div style="display: flex;align-items: center;padding-top:10px">
                    体験者に表示される文言：
                    <input type="text" v-model="sub_list[s].joken_mongon" id="joken_mongon" name="joken_mongon" class="form-control enter_forcus"
                    style="width:275px">
                  </div>
              </td>
            </tr>
            <tr v-if="taiken_list.shubetsu == 1 && null_disp==false">
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr v-if="taiken_list.shubetsu == 1 && (null_disp==false || (null_disp==true && sub_list[s].sankahi != null && sub_list[s].sankahi != ''))">
              <th >
                  <label for="">参加にあたって</label>
              </th>
              <td style="text-align: left;">
                <span class="sanka_span">
                <b style="width:85px">参加費</b>
                  <select class="enter_forcus" v-model="sub_list[s].sankahi" id="sankahi" name="sankahi"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="sub_list[s].sankahi == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="enter_forcus" id="disp_sankahi" name="disp_sankahi" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="sub_disp_sankahi[s]"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                  </span>
                  
                  <span class="sanka_span">
                    <b style="width:85px">検温等</b>
                    <select class="enter_forcus" v-model="sub_list[s].kensa" id="kensa" name="kensa"
                        style="height:30px;text-align:center" v-on:change="Henshu_check()"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext">
                      <option value="不要">不要</option>
                      <option value="要">要</option>
                      
                    </select>&nbsp;
                    <span v-if="sub_list[s].kensa == '要' " style="display: flex;align-items: center;">
                      <input type="text" class="enter_forcus" id="disp_kensa" name="disp_kensa" 
                          style="height: 30px;" v-on:change="Henshu_check()"
                          v-model="sub_disp_kensa[s]"
                          @keydown.enter.exact.prevent
                          @keyup.enter.prevent="moveNext"/>
                    </span>
                  </span>
                  <span class="sanka_span">
                  <b style="width:85px">検便</b>
                  <select class="enter_forcus" v-model="sub_list[s].kenben" id="kenben" name="kenben"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="sub_list[s].kenben == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="enter_forcus" id="disp_kenben" name="disp_kenben" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="sub_disp_kenben[s]"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                </span>
                <span class="sanka_span">
                <b style="width:85px">マスク着用</b>
                  <select class="enter_forcus" v-model="sub_list[s].mask" id="mask" name="mask"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="sub_list[s].mask == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="enter_forcus" id="disp_mask" name="disp_mask" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="sub_disp_mask[s]"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                </span>
                <span class="sanka_span">
                  <b style="width:85px">昼食</b>
                  <select class="enter_forcus" v-model="sub_list[s].chusyoku" id="chusyoku" name="chusyoku"
                      style="height:30px;text-align:center" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext">
                    <option value="不要">不要</option>
                    <option value="要">要</option>
                    
                  </select>&nbsp;
                  <span v-if="sub_list[s].chusyoku == '要' " style="display: flex;align-items: center;">
                    <input type="text" class="enter_forcus" id="disp_chusyoku" name="disp_chusyoku" 
                        style="height: 30px;" v-on:change="Henshu_check()"
                        v-model="sub_disp_chusyoku[s]"
                        @keydown.enter.exact.prevent
                        @keyup.enter.prevent="moveNext"/>
                  </span>
                </span>
                <span class="sanka_span">
                  <b style="width:85px">持ち物</b>
                  <input type="text" class="form-control enter_forcus" id="mochimono" name="mochimono" 
                  style="max-width:450px"
                      v-model="sub_list[s].mochimono" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                </span>
                <span class="sanka_span">
                  <b style="width:85px">服装</b>
                  <input type="text" class="form-control enter_forcus" id="fukusou" name="fukusou" 
                  style="max-width:450px"
                      v-model="sub_list[s].fukusou" v-on:change="Henshu_check()"
                      @keydown.enter.exact.prevent
                      @keyup.enter.prevent="moveNext"/>
                </span>
              </td>
            </tr>
            <!-- 添付資料 -->
            <tr v-if="null_disp==false || (null_disp==true && sub_list[s].shiryo_url != null && sub_list[s].shiryo_url != '')">
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr v-if="null_disp==false || (null_disp==true && sub_list[s].shiryo_url != null && sub_list[s].shiryo_url != '')">
              <th rowspan=2>
                  <label for="">添付資料</label>
              </th>
              <td style="text-align: left;">
                <b>説明：</b><input type="text" class="form-control enter_forcus" id="shiryo_setsumei" name="shiryo_setsumei" 
                    v-model="sub_list[s].shiryo_setsumei" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
                </td>
            </tr>
            
            <tr v-if="null_disp==false || (null_disp==true && sub_list[s].shiryo_url != null && sub_list[s].shiryo_url != '')">
            
              <td style="text-align: left;">
                <b>URL：</b><input type="text" class="form-control enter_forcus" id="shiryo_url" name="shiryo_url" 
                    v-model="sub_list[s].shiryo_url" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.prevent="moveNext"/>
                </td>
            </tr>
            <!-- その他（特記事項、備考） -->
            <tr v-if="null_disp==false || (null_disp==true && sub_list[s].bikou != null && sub_list[s].bikou != '')">
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr v-if="null_disp==false || (null_disp==true && sub_list[s].bikou != null && sub_list[s].bikou != '')">
              <th >
                  <label for="">その他（特記事項、備考）</label>
              </th>
              <td style="text-align: left;">
                <textarea class="form-control enter_forcus" id="bikou" name="bikou" rows="3" v-model="sub_list[s].bikou" v-on:change="Henshu_check()"
                    @keydown.enter.exact.prevent
                    @keyup.enter.exact="moveNext"
                    @keydown.enter.alt.exact="NewLine_bikou" maxlength="5000"></textarea>
                </td>
            </tr>
            </tbody>
          </template>
        </table>
        </div>
          
        <template v-if="jizen_jisshi == 1 || jigo_jisshi == 1">
          <div id="tab">
            <ul class="edit_tabMenu">
              <li class="tabblue" style="width:100%">
                <template v-if="jizen_jisshi == 1 && jigo_jisshi == 1">
                  事前説明会・事後集会
                </template>
                <template v-else-if="jizen_jisshi == 1 ">
                  事前説明会
                </template>
                <template v-else-if="jigo_jisshi == 1">
                  事後集会
                </template>
              </li>
            </ul>
          </div>
          <div class="edit_komoku_area">
            <table class="vy-form-table">
            <!--事前説明会-->
            <template v-if="jizen_jisshi == 1">
            <tr>
              <th >
                  <label for="" id="jizen_henshu">事前説明会</label>
                  
                  <span class="balloon_parent" >
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="width:700px;">
                      チェックを入れた説明会は「このプログラムにはこの説明会への参加が必要」とみなされ、説明会に参加するまで体験プログラムに参加できなくなります。<br>
                      1つもチェックが入っていない場合は「このプログラムには、事前説明会が必要ない」とみなされます。
                    </span>
                  </span>
              </th>
              <td style="text-align: left;">
                <form name="jizen">
                  <div v-for="(result,i) in all_jizen_list" v-bind:key="i" class="vy-search-result-row">
                    <!-- 特殊説明会以外を表示 -->
                    <template v-if="result.syurui != 4 && result.syurui != 5">
                      <div v-show="i != 0 && (null_disp==false || (null_disp==true && jizen_no_list.indexOf(result.jizen_no) != -1))" class="vy-dotted" style="padding:5px 0"></div>
                      <div style="display: flex;flex-direction: row;" v-show="null_disp==false || (null_disp==true && jizen_no_list.indexOf(result.jizen_no) != -1)">
                        <div style="display: flex;align-items:center;padding-right: 10px;">
                          <input type="checkbox" style="width:20px;height:20px" class="form-check-input" v-bind:id="['set_jizen' + i]" v-bind:value=result.jizen_no  checked="checked" v-if="jizen_no_list.indexOf(result.jizen_no) != -1" name="jizen" v-on:change="Henshu_check()">
                          <input type="checkbox" style="width:20px;height:20px" class="form-check-input" v-bind:id="['set_jizen' + i]" v-bind:value=result.jizen_no  v-else name="jizen" v-on:change="Henshu_check()">
                        </div>
                        <div>
                          {{ result.jizen_name }}<br>
                          <b>〆切日：</b>{{ DateSetting(result.shimekiri_date) }} <br>
                          <b>開催日：</b>
                          
                              <template v-if="result.syurui == 3">
                                <template v-if="result.movie_start_date && result.kensyu_date">
                                  <!--両方とも入力-->
                                  {{ DateSetting(result.movie_start_date) }} ～ {{ DateSetting(result.kensyu_date) }}
                                </template>
                                <template v-else-if="!result.movie_start_date && result.kensyu_date">
                                  <!--至のみ入力-->
                                  {{ DateSetting(result.kensyu_date) }} まで
                                </template>
                                <template v-else-if="result.movie_start_date && !result.kensyu_date">
                                  <!--自のみ入力-->
                                  {{ DateSetting(result.movie_start_date) }} 以降
                                </template>
                                    <template v-else>
                                      ー
                                    </template> 
                              </template>
                                  <template v-else>
                                    <template v-if="result.kensyu_date">
                                      {{ DateSetting(result.kensyu_date) }}
                                      
                                    </template>
                                    <template v-else>
                                      ー
                                    </template> 
                                    {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}
                                  </template>
                      <!--    {{ DateSetting(result.kensyu_date) }} {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}&nbsp;&nbsp;-->
                          <b>場所：</b>{{ result.basyo }} <br>
                          <b>定員：</b>
                          <span v-if="result.teiin">{{ result.teiin }}名まで</span>
                          <span v-else-if="result.teiin == 9999">定員なし</span>
                          <br>
                          <b>体験開始日：</b>{{ DateSetting(result.taikenkaishi_date) }} 
                        </div>
                      </div>
                    </template>
                  </div>
                  
                  <input type="checkbox" class="form-check-input" v-bind:id="['set_jizen0']" value=0 name="jizen" style="display:none">
                </form>
              </td>
            </tr>
            </template>
            
            <template v-if="jigo_jisshi == 1">
            <!--事後集会-->
            <tr>
                <td colspan="2"><div class="vy-dotted"></div></td>
            </tr>
            <tr>
              <th >
                  <label for="" id="jigo_henshu">事後集会</label>
                  
                  <span class="balloon_parent" >
                    <img class="q_icon" src="../../images/mark/qmark.png"  />
                    <span class="balloon" style="width:700px;">
                      チェックを入れた集会は「プログラム参加後には、この集会へ参加可能」とみなされます。<br>
                      1つもチェックが入っていない場合は「このプログラムには、事後集会がない」とみなされます。
                    </span>
                  </span>
              </th>
              <td style="text-align: left;">
                <form name="jigo">
                  <div v-for="(result,i) in all_jigo_list" v-bind:key="i" class="vy-search-result-row">
                    <!-- 特殊説明会以外を表示 -->
                      <div v-show="i != 0 && (null_disp==false || (null_disp==true && jigo_no_list.indexOf(result.jigo_no) != -1))" class="vy-dotted" style="padding:5px 0"></div>
                      <div style="display: flex;flex-direction: row;" v-show="null_disp==false || (null_disp==true && jigo_no_list.indexOf(result.jigo_no) != -1)">
                        <div style="display: flex;align-items:center;padding-right: 10px;">
                          <input type="checkbox" style="width:20px;height:20px" class="form-check-input" v-bind:id="['set_jigo' + i]" v-bind:value=result.jigo_no  checked="checked" v-if="jigo_no_list.indexOf(result.jigo_no) != -1" name="jigo" v-on:change="Henshu_check()">
                          <input type="checkbox" style="width:20px;height:20px" class="form-check-input" v-bind:id="['set_jigo' + i]" v-bind:value=result.jigo_no  v-else name="jigo" v-on:change="Henshu_check()">
                        </div>
                        <div>
                          {{ result.jigo_name }}<br>
                          <b>開催日：</b>{{ DateSetting(result.kaisai_date) }} {{ TimeSetting(result.jikantai_start) }}～{{ TimeSetting(result.jikantai_end) }}&nbsp;&nbsp;
                          <b>場所：</b>{{ result.basyo }} <br>
                          <b>定員：</b>
                          <span v-if="result.teiin">{{ result.teiin }}名まで</span>
                          <span v-else-if="result.teiin == 9999">定員なし</span>
                          <br>
                          <b>参加の必要性：</b>
                          <span v-if="result.syomei_flg == 0">必要</span>
                          <span v-else-if="result.syomei_flg == 1">任意</span>
                        </div>
                      </div>
                  </div>
                  
                  <input type="checkbox" class="form-check-input" v-bind:id="['set_jigo0']" value=0 name="jigo" style="display:none">
                </form>
              </td>
            </tr>
            </template>
            </table>
          </div>
        </template>
        <table class="vy-form-table">
          <tr>
            <td colspan="2">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-md-auto">
                    <!-- 必須項目を全て入力済みの状態で押すと「Check」へ-->
                    <!-- 必須項目が未入力のものがある場合に押すと「InvalidSubmit」へ-->
                    <button id="hozon_button" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" >保存</button>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </Form>
       
      <!--
      <div id="detail_button_area">
          <button v-if="type==1" class="btn mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: white;color:black;border: 1px solid #000;" v-on:click="Change_jyokyo()">申込状況の確認</button>
      </div>-->
              
    <!-- 体験プログラムの受入先選択画面・モーダルウィンドウ -->
    <component v-if="facility_area"
               v-bind:is="contentFacility"
               v-bind:param="paramFacility"
               v-on:call="call"></component>
          
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

                
        <!-- 日程編集・モーダルウィンドウ -->
        <component v-if="nittei_area"
                v-bind:is="contentNittei"
                v-bind:param="paramNittei"
                v-on:call="call"></component>
    </article>
  </template>
  
  
  <script setup>
  
  /* eslint-disable */

  // 子コンポーネントの指定
  import MessageModal from './ShisetsuMessageModal.vue'  
  import ShakyoTaikenDetailNittei from '../Shakyo/Taiken/ShakyoTaikenDetailNittei.vue'
  import axios from 'axios'
  import { useRouter,useRoute } from 'vue-router'
  import { Field, Form, ErrorMessage } from 'vee-validate';
  import * as yup from 'yup';
  import { ref,computed,watchEffect,watch, onMounted, onUnmounted } from 'vue'
  import { DateSetting,TimeSetting,GlobalData  } from '../js/userdata_shisetsu.js'
  import { DateTimeSetting,youbi_irekae  } from '../js/userdata.js'
  import FacilitySelect from '../Shakyo/Taiken/ShakyoFacilitySelect.vue'//参加代行モーダルウィンドウ

// ボタンの表示状態を管理するフラグ（初期値は非表示）
const isButtonVisible = ref(false)

// キーボード入力を判定する関数
const handleKeyDown = (event) => {
  // F9キーが押されたか判定 (F1〜F12など、任意のキーに変更可能)
  if (event.key === 'F9') {
    // ブラウザ固有のF9キーの挙動（もしあれば）を無効化
    event.preventDefault()
    
    // 表示・非表示を反転（トグル）
    isButtonVisible.value = !isButtonVisible.value
  }
}

// コンポーネントがマウントされたらイベントリスナーを登録
onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
})

// コンポーネントが破棄される前にイベントリスナーを解除（メモリリーク対策）
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
})

  const contentNittei = ref('')// 表示する子コンポーネントの情報（日程編集ウィンドウ）
  contentNittei.value = null // 表示する子コンポーネント
  let paramNittei = {}//子コンポーネントに送る値の連想配列。中身は子コンポーネントに合わせて常に入れ替わる
  let nittei_area = ref(false)//表示・非表示フラグ

  const route = useRoute()
  
  const cityname = route.params.shakyo
  const facility_code = route.params.shisetsu

  // 詳細表示フラグ、文字色、太さ
  // 分類1（表示は固定） 0
  // 分類2 1
  // プログラム名（表示は固定） 2
  // 活動内容 3
  // 施設住所 4
  // 活動日数 5
  // 受入先からのコメント 6
  // 添付資料 7
  // その他（特記事項） 8
  // 参加費 9 ---- 施設・地域のみ
  // 検温等 10
  // マスク着用 11
  // 昼食 12
  // 持ち物 13
  // 制作・寄付活動条件 14 ---- 制作・寄付のみ
  // 届け先 15 ---- 制作・寄付のみ
  // 申込〆切日数 16 ---- 施設・地域のみ
  // 検便 17 ---- 施設・地域のみ
  // 開催地名 18
  // 連絡先 19
  // アクセス方法 20
  // 服装 21
  // 日程、開催期間 22 ---- 色・太さの関係で追加（表示は固定）
  // 申込〆切日時 23 ---- 色・太さの関係で追加（表示は固定）
  // 参加条件 24 ---- 色・太さの関係で追加（表示は固定）
  // 全体の定員 25 ---- 色・太さの関係で追加（表示は固定）
  // 一日の定員 26 ---- 施設・地域のみ 色・太さの関係で追加（表示は固定）
  // 参加の義務 27 ---- 施設・地域のみ 色・太さの関係で追加（表示は固定）
  let shosai_disp = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
  let shosai_color = ref(['black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black','black'])
  let shosai_bold = ref([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0])
  
  
  // 受付〆切日の種別（1:事業単位、2:プログラム単位)
  let end_shubetsu = ref(1)

  // 事前説明会・事後集会の実施フラグ 1なら実施
  let jizen_jisshi = ref(2)
  let jigo_jisshi = ref(2)
  
  // 削除ボタンを表示させるフラグ
  let delete_disp = ref(false)
  // チェックイン機能を利用するかどうかのフラグ。1：利用する、2：しない
  let checkin_flg = ref(2)

  let end_datetime = ref(new Date())
    //---------------- 社協英名から市区町村コードを取得
      axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {

            shosai_disp.value = response["data"].program_shosai_disp.split(',')
            shosai_color.value = response["data"].program_shosai_color.split(',')
            shosai_bold.value = response["data"].program_shosai_bold.split(',')

            end_shubetsu.value = response["data"].end_shubetsu
            GlobalData.choson_code = response["data"].choson_code

            let moshikomi_start = ""
            if(response["data"].moshikomi_start == ""){
              moshikomi_start = "00:00:00"
            }else{
              moshikomi_start = response["data"].moshikomi_start
            }
          
            let moshikomi_date = new Date(response["data"].moshikomi_date+" "+moshikomi_start)
            let today = new Date()
        
            moshikomi_date = moshikomi_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            moshikomi_date = new Date(moshikomi_date);
            moshikomi_date.setHours(moshikomi_date.getHours());

            // 今日が申込開始日より前なら削除可能
            if (moshikomi_date > today) {
                delete_disp.value = true;
            }
            checkin_flg.value = response["data"].checkin_flg
            jizen_jisshi.value = response["data"].jizen_jisshi
            jigo_jisshi.value = response["data"].jigo_jisshi

            // 受付〆切日の確認
            if(response["data"].end_date){
              let set_time = " 23:59:59"
              if(response["data"].end_time) {
                set_time = response["data"].end_time
              }
              let end_date = new Date(response["data"].end_date + " "+set_time)
              end_date = end_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
              end_date = new Date(end_date);
              end_date.setHours(end_date.getHours());
              end_datetime.value = end_date
            }

     }).catch(error => {

     })


    // タブ部分の背景色を切り替えるためのクラス
    let list_color = ref("tabgray")
    let calendar_color = ref("tabgray")
    let detail_color = ref("tabblue")

    // 現在開いているタブ（詳細）
    let TabActive = ref("")

    // 現在開いているタブ（編集の活動内容）
    let KatsudouActive = ref("main")
    let KatsudouActive_no = ref(9999)

    // 現在開いているタブ（日程）
    let NitteiActive = ref(0)

    // カレンダーで表示する月を算出するための変数（活動１）
    let calendar_hyoji_date = []
    let calendar_year = []
    let calendar_month = []
    let holiday_year_month = []
    let kaisai_start = []
    let kaisai_end = []
    
    // カレンダーで表示する月を算出するための変数（活動２～）
    let sub_calendar_hyoji_date = []
    let sub_calendar_year = []
    let sub_calendar_month = []
    let sub_holiday_year_month = []
    let sub_kaisai_start = []
    let sub_kaisai_end = []


  // 必須項目とエラーメッセージ（切替が発生するのでTaikenはリアクティブ変数にする）
  let schema = ref();

  // 制作・寄付以外の場合のエラー
  const schema_standard = yup.object({
    
    /*
    nissu_min: yup.string()
      .test("min_required",
            "",
            () => taiken_list.value.nissu_max >= taiken_list.value.nissu_min
      ),
    nissu_max: yup.string()
      .test("min_required",
            "活動日数の上限は下限と同じ、または、下限より大きい数字を入力してください",
            () => taiken_list.value.nissu_max >= taiken_list.value.nissu_min
    ),*/

    bunrui1: yup.string().required("分類1は必須項目です。"),
    name: yup.string().required("プログラム名は必須項目です。"),
   // shimekiri_day: yup.string().required("申込締切日は必須項目です。"),
   // shimekiri_time: yup.string().required("申込締切時間は必須項目です。"),
    naiyou: yup.string().required("活動内容は必須項目です。"),
    k_jusyo: yup.string().required("開催場所の住所は必須項目です。"),
  })

  // 制作・寄付の時のエラー
  const schema_seisaku = yup.object({

    todokesaki:yup.string().required("届け先は必須項目です。"),
    seisaku_teiin:yup.string().required("定員は必須項目です。"),

    bunrui1: yup.string().required("分類1は必須項目です。"),
    name: yup.string().required("プログラム名は必須項目です。"),
   // shimekiri_day: yup.string().required("申込締切日は必須項目です。"),
  //  shimekiri_time: yup.string().required("申込締切時間は必須項目です。"),
    naiyou: yup.string().required("活動内容は必須項目です。"),
    k_jusyo: yup.string().required("開催場所の住所は必須項目です。"),
    
  })

  // 初期は制作以外のvalidationを設定
  schema.value = schema_standard

  // エラーがあった要素のID
  let validation_error_id = ""
  
  
  // 親コンポーネント（Shakyotaiken.vue）から送られてきた値
  // taiken    ：体験プログラムの情報（配列）
  // nittei    ：体験プログラムの日程情報（配列×日程の数）  
  // sub       ：サブ体験プログラムの情報（配列×サブプログラムの数）
  // sub_nittei：体験プログラムの日程情報（配列×サブプログラムの数×日程の数） 
  // all_jizen ：体験プログラムに紐づかないものも含めた全事前説明会
  // all_jigo  ：体験プログラムに紐づかないものも含めた事後集会
  // type      ：このコンポーネントを利用するタイプ（0：新規登録、1：編集）
  // taiken_id ：表示中の体験プログラムのID
  // bunrui1   ：体験プログラム全体の「分類1」の配列（「Taiken_get」APIから取得したもの）
  // bunrui2   ：体験プログラム全体の「分類2」の配列（「Taiken_get」APIから取得したもの）
  // all_bunrui_list：体験プログラムに利用する分類1・2（「Category_read」APIから取得したもの）
  // gakusei_kbn_list：参加条件（学生区分）の利用可不可
  // gakusei_meisho_list：参加条件（学生区分）の名称
  // jyokyo    ：サブも含めた全プログラムの実績（参加状況）
  // shomei    ：証明書の索引リスト
  const props = defineProps(['param']);  

  let taiken_id = 0 // 表示するプログラムのID

  // 参加条件
  let gakusei_kbn_list = ref(props.param.gakusei_kbn_list)
  let gakusei_meisho_list = ref(props.param.gakusei_meisho_list)

  // DBに保存される参加条件は、名称に関わらず以下の順番で保管される
  const joken_kubun_name = {
    "小": 1,
    "中": 2,
    "高": 3,
    "高専":4,
    "専":5,
    "大": 6,
    "院":7,
    "一般":8
  };

  // 上記の小～一般を格納
  const joken_kubun_keys = Object.keys(joken_kubun_name)

  // 参加条件のカラム名格納（上記のjoken_kubun_nameと対応）
  const joken_kubun_db = {
    1: "joken_syogaku",
    2: "joken_chugaku",
    3: "joken_koukou",
    4: "joken_kousen",
    5: "joken_senmon",
    6: "joken_daigaku",
    7: "joken_daigakuin",
    8: "joken_sonota"
  };


  // 表示する値を配列として格納
  let taiken_list = ref([])
  if(props.param.taiken != undefined){
    taiken_list.value = props.param.taiken
    if(taiken_list.value.bunrui2 == ""){
      taiken_list.value.bunrui2 = "なし"
    }

    console.log(taiken_list.value.joken_all_start+"/"+taiken_list.value.joken_all_end)    
    if(taiken_list.value.joken_mongon == "" || taiken_list.value.joken_mongon == null){
      if(taiken_list.value.joken_all_start != null && taiken_list.value.joken_all_end != null){
        taiken_list.value.joken_mongon = createJokenText(taiken_list.value.joken_all_start,taiken_list.value.joken_all_end)
      }else{
        taiken_list.value.joken_mongon = "小学生～一般"
      }
    }

    console.log(taiken_list.value.nissu_mongon)
    
  }

  // サブ活動内容（活動2～）
  let sub_list = ref([])
  if(props.param.sub != undefined){
    sub_list.value = props.param.sub

    // 既存のサブ活動内容にはold（新規ではない）フラグを立てる
    for(let s = 0;s<sub_list.value.length;s++){
      sub_list.value[s].update_flg = 'old'
      
      if(sub_list.value[s].joken_mongon == "" || sub_list.value[s].joken_mongon == null){
        if(sub_list.value[s].joken_all_start != null && sub_list.value[s].joken_all_end != null){
          sub_list.value[s].joken_mongon = createJokenText(sub_list.value[s].joken_all_start,sub_list.value[s].joken_all_end)
        }
      }
      console.log(sub_list.value[s].nissu_mongon)
    
    }
  }

  // 証明書の索引リストを取得
  let shomei_list = ref([])
  if(props.param.shomei != undefined){
    shomei_list.value = props.param.shomei
  }

  // 削除対象のサブプログラム
  let delete_sub_list = ref([])

  let nittei_list = ref([]) // 日程全てのリスト
  // 表示する日程のリスト
  let disp_nittei_list = ref([])
  disp_nittei_list.value[0] = [{"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]
  let set_nittei_list = ref([]) // 日程選択方法が「1日ごと」の場合の日程リスト

  let sub_nittei_list = ref([]) // サブプログラム日程全てのリスト
  let sub_disp_nittei_list = ref([]) // サブプログラム表示する日程全てのリスト
  let sub_set_nittei_list = ref([]) // サブプログラムの日程選択方法が「1日ごと」の場合の日程リスト

  let all_jizen_list = ref([]) // 事前説明会（特殊を除く）
  all_jizen_list.value = props.param.all_jizen

  // 詳細に表示する事前説明会
  let jizen = ref([])
  let jizen_count = 0

  // このプログラムの事前説明会No.を格納する配列
  let taiken_jizen_no = ref([])

  let all_jigo_list = ref([]) // 事後集会
  all_jigo_list.value = props.param.all_jigo
  
  // 詳細に表示する事後集会
  let jigo = ref([])
  let jigo_count = 0

  // このプログラムの事後集会No.を格納する配列
  let taiken_jigo_no = ref([])

  let type = 0 // このコンポーネントを利用するタイプ（0：新規登録、1：編集）
  if(props.param.type != undefined){
    type = props.param.type
  }

  let jyokyo_list = [] // 日程一覧やカレンダーで利用する参加状況（実績データ）
  let jyokyo_ninzu = ref(0)
  console.log(props.param.jyokyo)
  if(props.param.jyokyo != undefined){
    jyokyo_list = props.param.jyokyo
    console.log(jyokyo_list[0][0])
    if(jyokyo_list[0][0]){
      console.log(jyokyo_list[0][0].ninzu)
      jyokyo_ninzu.value = jyokyo_list[0][0].ninzu
    }
  }

  // 申込める全ての日時を保存するリスト
  let moushikomi_list = ref([]) // メイン（活動１の日程配列のみ）
  let moushikomi_list_sub = ref([]) // サブ（配列の中に、さらに配列を複数個持つ）

  // 表示するカレンダー（htmlタグをそのまま記述）
  let Calendar = ref("") // メイン（活動１のhtmlタグのみ）
  let Calendar_sub = ref([]) // サブ（活動２以降のhtmlタグを配列に格納して複数個持つ）

  let mode = ref(0);// 0 = 確認、1 = 編集
  let title = ref("体験プログラム新規登録")
  
  // 締切日時から、〆切日と時間を作成する
  let shimekiri_day = ref("")
  let shimekiri_time = ref("")

  // 参加費、検便、昼食でテキストを入れる場合の代替変数
  let disp_sankahi = ref("")
  let disp_kenben = ref("")
  let disp_chusyoku = ref("")
  
  // 検温等・マスクでテキストを入れる場合の代替変数
  let disp_kensa = ref("")
  let disp_mask = ref("")
  
  // 参加条件でテキストを入れる場合の代替変数
  let disp_syogaku = ref("")
  let disp_chugaku = ref("")
  let disp_koukou = ref("")
  let disp_daigaku = ref("")
  let disp_kousen = ref("")
  let disp_senmon = ref("")
  let disp_daigakuin = ref("")

  // 新入力方法対応
  let disp_all_start = ref("")
  let disp_all_start_gakunen = ref(0)

  let disp_all_end = ref("")
  let disp_all_end_gakunen = ref(0)

  // サブの場合の代替変数
  let sub_shimekiri_day = ref([])
  let sub_shimekiri_time = ref([])
  let sub_disp_sankahi = ref([])
  let sub_disp_kenben = ref([])
  let sub_disp_chusyoku = ref([])

  // 検温等・マスクでテキストを入れる場合の代替変数
  let sub_disp_kensa = ref([])
  let sub_disp_mask = ref([])
  
  // sub_参加条件でテキストを入れる場合の代替変数
  let sub_disp_syogaku = ref([])
  let sub_disp_chugaku = ref([])
  let sub_disp_koukou = ref([])
  let sub_disp_daigaku = ref([])
  let sub_disp_kousen = ref([])
  let sub_disp_senmon = ref([])
  let sub_disp_daigakuin = ref([])
  
  // 新入力方法対応
  let sub_disp_all_start = ref([""])
  let sub_disp_all_start_gakunen = ref([0])

  let sub_disp_all_end = ref([""])
  let sub_disp_all_end_gakunen = ref([0])



  // 日数の入力に不備がある場合のエラーメッセージ
  let nissu_error = ref("")

  // データの無い項目を非表示にするフラグ
  let null_disp = ref(false) // デフォルトは非表示

  // 受入先選択画面
  let facility_area = ref(false)//表示・非表示フラグ
  const contentFacility = ref('')// 表示する子コンポーネントの情報（受入先エリア）
  contentFacility.value = null // 表示する子コンポーネント
  let paramFacility = {}//子コンポーネントに送る値の連想配列。中身は子コンポーネントに合わせて常に入れ替わる

  let facility = []
  let facility_name = ref("選択されていません。")
  let facility_id = 0
  let old_facility_id = taiken_list.value.facility_id == null ? 0 : taiken_list.value.facility_id

  // 編集の時は各値を格納する
  if(type == 1){

    title.value = "体験プログラム詳細"
    nittei_list.value = props.param.nittei

    // 同じグループの日程レコードをセットにするためのカウント
    let nittei_set_no = 0

    let before_nittei = []

    // 日程データの各曜日テキストを配列に直す
    for(let n = 0;n<nittei_list.value.length;n++){
      nittei_list.value[n]["kaisai_array"] = []
      if(nittei_list.value[n].kaisai_youbi != null && nittei_list.value[n].kaisai_youbi != ""){
        
        nittei_list.value[n].kaisai_youbi = nittei_list.value[n].kaisai_youbi.replace(/､/g, '、')
        nittei_list.value[n]["kaisai_array"] = nittei_list.value[n].kaisai_youbi.split("、")
      }

      nittei_list.value[n]["jogai_array"] = []
      if(nittei_list.value[n].jogai != null && nittei_list.value[n].jogai != ""){
        nittei_list.value[n].jogai = nittei_list.value[n].jogai.replace(/､/g, '、')
        nittei_list.value[n]["jogai_array"] = nittei_list.value[n].jogai.split("、")
      }


      // グループが前の日程と別の場合は現在のセットNo.を加算して区別する
      if(nittei_list.value[n]["nittei_group"] != before_nittei["nittei_group"]){
        nittei_set_no = nittei_set_no + 1
      }

      // 日程レコードに日程セットNo.を格納
      nittei_list.value[n]["nittei_set_no"] = nittei_set_no

      // 今の日程を格納
      before_nittei = nittei_list.value[n]
    }
    
    sub_nittei_list.value = props.param.sub_nittei

    // サブプログラムの数だけ日程データがある
    let sub_setting_list = [] // プログラム毎の日程（配列）
    for(let s = 0;s<sub_nittei_list.value.length;s++){

      moushikomi_list_sub.value[s] = []

      let program_nittei = [] // プログラムごとの日程を格納

      // サブの、時間帯以外が同じ日程レコードをセットにするためのカウント
      let nittei_set_no = 0
      let before_nittei = []

      // 日程データの各曜日テキストを配列に直す
      for(let n = 0;n<sub_nittei_list.value[s].length;n++){
        sub_nittei_list.value[s][n]["kaisai_array"] = []
        if(sub_nittei_list.value[s][n].kaisai_youbi != null && sub_nittei_list.value[s][n].kaisai_youbi != ""){
          
          sub_nittei_list.value[s][n].kaisai_youbi = sub_nittei_list.value[s][n].kaisai_youbi.replace(/､/g, '、')
          sub_nittei_list.value[s][n]["kaisai_array"] = sub_nittei_list.value[s][n].kaisai_youbi.split("、")
        }

        sub_nittei_list.value[s][n]["jogai_array"] = []
        if(sub_nittei_list.value[s][n].jogai != null && sub_nittei_list.value[s][n].jogai != ""){
          sub_nittei_list.value[s][n].jogai = sub_nittei_list.value[s][n].jogai.replace(/､/g, '、')
          sub_nittei_list.value[s][n]["jogai_array"] = sub_nittei_list.value[s][n].jogai.split("、")
        }

        // グループが前の日程と別の場合は現在のセットNo.を加算して区別する
        if(sub_nittei_list.value[s][n]["nittei_group"] != before_nittei["nittei_group"]){
          nittei_set_no = nittei_set_no + 1
        }

        // 日程レコードに日程セットNo.を格納
        sub_nittei_list.value[s][n]["nittei_set_no"] = nittei_set_no

        // 今の日程を格納
        before_nittei = sub_nittei_list.value[s][n]
        program_nittei[program_nittei.length] = before_nittei
      }
    }
    


    taiken_id =  props.param.taiken_id


    // 「種別」が未入力なら施設・体験とする
    if(taiken_list.value["shubetsu"] == null || taiken_list.value["shubetsu"] == ""){
      taiken_list.value["shubetsu"] = 1
    }

    
    // 参加条件のチェック
    // joken_all_start,joken_all_endともに「(区分):(学年)」で格納されているので「:」を軸にして配列に直し、取り出す
    disp_all_start.value = "小"
    disp_all_start_gakunen.value = 0

    if(taiken_list.value["joken_all_start"] != "" && taiken_list.value["joken_all_start"] != null){
        let start =  taiken_list.value["joken_all_start"].split(':');
        disp_all_start.value = start[0]
        disp_all_start_gakunen.value = start[1]
    }

    disp_all_end.value = "一般"
    disp_all_end_gakunen.value = 0
    if(taiken_list.value["joken_all_end"] != "" && taiken_list.value["joken_all_end"] != null){
        let end =  taiken_list.value["joken_all_end"].split(':');
        disp_all_end.value = end[0]
        disp_all_end_gakunen.value = end[1]
    }

      if(taiken_list.value["sankahi"] != "不要" && taiken_list.value["sankahi"] != null && taiken_list.value["sankahi"] != null){
        if(taiken_list.value["sankahi"] != "要"){
          disp_sankahi.value = taiken_list.value["sankahi"]
          taiken_list.value["sankahi"] = "要"
        }
      }else{
        taiken_list.value["sankahi"] = "不要"
      }
      if(taiken_list.value["kenben"] != "不要" && taiken_list.value["kenben"] != null && taiken_list.value["kenben"] != null){
        
        if(taiken_list.value["kenben"] != "要"){
          disp_kenben.value = taiken_list.value["kenben"]
          taiken_list.value["kenben"] = "要"
        }
      }else{
        taiken_list.value["kenben"] = "不要"
      }

      if(taiken_list.value["chusyoku"] != "不要" && taiken_list.value["chusyoku"] != null && taiken_list.value["chusyoku"] != ""){
        if(taiken_list.value["chusyoku"] != "要"){
          disp_chusyoku.value = taiken_list.value["chusyoku"]
          taiken_list.value["chusyoku"] = "要"
        }
      }else{
        taiken_list.value["chusyoku"] = "不要"
      }

      if(taiken_list.value["sankahi"] != "不要" && taiken_list.value["sankahi"] != null && taiken_list.value["sankahi"] != ""){
        
        if(taiken_list.value["sankahi"] != "要"){
          disp_sankahi.value = taiken_list.value["sankahi"]
          taiken_list.value["sankahi"] = "要"
        }
      }else{
        taiken_list.value["sankahi"] = "不要"
      }
      if(taiken_list.value["chusyoku"] != "不要" && taiken_list.value["chusyoku"] != null && taiken_list.value["chusyoku"] != ""){
        
        if(taiken_list.value["chusyoku"] != "要"){
          disp_chusyoku.value = taiken_list.value["chusyoku"]
          taiken_list.value["chusyoku"] = "要"
        }
      }else{
        taiken_list.value["chusyoku"] = "不要"
      }
      if(taiken_list.value["kensa"] != "不要" && taiken_list.value["kensa"] != null && taiken_list.value["kensa"] != ""){
        if(taiken_list.value["kensa"] != "要"){
          disp_kensa.value = taiken_list.value["kensa"]
          taiken_list.value["kensa"] = "要"
        }
      }else{
        taiken_list.value["kensa"] = "不要"
      }
      if(taiken_list.value["mask"] != "不要" && taiken_list.value["mask"] != null && taiken_list.value["mask"] != ""){
        
        if(taiken_list.value["mask"] != "要"){
          disp_mask.value = taiken_list.value["mask"]
          taiken_list.value["mask"] = "要"
        }
      }else{
        taiken_list.value["mask"] = "不要"
      }

      
    // 体験プログラムの割付事前説明会No.を取り出す
    if(taiken_list.value["jizenkensyu_no"] != "" && taiken_list.value["jizenkensyu_no"] != null){
      taiken_jizen_no.value = taiken_list.value["jizenkensyu_no"].split(',')
    }
    
    // 体験プログラムに設定された事前説明会No.を取り出す
    for(let i = 0;i < taiken_list.value.jizen.length;i++){

        let ok_flg = 0
        for(let t = 0;t<taiken_jizen_no.value.length;t++){
          if(taiken_jizen_no.value[t] == taiken_list.value.jizen[i]["jizen_no"]){
            ok_flg = 1
          }
        }

        if(ok_flg == 0){
          continue
        }

        jizen.value[jizen_count] = taiken_list.value.jizen[i];
        jizen_count++
    }
    
    // 体験プログラムの割付事後集会No.を取り出す
    if(taiken_list.value["jizenkensyu_no"] != "" && taiken_list.value["jizenkensyu_no"] != null){
        taiken_jigo_no.value = taiken_list.value["jizenkensyu_no"].split(',')
    }

    // 体験プログラムに設定された事後集会No.を取り出す
    for(let i = 0;i < taiken_list.value.jigo.length;i++){
        
        let ok_flg = 0
        for(let t = 0;t<taiken_jigo_no.value.length;t++){
          if(taiken_jigo_no.value[t] == taiken_list.value.jigo[i]["jigo_no"]){
            ok_flg = 1
          }
        }

        if(ok_flg == 0){
          continue
        }

        jigo.value[jigo_count] = taiken_list.value.jigo[i];
        jigo_count++

    }

      

    // サブの代替変数を処理
    for(let s = 0;s<sub_list.value.length;s++){
      
      // 参加条件のチェック
      // joken_all_start,joken_all_endともに「(区分):(学年)」で格納されているので「:」を軸にして配列に直し、取り出す
      sub_disp_all_start.value[s] = "小"
      sub_disp_all_start_gakunen.value[s] = 0

      if(sub_list.value[s]["joken_all_start"] != "" && sub_list.value[s]["joken_all_start"] != null){
          let start =  sub_list.value[s]["joken_all_start"].split(':');
          sub_disp_all_start.value[s] = start[0]
          sub_disp_all_start_gakunen.value[s] = start[1]
      }

      sub_disp_all_end.value[s] = "一般"
      sub_disp_all_end_gakunen.value[s] = 0
      if(sub_list.value[s]["joken_all_end"] != "" && sub_list.value[s]["joken_all_end"] != null){
          let end =  sub_list.value[s]["joken_all_end"].split(':');
          sub_disp_all_end.value[s] = end[0]
          sub_disp_all_end_gakunen.value[s] = end[1]
      }

      if(sub_list.value[s]["sankahi"] != "不要" && sub_list.value[s]["sankahi"] != null && sub_list.value[s]["sankahi"] != null){
        if(sub_list.value[s]["sankahi"] != "要"){
          sub_disp_sankahi.value[s] = sub_list.value[s]["sankahi"]
          sub_list.value[s]["sankahi"] = "要"
        }
      }else{
        sub_list.value[s]["sankahi"] = "不要"
      }
      if(sub_list.value[s]["kenben"] != "不要" && sub_list.value[s]["kenben"] != null && sub_list.value[s]["kenben"] != null){
        
        if(sub_list.value[s]["kenben"] != "要"){
          sub_disp_kenben.value[s] = sub_list.value[s]["kenben"]
          sub_list.value[s]["kenben"] = "要"
        }
      }else{
        sub_list.value[s]["kenben"] = "不要"
      }

      if(sub_list.value[s]["chusyoku"] != "不要" && sub_list.value[s]["chusyoku"] != null && sub_list.value[s]["chusyoku"] != ""){
        if(sub_list.value[s]["chusyoku"] != "要"){
          sub_disp_chusyoku.value[s] = sub_list.value[s]["chusyoku"]
          sub_list.value[s]["chusyoku"] = "要"
        }
      }else{
        sub_list.value[s]["chusyoku"] = "不要"
      }

      if(sub_list.value[s]["sankahi"] != "不要" && sub_list.value[s]["sankahi"] != null && sub_list.value[s]["sankahi"] != ""){
        
        if(sub_list.value[s]["sankahi"] != "要"){
          sub_disp_sankahi.value[s] = sub_list.value[s]["sankahi"]
          sub_list.value[s]["sankahi"] = "要"
        }
      }else{
        sub_list.value[s]["sankahi"] = "不要"
      }
      if(sub_list.value[s]["chusyoku"] != "不要" && sub_list.value[s]["chusyoku"] != null && sub_list.value[s]["chusyoku"] != ""){
        
        if(sub_list.value[s]["chusyoku"] != "要"){
          sub_disp_chusyoku.value[s] = sub_list.value[s]["chusyoku"]
          sub_list.value[s]["chusyoku"] = "要"
        }
      }else{
        sub_list.value[s]["chusyoku"] = "不要"
      }
      if(sub_list.value[s]["kensa"] != "不要" && sub_list.value[s]["kensa"] != null && sub_list.value[s]["kensa"] != ""){
        if(sub_list.value[s]["kensa"] != "要"){
          sub_disp_kensa.value[s] = sub_list.value[s]["kensa"]
          sub_list.value[s]["kensa"] = "要"
        }
      }else{
        sub_list.value[s]["kensa"] = "不要"
      }
      if(sub_list.value[s]["mask"] != "不要" && sub_list.value[s]["mask"] != null && sub_list.value[s]["mask"] != ""){
        
        if(sub_list.value[s]["mask"] != "要"){
          sub_disp_mask.value[s] = sub_list.value[s]["mask"]
          sub_list.value[s]["mask"] = "要"
        }
      }else{
        sub_list.value[s]["mask"] = "不要"
      }
    }
    
      
  }else{
    null_disp.value = false
    mode.value = 1
    // 新規登録の場合は事前に連想配列を作成
    taiken_list.value ={"taiken_no_text":"",
                       "shubetsu":1,
                        "bunrui1":null,
                       "bunrui2":null,
                       "name":null,
                       "title_image":null,
                       "s_disp":0,
                       "s_syurui":null,
                       "s_name":'',
                       "s_jusyo":'',
                       "s_tel":'',
                       "s_fax":'',
                       "s_email":'',
                       "s_tantou":'',
                       "s_comment":'',
                       "k_name":null,
                       "k_jusyo":null,
                       "k_tel":null,
                       "shimekiri_date":null,
                       "shimekiri_nissu":null,
                       "nissu_min":1,
                       "nissu_max":1,
                       "nissu_joken":2,
                       "nissu_douitsu":'false',
                       "nissu_jogai":'false',
                       "nissu_mongon":"1日",
                       "seisaku_joken":null,
                       "seisaku_teiin":null,
                       "teiin_mongon":"",
                       "all_teiin_flg":0,
                       "todokesaki":null,
                       "mochimono":null,
                       "fukusou":null,
                       "joken_syogaku":"〇",
                       "joken_chugaku":"〇",
                       "joken_koukou":"〇",
                       "joken_senmon":"〇",
                       "joken_kousen":"〇",
                       "joken_daigaku":"〇",
                       "joken_daigakuin":"〇",
                       "joken_sonota":"〇",
                       "joken_all_start":"",
                       "joken_all_end":"",
                       "joken_mongon":"",
                       "sankahi":"不要",
                       "kensa":'不要',
                       "kenben":'不要',
                       "mask":'不要',
                       "chusyoku":"不要",
                       "jizenkensyu_no":"",
                       "jigosyukai_no":"",
                       "shiryo_setsumei":"",
                       "shiryo_url":"",
                       "bikou":null,
                       "shomeisho":0,
                       "google_form":1,
                       "hissu_flg":0,
                       "teiin_settei":0,
                       "teiin_oneday":1,
                       "nittei_sentaku":0,
                      "choson_code":GlobalData.choson_code}

    nittei_list.value[0] = {"kaisai_start":"",
                            "kaisai_end":"",
                            "jikantai_start":"",
                            "jikantai_end":"",
                            "kaisai_youbi":"",
                            "jogai":"",
                            "jogai_date":"",
                            "teiin":null,
                            "teiin_mongon":"",
                            "comment":"",
                            "nittei_group":"1",
                            "nittei_set_no":0,
                            "jogai_array":[],
                            "kaisai_array":[]}
    
  }

  let jizen_no = taiken_list.value["jizenkensyu_no"]
  let jizen_no_list = ref([])

  let jigo_no = taiken_list.value["jigosyukai_no"]
  let jigo_no_list = ref([])

  if(route.params.cmd == "add"){

    for(let i = 0;i<all_jizen_list.value.length;i++){
      let jizen_kobetsu = all_jizen_list.value[i]
      jizen_no_list.value[i] = jizen_kobetsu.jizen_no
    }
    for(let i = 0;i<all_jigo_list.value.length;i++){
      let jigo_kobetsu = all_jigo_list.value[i]
      jigo_no_list.value[i] = jigo_kobetsu.jigo_no
    }

              
  }else{

    if(taiken_list.value["jizenkensyu_no"] != "" && taiken_list.value["jizenkensyu_no"] != null){
      jizen_no_list.value = jizen_no.split(",").map(Number)
    }
    
    if(taiken_list.value["jigosyukai_no"] != "" && taiken_list.value["jigosyukai_no"] != null){
      jigo_no_list.value = jigo_no.split(",").map(Number)
    }
  }

  // プルダウンメニューに表示する値を配列として格納
  let bunrui1_list = ref([])
  let bunrui2_list = ref([])
  let all_bunrui_list = props.param.all_bunrui_list

  // 分類2を格納
  if(all_bunrui_list){
    for(let b2 = 0;b2<all_bunrui_list.length;b2++){
      if(all_bunrui_list[b2].bunrui == 2){
        bunrui2_list.value[bunrui2_list.value.length] = all_bunrui_list[b2]
      }
    }
  }
  // 分類1によって絞り込まれた分類2のリスト
  let bunrui2_list_Extract = ref([])

  // 日程から、表示する開催期間を作成する配列、その数、実際に表示する変数
  let disp_kaisai_array = []
  let disp_kaisai_count = 0
  let disp_kaisai_text = ""

  // 曜日配列
  const youbi_list = ["日","月","火","水","木","金","土","祝"]
  
  // プログラムの種別配列
  const shubetsu_list = ["（未設定）","施設・地域活動","制作・寄付活動"]
  
  // 参加の義務の配列
  const hissu_list = ["任意","必須","条件付き"]

  // 定員の扱いの配列
  const teiin_list = ["時間帯ごと","1日ごと"]

  // 日程選択方法の配列
  const nittei_sentaku_list = ["参加日ごと","日程ごと"]

  /* メッセージを表示するモーダルウィンドウ */
  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  const router = useRouter();
  
  /* 入力確認用変数 */
  let henshu_flg = ref(0) // 1項目でも編集されていたら「1」に変更
  let nittei_sanka_flg = ref(0) // 1日程/1参加条件でも編集されていたら「1」に変更

  /* コンポーネントの表示に関わる処理 */
  
  // タブをクリックしたときの処理
  let TabSelect = function(id){
   // 選択したタブに切り替える（タブ側ではv-ifで表示・非表示を制御）
    TabActive.value = id

    // いったんすべてのタブの背景を灰色にする（事前にtabgrayクラスを用意）
    calendar_color.value = "tabgray"
    detail_color.value = "tabgray"
    list_color.value = "tabgray"
    
    // アクティブになるタブを青に変更（事前にtabblueクラスを用意）
    if(id == 'tab_list'){
        // 日程一覧を表示
        list_color.value = "tabblue"
    }else if(id == 'tab_calendar'){
        // カレンダーを表示
        calendar_color.value = "tabblue"
    }else if(id == 'tab_detail'){
        // 詳細を表示
        detail_color.value = "tabblue"
        
    }
  }

  // 編集モードへ変更
  let Change_henshu = function(){
    mode.value = 1;
    title.value = "体験プログラム編集"
    null_disp.value = false// 未入力項目も強制的に表示

    // 編集モードに切り替えたことを親コンポーネントにも伝える    
    emit('call',{cmd:'detai_edit_change'});
  }
  // 確認モードへ変更
  let Change_detail = function(){

    if(henshu_flg.value == 1 || nittei_sanka_flg.value == 1){
      if(!window.confirm("確認に戻りますか？\n※編集した内容は保存されません。")) return;
      title.value = "体験プログラム詳細"
    }
    
    // 親コンポーネントから再表示してもらう
    emit('call',{cmd:'return_detail',id0:taiken_id});

  }

  /* コンポーネントの表示に関わる処理 */
  let Return_home = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")

  }
  // パンくずリストのクリックで詳細コンポーネントから検索コンポーネントに戻す
  let Return_list = function(){
    router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu")
  }

  // ボタンクリックで詳細コンポーネントからメッセージ・キャンセルコンポーネントに変更
  let rireki_disp = function(){
      router.push("/"+GlobalData.shakyo+"/"+route.params.shisetsu+"/Shisetsu/rireki_search/"+taiken_id)
    // 親コンポーネントへ切替命令を送る
//    emit('call',{cmd:'rireki_search',program_id:taiken_id});
  }
  
  /* 親コンポーネントに関わる関数 */
  const emit = defineEmits(['call'])

  // 登録または更新する
  let Send = function() {
    // メイン

    if(type == 1){
      if(taiken_list.value["taiken_no_text"] == "" || taiken_list.value["taiken_no_text"] == null){
          taiken_list.value["taiken_no_text"] = taiken_list.value["taiken_no"]
        
      }
    }
    /*
    if(taiken_list.value["joken_syogaku"] == "指定"){
      taiken_list.value["joken_syogaku"] = disp_syogaku.value
    }
    if(taiken_list.value["joken_chugaku"] == "指定"){
      taiken_list.value["joken_chugaku"] = disp_chugaku.value
    }
    if(taiken_list.value["joken_koukou"] == "指定"){
      taiken_list.value["joken_koukou"] = disp_koukou.value
    }
    if(taiken_list.value["joken_senmon"] == "指定"){
      taiken_list.value["joken_senmon"] = disp_senmon.value
    }
    if(taiken_list.value["joken_kousen"] == "指定"){
      taiken_list.value["joken_kousen"] = disp_kousen.value
    }
    if(taiken_list.value["joken_daigaku"] == "指定"){
      taiken_list.value["joken_daigaku"] = disp_daigaku.value
    }
    if(taiken_list.value["joken_daigakuin"] == "指定"){
      taiken_list.value["joken_daigakuin"] = disp_daigakuin.value
    }
    */

    // 参加条件  
    if(disp_all_start.value != "" && disp_all_start.value != null){
        taiken_list.value["joken_all_start"] = disp_all_start.value +":"+disp_all_start_gakunen.value 
    }

    if(disp_all_end.value != 0 && disp_all_end.value != null){
      taiken_list.value["joken_all_end"] = disp_all_end.value +":"+disp_all_end_gakunen.value 
    }

    let joken_array = JokenAvailability(taiken_list.value["joken_all_start"],taiken_list.value["joken_all_end"])
    taiken_list.value["joken_syogaku"] = joken_array["joken_syogaku"]
    taiken_list.value["joken_chugaku"] = joken_array["joken_chugaku"]
    taiken_list.value["joken_koukou"] = joken_array["joken_koukou"]
    taiken_list.value["joken_daigaku"] = joken_array["joken_daigaku"]
    taiken_list.value["joken_sonota"] = joken_array["joken_sonota"]

    if(taiken_list.value["sankahi"] == "要"){
      if(disp_sankahi.value != "" && disp_sankahi.value != null){
        taiken_list.value["sankahi"] = disp_sankahi.value
      }
    }
    if(taiken_list.value["kensa"] == "要"){
      if(disp_kensa.value != "" && disp_kensa.value != null){
        taiken_list.value["kensa"] = disp_kensa.value
      }
    }
    if(taiken_list.value["kenben"] == "要"){
      if(disp_kenben.value != "" && disp_kenben.value != null){
        taiken_list.value["kenben"] = disp_kenben.value
      }
    }


    if(taiken_list.value["mask"] == "要"){
      if(disp_mask.value != "" && disp_mask.value != null){
        taiken_list.value["mask"] = disp_mask.value
      }

    }
    if(taiken_list.value["chusyoku"] == "要"){
      if(disp_chusyoku.value != "" && disp_chusyoku.value != null){
        taiken_list.value["chusyoku"] = disp_chusyoku.value
      }
    }

    if(taiken_list.value.shubetsu == 1){
      // 制作・寄付ではない場合、関係する項目を削除
      taiken_list.value.seisaku_joken = ""
      taiken_list.value.todokesaki = ""
      // 全体の定員を利用しない場合は空にする
      if(taiken_list.value.all_teiin_flg == 0){
        taiken_list.value.seisaku_teiin = null
      }
    }

    // 〆切日が空欄であればDB内の〆切日時も空欄にする
    if(shimekiri_day.value == null || shimekiri_day.value == ""){
      taiken_list.value["shimekiri_date"] = null
    }else{
      let set_shimekiri_date = ""
      set_shimekiri_date = shimekiri_day.value +" "
      if(shimekiri_time.value == null || shimekiri_time.value == ""){
        set_shimekiri_date += "23:59:59"
      }else{
        set_shimekiri_date += shimekiri_time.value
      }
      taiken_list.value["shimekiri_date"] = set_shimekiri_date
    }

    // 受入先
    if(facility_id != old_facility_id){
      taiken_list.value["facility_id"] = facility_id
    }

    // サブ
    for(let s = 0;s<sub_list.value.length;s++){
      
      // 参加条件  
      if(sub_disp_all_start.value[s] != "" && sub_disp_all_start.value[s] != null){
          sub_list.value[s]["joken_all_start"] = sub_disp_all_start.value[s] +":"+sub_disp_all_start_gakunen.value[s]
      }

      if(sub_disp_all_end.value[s] != 0 && disp_all_end.value != null){
        sub_list.value[s]["joken_all_end"] = sub_disp_all_end.value[s]+":"+sub_disp_all_end_gakunen.value[s] 
      }

      let joken_array = JokenAvailability(sub_list.value[s]["joken_all_start"],sub_list.value[s]["joken_all_end"])
      sub_list.value[s]["joken_syogaku"] = joken_array["joken_syogaku"]
      sub_list.value[s]["joken_chugaku"] = joken_array["joken_chugaku"]
      sub_list.value[s]["joken_koukou"] = joken_array["joken_koukou"]
      sub_list.value[s]["joken_daigaku"] = joken_array["joken_daigaku"]
      sub_list.value[s]["joken_sonota"] = joken_array["joken_sonota"]

      if(sub_list.value[s]["sankahi"] == "要"){
        if(sub_disp_sankahi.value[s] != "" && sub_disp_sankahi.value[s] != null){
          sub_list.value[s]["sankahi"] = sub_disp_sankahi.value[s]
        }
      }
      if(sub_list.value[s]["kensa"] == "要"){
        if(sub_disp_kensa.value[s] != "" && sub_disp_kensa.value[s] != null){
          sub_list.value[s]["kensa"] = sub_disp_kensa.value[s]
        }
      }
      if(sub_list.value[s]["kenben"] == "要"){
        if(sub_disp_kenben.value[s] != "" && sub_disp_kenben.value[s] != null){
          sub_list.value[s]["kenben"] = sub_disp_kenben.value[s]
        }
      }

      if(sub_list.value[s]["mask"] == "要"){
        if(sub_disp_mask.value[s] != "" && sub_disp_mask.value[s] != null){
          sub_list.value[s]["mask"] = sub_disp_mask.value[s]
        }
      }
      if(sub_list.value[s]["chusyoku"] == "要"){
        if(sub_disp_chusyoku.value[s] != "" && sub_disp_chusyoku.value[s] != null){
          sub_list.value[s]["chusyoku"] = sub_disp_chusyoku.value[s] 
        }
      }

      if(taiken_list.value.shubetsu == 1){
        // 制作・寄付ではない場合、関係する項目を削除
        sub_list.value[s].seisaku_joken = ""
        sub_list.value[s].todokesaki = ""
 //       sub_list.value[s].seisaku_teiin = null
      }

      // 〆切日が空欄であればDB内の〆切日時も空欄にする
      if(sub_shimekiri_day.value[s] == null || sub_shimekiri_day.value[s] == ""){
        sub_list.value[s]["shimekiri_date"] = null
      }else{
        let set_shimekiri_date = ""
        set_shimekiri_date = sub_shimekiri_day.value[s] +" "
        if(sub_shimekiri_time.value[s] == null || sub_shimekiri_time.value[s] == ""){
          set_shimekiri_date += "23:59:59"
        }else{
          set_shimekiri_date += sub_shimekiri_time.value[s]
        }
        sub_list.value[s]["shimekiri_date"] = set_shimekiri_date

      }
    }



    // 親コンポーネントへ更新or新規登録内容を送る
    emit('call',{cmd:'update',
                taiken_result:taiken_list.value,
                nittei_result:nittei_list.value,
                sub_result:sub_list.value,
                sub_nittei_result:sub_nittei_list.value,
                delete_sub_result:delete_sub_list.value
              });

  }

  // 体験プログラム情報を削除する
  let Delete_set = function() {
    emit('call',{cmd:'delete'});
  }
  
  /* その他の関数 */

  // 活動条件関係の文言入力
  
  // 日程選択方法の変更
  let nittei_sentaku_change = function(program_num){
    // 日程選択方法を日程ごとにする場合は定員の扱いは日時ごとに固定
    if(program_num == 9999){
      // メインの場合
      if(taiken_list.value.nittei_sentaku == 1){
        taiken_list.value.teiin_settei = 0
      }
    }else{
      // サブの場合
      if(sub_list.value[program_num].nittei_sentaku == 1){
        sub_list.value[program_num].teiin_settei = 0
      }
      
    }
  }
  
  // 活動日数を変更した時
  let nissu_change = function(program_num){
    
    let check_program = taiken_list.value
    if(program_num == 9999){
      // メインの場合
      check_program = taiken_list.value
    }else{
      // サブの場合
      check_program = sub_list.value[program_num]
    }

    let set_mongon = ""

    if(check_program.nissu_min == check_program.nissu_max){
      set_mongon += check_program.nissu_min  + "日"
    }else if(check_program.nissu_min != check_program.nissu_max){
      if(check_program.nissu_max == '' ||  check_program.nissu_max == null  ||  check_program.nissu_max < 0){
        set_mongon += check_program.nissu_min  + "日以上"

      }else if(check_program.nissu_min == '' ||  check_program.nissu_min == null　||  check_program.nissu_min < 0){
        set_mongon += check_program.nissu_max  + "日以下"

      }else{

        set_mongon += check_program.nissu_min  + "～" + check_program.nissu_max +"日"
      }
    }
    
    if(check_program.nissu_joken == 1){
      set_mongon += "連続"
      if(check_program.nissu_jogai == "false" || check_program.nissu_jogai == false){
          set_mongon += "（除外日・除外曜日の飛ばし不可）"
      }
    }

    check_program.nissu_mongon = set_mongon

  }

  // 定員設定を変更した時
  let teiin_settei_change = function(program_num){
    let check_program = taiken_list.value
    if(program_num == 9999){
      // メインの場合
      check_program = taiken_list.value
    }else{
      // サブの場合
      check_program = sub_list.value[program_num]
    }
    
    if(check_program.teiin_settei == 0){
      for(let num = 0;num<3;num++){
        teiin_change(num,program_num)
      }
    }else{
      teiin_oneday_change(program_num)
    }
  }

  // 日程ごとの定員を変更したときに文言も変更する
  let teiin_change = function(num,program_num){
    if(program_num == 9999){ 
      // メインの場合
      let check_teiin = disp_nittei_list.value[NitteiActive.value][num].teiin
      if(check_teiin && check_teiin != null && check_teiin != ''){
        disp_nittei_list.value[NitteiActive.value][num].teiin_mongon = check_teiin + "名まで"
      }
    }else{
      // サブの場合
      let check_teiin = sub_disp_nittei_list.value[program_num][NitteiActive.value][num].teiin
      if(check_teiin && check_teiin != null && check_teiin != ''){
        sub_disp_nittei_list.value[program_num][NitteiActive.value][num].teiin_mongon = check_teiin + "名まで"
      }
    }
    
  }

  // 1日の定員を変更したときに文言も変更する
  let teiin_oneday_change = function(program_num){
    if(program_num == 9999){ 
      // メインの場合
      if(taiken_list.value.teiin_oneday){
        taiken_list.value.teiin_mongon = "1日" + taiken_list.value.teiin_oneday + "名まで"
      }
    }else{
      // サブの場合
      if(sub_list.value[program_num].teiin_oneday){
        sub_list.value[program_num].teiin_mongon = "1日" + sub_list.value[program_num].teiin_oneday + "名まで"
      }
    }
  }
  
  // 開催曜日を設定する
  // y ：選択した曜日の番地
  // num ：曜日を選択した日程の番地
  // program_num：編集中の活動の番地
  let set_kaisai_youbi = function(y,num,program_num){

    // チェックした活動の日程の曜日
    let set_elm = document.getElementById("kaisai_youbi"+String(program_num)+String(y)+String(num))

      let check_list = []
      if(program_num == 9999){
        // メインの場合
        check_list = disp_nittei_list.value[NitteiActive.value][0]
      }else{
        // サブの場合
        check_list = sub_disp_nittei_list.value[program_num][NitteiActive.value][0]
      }

      console.log(check_list)
      // 除外曜日が一つでも選択されている場合はチェックを外してreturn     
      if(check_list["jogai_array"].length != 0){
        set_elm.checked = false
        return
      }


      if(set_elm.checked){
        check_list["kaisai_array"][check_list["kaisai_array"].length] = set_elm.value 
      }else{
        let re_count = 0;
        let re_array = []
        for(let n = 0;n<check_list["kaisai_array"].length;n++){
          if(check_list["kaisai_array"][n] != set_elm.value){
            re_array[re_count] = check_list["kaisai_array"][n]
            re_count++
          }
        }

        check_list["kaisai_array"] = re_array
      }

      check_list["kaisai_youbi"] = check_list["kaisai_array"].join("、")

      // 開催曜日が一つでも選択されている場合は除外曜日を選択不可にする    
      for(let k = 0;k<youbi_list.length;k++){
        let set_elm = document.getElementById("jogai_youbi"+String(program_num)+String(k)+String(num))
        if(check_list["kaisai_array"].length != 0){
            set_elm.checked = false
            set_elm.disabled = true;
        }else{
            set_elm.disabled = false;
        }
      }
  }

  // 除外曜日を設定する
  // y ：選択した曜日の番地
  // num ：曜日を選択した日程の番地
  // program_num：編集中の活動の番地
  let set_jogai_youbi = function(y,num,program_num){

      let set_elm = document.getElementById("jogai_youbi"+String(program_num)+String(y)+String(num))
      
      let check_list = []
      if(program_num == 9999){
        // メインの場合
        check_list = disp_nittei_list.value[NitteiActive.value][0]
      }else{
        // サブの場合
        check_list = sub_disp_nittei_list.value[program_num][NitteiActive.value][0]
      }

      // 開催曜日が一つでも選択されている場合はチェックを外してreturn     
      if(check_list["kaisai_array"].length != 0){
        set_elm.checked = false
        return
      }

      if(set_elm.checked){
        check_list["jogai_array"][check_list["jogai_array"].length] = set_elm.value 
      }else{
        let re_count = 0;
        let re_array = []
        for(let n = 0;n<check_list["jogai_array"].length;n++){
          if(check_list["jogai_array"][n] != set_elm.value){
            re_array[re_count] = check_list["jogai_array"][n]
            re_count++
          }
        }
        check_list["jogai_array"] = re_array
      }
      check_list["jogai"] = check_list["jogai_array"].join("、")

      // 除外曜日が一つでも選択されている場合は開催曜日を選択不可にする    
      for(let k = 0;k<youbi_list.length;k++){
        let set_elm = document.getElementById("kaisai_youbi"+String(program_num)+String(k)+String(num))
        if(check_list["jogai_array"].length != 0){
            set_elm.checked = false
            set_elm.disabled = true;
        }else{
            set_elm.disabled = false;
        }
      }

  }

  // 参加条件の大小をチェック（先に来る区分が小さくなければならない）
  function kubunCheck(start,end){
    if (!start) return 1;

    const [startKubun] = start;
    const startOrder = joken_kubun_name[startKubun];

    let endOrder = null;

    if (end) {
      const [endKubun] = end;
      endOrder = joken_kubun_name[endKubun];
    }

    // 区分大小チェック（start > end は不正なのでここで終了）
    if (endOrder !== null && startOrder > endOrder) {
      return 1 
    }
    return 0

  }

  // 参加条件を切り替えたときにデフォルトテキストを挿入
  // s     ：taisho == 'sub'の場合の番地
  // taisho：main or sub
  function Joken_change(s,taisho){

    if(taisho == 'main'){
      taiken_list.value["joken_all_start"] = disp_all_start.value +":"+disp_all_start_gakunen.value 
      taiken_list.value["joken_all_end"] = disp_all_end.value +":"+disp_all_end_gakunen.value 
      taiken_list.value["joken_mongon"] = createJokenText(taiken_list.value["joken_all_start"], taiken_list.value["joken_all_end"])
    }else{
      sub_list.value[s]["joken_all_start"] = sub_disp_all_start.value[s] +":"+sub_disp_all_start_gakunen.value[s]
      sub_list.value[s]["joken_all_end"] = sub_disp_all_end.value[s] +":"+sub_disp_all_end_gakunen.value[s]
      sub_list.value[s]["joken_mongon"] = createJokenText(sub_list.value[s]["joken_all_start"], sub_list.value[s]["joken_all_end"])

    }

  }

  // 参加条件をテキスト化
  function createJokenText(startText, endText) {


    const STUDENT_LABEL = {
      '小': gakusei_meisho_list.value[0],
      '中': gakusei_meisho_list.value[1],
      '高': gakusei_meisho_list.value[2],
      '高専': gakusei_meisho_list.value[3],
      '専': gakusei_meisho_list.value[4],
      '大': gakusei_meisho_list.value[5],
      '院': gakusei_meisho_list.value[6],
      '一般': '一般'
    };

    const parse = (text) => {
      const [kubun, gradeStr] = text.split(':');
      return { kubun, grade: Number(gradeStr) };
    };
    const start = parse(startText);
    const end = parse(endText);

    if((start.kubun == null || end.kubun == null) || 
      (start.kubun == '' || end.kubun == '') || 
      (start.kubun == undefined || end.kubun == undefined) || 
      (start.kubun == "undefined" || end.kubun == "undefined")){
      return
    }
    // 一般のみ
    if (start.kubun === '一般' && end.kubun === '一般') {
      return '一般';
    }

    // 開始と終了が異なる → 常に「～」
    if (startText !== endText) {


      const startLabel =
        start.grade > 0
          ? `${STUDENT_LABEL[start.kubun]}${start.grade}年生`
          : STUDENT_LABEL[start.kubun];

      const endLabel =
        end.grade > 0
          ? `${STUDENT_LABEL[end.kubun]}${end.grade}年生`
          : STUDENT_LABEL[end.kubun];

    
      return `${startLabel}～${endLabel}`;
    }

    // 同一区分・同一学年
    if (start.grade > 0) {
      return `${STUDENT_LABEL[start.kubun]}${start.grade}年生`;
    }

    // 同一区分・学年なし
    return STUDENT_LABEL[start.kubun];
  }

  // joken_all_startとjoken_all_endのテキストを分解
  function parseKubunText(text) {
    const [kubun, gradeStr] = text.split(':');
    return {
      kubun,
      grade: Number(gradeStr)
    };
  }


  // joken_all_startとjoken_all_endを比較して、各検索条件に入力する値（〇 or ー）を判定する
  function JokenAvailability(startValue, endValue) {
    console.log(startValue+"～"+endValue)
    // 初期化（全部「ー」）
    const result = {
      joken_syogaku: "ー",
      joken_chugaku: "ー",
      joken_koukou: "ー",
      joken_kousen:"ー",
      joken_senmon:"ー",
      joken_daigaku: "ー",
      joken_daigakuin: "ー",
      joken_sonota: "ー"
    };

    if (!startValue) return result;

    const [startKubun] = startValue.split(":");
    const startOrder = joken_kubun_name[startKubun];

    let endOrder = null;

    if (endValue) {
      const [endKubun] = endValue.split(":");
      endOrder = joken_kubun_name[endKubun];
    }
    

    // 全区分を走査
    for (const order in joken_kubun_db) {
      const o = Number(order);

      // start 以上
      if (o >= startOrder) {
        // end 未指定 or end 以下
        if (endOrder === null || o <= endOrder) {
          const dbField = joken_kubun_db[o];
          result[dbField] = "〇";
        }
      }
    }

    return result;
  }


  // 表示中の体験プログラム情報をもとに証明書のプレビューを行う
  let ShomeiPreview = function(){

      // 親コンポーネントへ証明書プレビュー命令とID・証明書No.を送る
      emit('call',{cmd:'shomei_preview',
                taiken_id:taiken_list.value.taiken_id,
                shomei_no:taiken_list.value.shomeisho
              });
  }

  // 種別を変更した時、選択できる分類1と2を変更する
  let shubetsu_change = function(){

    // 現在選択中の分類2は未入力状態
    taiken_list.value.bunrui2 = ""
    // 表示する分類1リストを初期化
    bunrui1_list.value = []
    // 表示する分類2リストを初期化
    bunrui2_list_Extract.value = []

    // 種別を設定する
    shubetsu_setting()
    
  }

    // 種別を設定する
  let shubetsu_setting = function(){

    // 種別が全てなら、分類1・2も全て格納する
    if(taiken_list.value.shubetsu == 0){
      for(let b1 = 0;b1<all_bunrui_list.length;b1++){
        if(all_bunrui_list[b1].bunrui == 1){
          bunrui1_list.value[bunrui1_list.value.length] = all_bunrui_list[b1]["name"]
        }
      }
      for(let b2 = 0;b2<bunrui2_list.value.length;b2++){
        bunrui2_list_Extract.value[bunrui2_list_Extract.value.length] = bunrui2_list.value[b2]["name"]
      }
    }else{

      // 種別が絞り込まれていた場合、その種別のみ格納する
      for(let b1 = 0;b1<all_bunrui_list.length;b1++){
        if(all_bunrui_list[b1].bunrui == 1 && all_bunrui_list[b1].shubetsu == taiken_list.value.shubetsu){
          bunrui1_list.value[bunrui1_list.value.length] = all_bunrui_list[b1]["name"]
        }
      }
      for(let b2 = 0;b2<bunrui2_list.value.length;b2++){
        if(bunrui2_list.value[b2].shubetsu == taiken_list.value.shubetsu){
          bunrui2_list_Extract.value[bunrui2_list_Extract.value.length]  = bunrui2_list.value[b2]["name"]
        }
      }
    }

  }

  // 分類1を変更した時、選択できる分類2を変更する
  let bunrui1_change = function(){

    // 現在選択中の分類2は未入力状態
    taiken_list.value.bunrui2 = ""
    bunrui1_list_set()
  }

  // 分類1に応じて分類2を絞り込む
  let bunrui1_list_set = function(){

    // 表示する分類2リストを初期化
    bunrui2_list_Extract.value = []
    /*
    for(let b2 = 0;b2 < bunrui2_list.value.length;b2++){
        // 所属する種別のみ格納する
        if(bunrui2_list.value[b2].shubetsu == taiken_list.value.shubetsu){
          // 分類1に所属する分類2を表示する
          if(taiken_list.value.bunrui1 == bunrui2_list.value[b2]["bunrui1_name"]){
            bunrui2_list_Extract.value[bunrui2_list_Extract.value.length] = bunrui2_list.value[b2]["name"]
          }
        }
    }
    */
    
      for(let a = 0;a<all_bunrui_list.length;a++){
        if(all_bunrui_list[a].bunrui == 2){
          if(taiken_list.value.bunrui1 == all_bunrui_list[a]["bunrui1_name"] ){
            bunrui2_list_Extract.value[bunrui2_list_Extract.value.length] = all_bunrui_list[a]["name"]
          }
        }
      }
  }

  // 受入先・コメントのテキストエリアの改行
  let NewLine_ukeire = function() {
    taiken_list.value.s_comment = `${taiken_list.value.s_comment}\n`;
  }
  // 活動内容のテキストエリアの改行
  let NewLine_naiyou = function(num) {
    if(num == 9999){
      taiken_list.value.naiyou = `${taiken_list.value.naiyou}\n`;
    }else{
      sub_list.value[s].naiyou = `${sub_list.value[s].naiyou}\n`;

    }
  }
  // その他のテキストエリアの改行
  let NewLine_bikou = function() {
    taiken_list.value.bikou = `${taiken_list.value.bikou}\n`;
  }
  // 申込者限定情報のテキストエリアの改行
  let NewLine_s_bikou = function() {
    taiken_list.value.s_bikou = `${taiken_list.value.s_bikou}\n`;
  }

  // 制作・寄付　←→　施設・体験の切替
  let change_seisaku = function(){
      if(taiken_list.value.shubetsu == 2){
        // 制作のvalidationを設定
        schema.value = schema_seisaku
      }else{
        // 施設・体験のvalidationを設定
        schema.value = schema_standard
      }
  }


  // 表示用の日程をセッティングする（すべて）
  let disp_nittei_list_setting = function(){
    disp_nittei_list.value = [] // 初期化
    //
    // 日程レコードに日程セットNo.を格納
    let once_list = [
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]
    let before_no = 1
    let once_count = 0
    for(let n = 0;n<nittei_list.value.length;n++){
      if(n != 0 && nittei_list.value[n]["nittei_set_no"] != before_no){
        disp_nittei_list.value[disp_nittei_list.value.length] = once_list
        once_list = [
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]
        once_count = 0
      }
      once_list[once_count] = nittei_list.value[n]
      before_no = nittei_list.value[n]["nittei_set_no"]
      once_count++

      if((n+1) == nittei_list.value.length){
        disp_nittei_list.value[disp_nittei_list.value.length] = once_list
      }
    }
    

    sub_disp_nittei_list.value = [] // 初期化
    // サブ
    for(let s = 0;s<sub_nittei_list.value.length;s++){
      // プログラムごとの日程を入れる配列
      
      let sub_nittei = sub_nittei_list.value[s]
      let set_list = []

      //
      // 日程レコードに日程セットNo.を格納
      let once_list = [
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]
      let before_no = 1
      let once_count = 0
      for(let n = 0;n<sub_nittei.length;n++){
        if(n != 0 && sub_nittei[n]["nittei_set_no"] != before_no){
          set_list[set_list.length] = once_list
          once_list = [
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]
          once_count = 0
        }
        once_list[once_count] = sub_nittei[n]
        before_no = sub_nittei[n]["nittei_set_no"]
        once_count++

        if((n+1) == sub_nittei.length){
          set_list[set_list.length] = once_list
        }
      }

      sub_disp_nittei_list.value[sub_disp_nittei_list.value.length] = set_list 
    }
    
  }

  // 活動内容を追加する
  let katsudou_add = function(){

    // 新規登録の場合は事前に連想配列を作成


      // 表示用のサブ日程のうち、最後のサブに初期値を追加する
      sub_disp_nittei_list.value[sub_disp_nittei_list.value.length] = []
      sub_disp_nittei_list.value[sub_disp_nittei_list.value.length-1][0] =  [{"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
              "nittei_group":"1","nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}]

    sub_nittei_list.value[sub_nittei_list.value.length] = 
                            [{"kaisai_start":"",
                            "kaisai_end":"",
                            "jikantai_start":"",
                            "jikantai_end":"",
                            "kaisai_youbi":"",
                            "jogai":"",
                            "jogai_date":"",
                            "teiin":null,
                            "teiin_mongon":"",
                            "comment":"",
                            "nittei_group":"1",
                            "nittei_set_no":0,
                            "jogai_array":[],
                            "kaisai_array":[]}]

    // メインのIDと新規追加フラグを追加する
    sub_list.value[sub_list.value.length] =
                      {"main_taiken_id":taiken_id,
                      "taiken_no":taiken_list.value.taiken_no,
                      "taiken_no_text":taiken_list.value.taiken_no_text,
                      "update_flg":"new",
                       "name":taiken_list.value.name,
                       "s_syurui":null,
                       "s_name":'',
                       "s_jusyo":'',
                       "s_tel":'',
                       "s_fax":'',
                       "s_email":'',
                       "s_tantou":'',
                       "s_comment":'',
                       "k_name":null,
                       "k_jusyo":null,
                       "k_tel":null,
                       "shimekiri_date":null,
                       "shimekiri_nissu":null,
                       "nissu_min":1,
                       "nissu_max":1,
                       "nissu_joken":2,
                       "nissu_douitsu":'false',
                       "nissu_jogai":'false',
                       "nissu_mongon":"",
                       "seisaku_joken":null,
                       "seisaku_teiin":null,
                       "teiin_mongon":"",
                       "todokesaki":null,
                       "mochimono":null,
                       "joken_syogaku":"〇",
                       "joken_chugaku":"〇",
                       "joken_koukou":"〇",
                       "joken_senmon":"ー",
                       "joken_kousen":"ー",
                       "joken_daigaku":"〇",
                       "joken_daigakuin":"ー",
                       "joken_sonota":"〇",
                       "joken_all_start":"",
                       "joken_all_end":"",
                       "joken_mongon":"",
                       "sankahi":"不要",
                       "kensa":'不要',
                       "kenben":'不要',
                       "mask":'不要',
                       "chusyoku":"不要",
                       "shiryo_setsumei":"",
                       "shiryo_url":"",
                       "bikou":null,
                       "hissu_flg":0,
                       "teiin_settei":0,
                       "teiin_oneday":1,
                       "nittei_sentaku":0,
                        "choson_code":GlobalData.choson_code}


      // 最新の活動タブに移動
      KatsudouActive.value = 'sub'+(sub_list.value.length-1)

  }

  // 活動内容を削除する
  let katsudou_delete = function(program_num){

    if(window.confirm("この活動内容を削除しますか？")){
      // 元から存在するサブプログラムであれば、削除対象プログラムとして格納
      if(sub_list.value[program_num]["update_flg"] == "old"){
        delete_sub_list.value[delete_sub_list.value.length] = sub_list.value[program_num]
      }
      sub_list.value.splice(program_num,1)
      sub_nittei_list.value.splice(program_num,1)
      sub_disp_nittei_list.value.splice(program_num,1)
      sub_shimekiri_day.value.splice(program_num,1)
      sub_shimekiri_time.value.splice(program_num,1)
      sub_disp_all_start.value.splice(program_num,1)
      sub_disp_all_end.value.splice(program_num,1)

      
      // 削除した後は活動1タブに戻す
      KatsudouActive.value = 'main'

      // 日程変更フラグを立てる
      nittei_sanka_check()
    }
  }
  
  // 指定した活動に移動する（詳細）
  let link_katsudou_shosai = function(program_num){
    let id = "katsudou_shosai" + program_num
    Page_id_focus(id)
  }
  
  // 指定した活動に移動する（日程一覧）
  let link_katsudou_nittei = function(program_num){
    let id = "katsudou_nittei" + program_num
    Page_id_focus(id)
  }

  // 指定した活動の日程に移動する（日程一覧）
  let link_katsudou_nittei_nittei = function(program_num,nittei_num){
    let id = "katsudou_nittei"+program_num+"_nittei"  + nittei_num
    Page_id_focus(id)
  }
  // 指定した活動に移動する（カレンダー）
  let link_katsudou_cal = function(program_num){
    let id = "katsudou_cal" + program_num
    Page_id_focus(id)
  }
  // 指定した活動の日程に移動する（カレンダー）
  let link_katsudou_cal_nittei = function(program_num,nittei_num){
    let id = "katsudou_cal"+program_num+"_nittei"  + nittei_num
    Page_id_focus(id)
  }


  // 指定した活動内容に移動する（編集）
  let link_katsudou = function(program_num){
    let id = "link_katsudou" + program_num
    Page_id_focus(id)
  }

  
  // 指定した活動のタブを表示する
  let Change_katsudou = function(program_num){
    // 日程タブは１に戻す
    NitteiActive.value = 0

    if(program_num == 9999){
      KatsudouActive.value = "main"
    }else{
      KatsudouActive.value = "sub"+program_num
    }

    // 確認の場合のみカレンダーを表示
    if(mode.value == 0){
      KatsudouActive_no.value = program_num
      Sub_Calendar_set(program_num)
    }
  }

  // 日程タブ切り替え
  let Change_nittei = function(num){
    NitteiActive.value = num
    Calendar_set()
    Sub_Calendar_set(KatsudouActive_no.value)
  }

  
  // 日程の入力項目を追加する
  // program_num : 日程を追加するプログラムのナンバー
  let nittei_add = function(program_num){
    
    // 末尾に初期値を入力（3つの日程情報を持つ配列を追加）
    if(program_num == 9999){
      let set_group_no = disp_nittei_list.value.length + 1
      // メインの場合
      disp_nittei_list.value[disp_nittei_list.value.length]
                          = [
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}
                            ]
    }else{
      let set_group_no = sub_disp_nittei_list.value[program_num].length + 1
      sub_disp_nittei_list.value[program_num][sub_disp_nittei_list.value[program_num].length]
                         = [
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]},
                              {"kaisai_start":"","kaisai_end":"","jikantai_start":"","jikantai_end":"","kaisai_youbi":"","jogai":"","jogai_date":"","teiin":null,"teiin_mongon":"","comment":"",
                              "nittei_group":set_group_no,"nittei_set_no":0,"jogai_array":[],"kaisai_array":[]}
                          ]
    }


  }

  // 日程をひとつ削除する 
  // num         : 活動（下記プログラムのナンバー）内における日程の番地
  // program_num : 日程を削除するプログラムのナンバー
  let nittei_delete = function(num,program_num){
    if(window.confirm("この日程を削除しますか？")){
      if(program_num == 9999){
        // メインの場合
        disp_nittei_list.value.splice(num,1)
      }else{
        // サブの場合
        sub_disp_nittei_list.value[program_num].splice(num,1)
      }
      // 日程変更フラグを立てる
      nittei_sanka_check()

      // 日程タブを1に戻す
      NitteiActive.value = 0

      // グループ番号を振りなおす
      group_setting(program_num)
    }
  }
  
  // 日程を複製する 
  // num         : 活動（下記プログラムのナンバー）内における日程の番地
  // program_num : 日程を複製するプログラムのナンバー
  let nittei_copy = function(num,program_num){
      if(program_num == 9999){
        // メインの場合
        disp_nittei_list.value[disp_nittei_list.value.length] 
        = JSON.parse(JSON.stringify(disp_nittei_list.value[num]))
        
        // 日程タブを複製した日程とする
        NitteiActive.value = disp_nittei_list.value.length - 1

      }else{
        // サブの場合
        sub_disp_nittei_list.value[program_num][sub_disp_nittei_list.value[program_num].length] 
        = JSON.parse(JSON.stringify(sub_disp_nittei_list.value[program_num][num]))
        
        // 日程タブを複製した日程とする
        NitteiActive.value = sub_disp_nittei_list.value[program_num].length - 1
      }


      // 日程変更フラグを立てる
      nittei_sanka_check()

      // グループ番号を振りなおす
      group_setting(program_num)
  }

  // 日程を編集する
  // program_num : 日程を編集するプログラムのナンバー
  // num         : 日程の番地
  // flg         : kaisai or jogai（開催期間選択か、除外日選択か）
  let calendar_open = function(program_num,num,flg){
    // 編集ボタンを押した日程リストと編集フラグを子コンポーネントに送る
    paramNittei = {"num":num,"flg":flg,"program_num":program_num,"shubetsu":taiken_list.value.shubetsu}
    if(program_num == 9999){
      // メインの場合
      paramNittei.disp_nittei_list = disp_nittei_list.value[num]
      paramNittei.program = taiken_list.value
    }else{
      // サブの場合
      paramNittei.disp_nittei_list = sub_disp_nittei_list.value[program_num][num]
      paramNittei.program = sub_list.value[program_num]

    }
    nittei_area.value = true
    contentNittei.value = ShakyoTaikenDetailNittei
  }



  // 指定したプログラム（活動の）日程グループ番号を振りなおす
  // program_num : 日程を削除するプログラムのナンバー
  let group_setting = function(program_num){
      if(program_num == 9999){
        // メインの場合
        for(let d = 0;d<disp_nittei_list.value.length;d++){
          for(let s = 0;s<disp_nittei_list.value[d].length;s++){
            disp_nittei_list.value[d][s].nittei_group = (d+1)
          }
        }
      }else{
        // サブの場合
        for(let d = 0;d<sub_disp_nittei_list.value[program_num].length;d++){
          for(let s = 0;s<sub_disp_nittei_list.value[program_num][d].length;s++){
            sub_disp_nittei_list.value[program_num][d][s].nittei_group = (d+1)
          }
        }
      }
      // 日程変更フラグを立てる
      nittei_sanka_check()
  }
    
  let error_count  = 0
  // 画像ファイル取得
  // 画像ファイル取得 & Lambda へ送信
  const imgUpload = async (e) => {

      // エラー初期化
      error_count = 0;

      const fileInput = e.target;
      const file = fileInput.files[0];
      if (!file) return;

      // 拡張子取得
      const accept = file.name.split(".").pop();

      // ファイル名作成
      const today = new Date();
      const fileNameOnly = 'taiken' +
          `${GlobalData.shakyo}_${file.name.split(".")[0]}` +
          `_${today.getFullYear()}${today.getMonth()+1}${today.getDate()}` +
          `${today.getHours()}${today.getMinutes()}${today.getSeconds()}`;

      // アップロード先のフォルダを指定
      const folder = 'taiken/img/'
      const file_name = `${folder}/${fileNameOnly}.${accept}`;

      // Lambda に送る payload
      const formData = new FormData();
      formData.append("file_name", file_name);
      formData.append("file", file);
      formData.append("Bucket",GlobalData.$Image_bucket)

      try {
          // Lambda API Gateway の URL。APIGatewayではなくLambdaの関数URLを利用
          const set_url = GlobalData.$fileupload_url;

          // 呼び出し
          const response = await axios.post(set_url, formData, {
              headers: {
                  "Content-Type": "multipart/form-data"
              }
          });

          console.log("Lambda response:", response.data);
          // 画像のURLを指定して再読み込み
          taiken_list.value.title_image = "https://"+GlobalData.$Image_bucket+".s3-ap-northeast-1.amazonaws.com/"+file_name

      } catch (error) {
          console.error("Upload error:", error);
          error_count++;
      }
  };

  // 画像を削除
  const imgDelete = () =>{
    taiken_list.value.title_image = null
  }

  // 日程・参加条件の変更を検知する
  let nittei_sanka_check = function(){
    nittei_sanka_flg.value = 1
    Henshu_check()
  }

  // 1項目でも編集されていたらフラグを立てる
  let Henshu_check = function(){
    henshu_flg.value = 1 
    
    emit('call',{cmd:'detail_edit'})
  }

  // 必須項目の背景色を変更する
  let Background_change = function(id){
    document.getElementById(id).style.backgroundColor = "white"
  }
  
  // 保存する前に確認
  let Update_check = function() {
    validation_error_id = ""

    nissu_error.value = ""

    // 施設・体験の時は活動日数をチェック
    if(taiken_list.value.shubetsu == 1){

      // メインの活動日数
      if(taiken_list.value.nissu_max == ''){
        taiken_list.value.nissu_max = null 
      }
      if(taiken_list.value.nissu_min == ''){
        taiken_list.value.nissu_min = null 
      }

      // 両方とも未入力ならエラー
      if((taiken_list.value.nissu_max == null || taiken_list.value.nissu_max == '') &&
        (taiken_list.value.nissu_min == null || taiken_list.value.nissu_min == '')){
        nissu_error.value = "【活動1】活動日数の上限・下限は必ずどちらかを入力してください。"
        document.getElementById("nissu_max").style.backgroundColor = "pink"
        document.getElementById("nissu_min").style.backgroundColor = "pink"
      }else{
        
        // 下限が整数かどうかをチェック
        if(taiken_list.value.nissu_min != null && taiken_list.value.nissu_min != ''){
            let check_nissu = taiken_list.value.nissu_min
            if(isNaN(check_nissu)){
              nissu_error.value = "【活動1】活動日数に半角数字の整数以外が入力されています。\n"
              document.getElementById("nissu_min").style.backgroundColor = "pink"
            }else{
              // 数値でも小数点以下が含まれていたらエラー
              let check_float = parseFloat(check_nissu)
              if(!Number.isInteger(check_float)){
                nissu_error.value = "【活動1】活動日数に半角数字の整数以外が入力されています。\n"
                document.getElementById("nissu_min").style.backgroundColor = "pink"
              }else{
                // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                taiken_list.value.nissu_min = parseInt(taiken_list.value.nissu_min)
              }
            } 
        }

        // 上限が整数かどうかをチェック
        if(taiken_list.value.nissu_max != null && taiken_list.value.nissu_max != ''){

            let check_nissu = taiken_list.value.nissu_max
            if(isNaN(check_nissu)){
              nissu_error.value = "【活動1】活動日数に半角数字の整数以外が入力されています。\n"
              document.getElementById("nissu_max").style.backgroundColor = "pink"
            }else{
              // 数値でも小数点以下が含まれていたらエラー
              let check_float = parseFloat(check_nissu)
              if(!Number.isInteger(check_float)){
                nissu_error.value = "【活動1】活動日数に半角数字の整数以外が入力されています。\n"
                document.getElementById("nissu_max").style.backgroundColor = "pink"
              }else{
                // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                taiken_list.value.nissu_max = parseInt(taiken_list.value.nissu_max)
              }
            } 
        }

        // 両方とも入力しているなら、上限が下限より小さいときはエラー
        if((taiken_list.value.nissu_max != null && taiken_list.value.nissu_max != '') &&
          (taiken_list.value.nissu_min != null && taiken_list.value.nissu_min != '')){
          if(taiken_list.value.nissu_max < taiken_list.value.nissu_min){
            nissu_error.value += "【活動1】活動日数の上限は下限と同じ、または、下限より大きい数字を入力してください。"
            document.getElementById("nissu_max").style.backgroundColor = "pink"
            document.getElementById("nissu_min").style.backgroundColor = "pink"
          }
        }

        // サブ
        for(let s = 0;s<sub_list.value.length;s++){

          let sub_nissu = sub_list.value[s]
          if(sub_nissu.nissu_max == ''){
            sub_list.value[s].nissu_max = null 
          }
          if(sub_nissu.nissu_min == ''){
            sub_list.value[s].nissu_min = null 
          }

          // 両方とも未入力ならエラー
          if((sub_nissu.nissu_max == null || sub_nissu.nissu_max == '') &&
            (sub_nissu.nissu_min == null || sub_nissu.nissu_min == '')){
            nissu_error.value += "【活動"+(s+2)+"】活動日数の上限・下限は必ずどちらかを入力してください。"
          }else{
            
            // 下限が整数かどうかをチェック
            if(sub_nissu.nissu_min != null && sub_nissu.nissu_min != ''){
                let check_nissu = sub_nissu.nissu_min
                if(isNaN(check_nissu)){
                  nissu_error.value += "【活動"+(s+2)+"】活動日数に半角数字の整数以外が入力されています。\n"
                }else{
                  // 数値でも小数点以下が含まれていたらエラー
                  let check_float = parseFloat(check_nissu)
                  if(!Number.isInteger(check_float)){
                    nissu_error.value += "【活動"+(s+2)+"】活動日数に半角数字の整数以外が入力されています。\n"
                  }else{
                    // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                    sub_list.value[s].nissu_min = parseInt(sub_nissu.nissu_min)
                  }
                } 
            }

            // 上限が整数かどうかをチェック
            if(sub_nissu.nissu_max != null && sub_nissu.nissu_max != ''){

                let check_nissu = sub_nissu.nissu_max
                if(isNaN(check_nissu)){
                  nissu_error.value += "【活動"+(s+2)+"】活動日数に半角数字の整数以外が入力されています。\n"
                }else{
                  // 数値でも小数点以下が含まれていたらエラー
                  let check_float = parseFloat(check_nissu)
                  if(!Number.isInteger(check_float)){
                    nissu_error.value += "【活動"+(s+2)+"】活動日数に半角数字の整数以外が入力されています。\n"
                  }else{
                    // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                    sub_list.value[s].nissu_max = parseInt(sub_nissu.nissu_max)
                  }
                } 
            }

            // 両方とも入力しているなら、上限が下限より小さいときはエラー
            if((sub_nissu.nissu_max != null && sub_nissu.nissu_max != '') &&
              (sub_nissu.nissu_min != null && sub_nissu.nissu_min != '')){
              if(sub_nissu.nissu_max < sub_nissu.nissu_min){
                nissu_error.value += "【活動"+(s+2)+"】活動日数の上限は下限と同じ、または、下限より大きい数字を入力してください。"
              }
            }
          }
        }
      }

      if(nissu_error.value != ""){
        message.value = nissu_error.value;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "validation_error";
        contentMessage.value = MessageModal
        return
      }

      // 社協全体の〆切日の設定が「プログラム単位」の場合
      if(end_shubetsu.value == 2){

        let shimekiri_error_check = 0 // 〆切日・〆切日数のチェック（1 = エラー）

        let nissu_check = 0 // 日数の入力有無（1なら入力）
        let date_check = 0 // 〆切日の入力有無（1なら入力）
        let shimekiri_error_message = ""


        // メイン
        // 〆切日数が入力されているか
         if(taiken_list.value.shimekiri_nissu != null && taiken_list.value.shimekiri_nissu != ""){
            nissu_check = 1
         }
        if(shimekiri_day.value != null && shimekiri_day.value != ""){
            date_check = 1
        }
        if(nissu_check == 1 && date_check == 1){
            shimekiri_error_message = "【活動1】申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。"
            shimekiri_error_check = 1
        }else if(nissu_check == 0 && date_check == 0){
            shimekiri_error_message = "【活動1】申込〆切日時と申込〆切日数は、どちらか一方を必ず入力してください。"
            shimekiri_error_check = 1
        }
          // 〆切日数が空欄ならnullを入れてあげる
          if(taiken_list.value.shimekiri_nissu == ""){
            taiken_list.value.shimekiri_nissu = null
          }

        // サブ
        for(let s = 0;s<sub_list.value.length;s++){

          let sub_nissu_check = 0 // 日数の入力有無（1なら入力）
          let sub_date_check = 0 // 〆切日の入力有無（1なら入力）

          let sub_shimekiri = sub_list.value[s]

          if(sub_shimekiri.shimekiri_nissu != null && sub_shimekiri.shimekiri_nissu != ""){
              sub_nissu_check = 1
          }
          if(sub_shimekiri_day.value[s] != null && sub_shimekiri_day.value[s] != ""){
              sub_date_check = 1
          }

          if(sub_nissu_check == 1 && sub_date_check == 1){
            if(shimekiri_error_message != "") shimekiri_error_message += "\n"
            shimekiri_error_message += "【活動"+(s+2)+"】申込〆切日時と申込〆切日数は、どちらか一方のみ入力可能です。"
            shimekiri_error_check = 1
          }else if(sub_nissu_check == 0 && sub_date_check == 0){
            if(shimekiri_error_message != "") shimekiri_error_message += "\n"
            shimekiri_error_message += "【活動"+(s+2)+"】申込〆切日時と申込〆切日数は、どちらか一方を必ず入力してください。"
            shimekiri_error_check = 1
          }

          // 〆切日数が空欄ならnullを入れてあげる
          if(sub_shimekiri.shimekiri_nissu == ""){
            sub_list.value[s].shimekiri_nissu = null
          }
        }

        if(shimekiri_error_check == 1){
          message.value = shimekiri_error_message;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "validation_error";
          contentMessage.value = MessageModal
          return
        }

      }
    }else{
      // 制作・寄付の時
      // 社協全体の〆切日の設定が「プログラム単位」の場合
      if(end_shubetsu.value == 2){
        let shimekiri_error_check = 0 // 〆切日時のチェック（1 = エラー）
        let shimekiri_error_message = ""

        //両方とも空欄の場合    
        
        if(shimekiri_day.value == null || shimekiri_day.value == ""){
          shimekiri_error_message = "申込〆切日時は必ず入力してください。"
          shimekiri_error_check = 1
        }
        if(shimekiri_error_check == 1){
          message.value = shimekiri_error_message;
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "validation_error";
          contentMessage.value = MessageModal
          return
        }
      }

    }
    
      let katsudou_jusho_check = 0 // 活動内容と住所のチェック
      let nittei_hissu_check = 0 // 日程の必須項目チェック（1 = エラー）
      let nittei_min_max_check = 0 // 日程の大小チェック（1 = エラー）
      let jikan_min_max_check = 0 // 時間帯の大小チェック（1 = エラー）
      let jogai_kaisai_youbi = 0 // 除外曜日と開催曜日の両方が入力されているかどうか（されていたら1 = エラー）
      let jogai_date_check = 0 // 除外日が変なテキストかどうか（変だったら1 = エラー）
      let teiin_check = 0 // 定員が整数かどうか（整数じゃなかったら1 = エラー）
      let all_teiin_check = 0 // 全体定員が整数かどうか（整数じゃなかったら1 = エラー）
      let sanka_joken_check = 0 // 参加条件の入力が正常かどうか（変だったら1 = エラー）
      let sanka_joken_none = 0 // 参加条件の入力が全て「ー」どうか（全て「ー」だったら1 = エラー）

      let set_error_message = ""

      if(taiken_list.value.shubetsu == 1){
        // 定員が1日ごとの場合のチェック
        if(taiken_list.value.teiin_settei == 1){
          
          // メイン
          if(taiken_list.value.teiin_oneday == null || taiken_list.value.teiin_oneday == ''){
            document.getElementById("teiin_oneday").style.backgroundColor = "pink"
            teiin_check = 1
          }else{
            let check_teiin = taiken_list.value.teiin_oneday
            if(isNaN(check_teiin)){
                teiin_check = 1
                document.getElementById("teiin_oneday").style.backgroundColor = "pink"
            }else{
              // 数値でも小数点以下が含まれていたらエラー
              let check_float = parseFloat(check_teiin)
              if(!Number.isInteger(check_float)){
                teiin_check = 1
                document.getElementById("teiin_oneday").style.backgroundColor = "pink"
              }else{
                
                // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                taiken_list.value.teiin_oneday = parseInt(taiken_list.value.teiin_oneday)
              }
            }
          }
          
          // サブ
          for(let s = 0;s<sub_list.value.length;s++){

            let sub = sub_list.value[s]
            if(sub.teiin_oneday == null || sub.teiin_oneday == ''){
              teiin_check = 1
            }else{
              let check_teiin = sub.teiin_oneday
              if(isNaN(check_teiin)){
                  teiin_check = 1
              }else{
                // 数値でも小数点以下が含まれていたらエラー
                let check_float = parseFloat(check_teiin)
                if(!Number.isInteger(check_float)){
                  teiin_check = 1
                }else{
                  
                  // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                  sub.teiin_oneday = parseInt(sub.teiin_oneday)
                }
              }
            }
          }
        }

        // 全体定員チェック（定員フラグが立ってるときのみチェック）
        if(taiken_list.value.all_teiin_flg == 1 ){
          if(taiken_list.value.seisaku_teiin == null || taiken_list.value.seisaku_teiin == ''){
              document.getElementById("all_teiin").style.backgroundColor = "pink"
              all_teiin_check = 1
          }
        }

        // 施設・地域の時は表示中の日程（disp_nittei_list）から日程リスト（nittei_list）を作成する
        //disp_nittei_list.value

        // いったん空にする
        nittei_list.value = []

        console.log("メイン定員設定"+taiken_list.value.teiin_settei)

        // メインの表示中日程（dips_nittei_list）にはさらに細かく日程レコードが入っているので、細かくして日程リスト（nittei_list）に入れる
        for(let d = 0;d<disp_nittei_list.value.length;d++){
          let disp_nittei = disp_nittei_list.value[d]
          
          for(let dn = 0;dn<disp_nittei.length;dn++){

            if(dn == 0){

              // 1番目の日程
              if((disp_nittei[dn].kaisai_start != "" && disp_nittei[dn].kaisai_start != null)
                    && (disp_nittei[dn].kaisai_end != "" && disp_nittei[dn].kaisai_end != null)
                    && (disp_nittei[dn].jikantai_start != "" && disp_nittei[dn].jikantai_start != null)
                    && (disp_nittei[dn].jikantai_end != "" && disp_nittei[dn].jikantai_end != null)
                    
                  ){
                  
                  // 定員の扱いが時間帯ごとの場合は、定員が未入力ならエラー
                  let jikantai_teiin_error = 0
                  if(taiken_list.value.teiin_settei == 0){
                   if(disp_nittei[dn].teiin == "" || disp_nittei[dn].teiin == null) {
                    jikantai_teiin_error = 1
                   }
                  }
                  if(jikantai_teiin_error == 0){
                    // 必須項目が全て入力されていたら追加
                    console.log("1:OK："+JSON.stringify(disp_nittei[dn]))
                    
                    disp_nittei[dn] = {
                                "kaisai_start":disp_nittei[0].kaisai_start,
                                "kaisai_end":disp_nittei[0].kaisai_end,
                                "jikantai_start":disp_nittei[dn].jikantai_start,
                                "jikantai_end":disp_nittei[dn].jikantai_end,
                                "kaisai_youbi":disp_nittei[0].kaisai_youbi,
                                "jogai":disp_nittei[0].jogai,
                                "jogai_date":disp_nittei[0].jogai_date,
                                "teiin":disp_nittei[dn].teiin,
                                "teiin_mongon":disp_nittei[dn].teiin_mongon,
                                "comment":disp_nittei[0].comment,
                                "nittei_group":disp_nittei[0].nittei_group}
                    nittei_list.value[nittei_list.value.length] = disp_nittei[dn]
                  }else{
                    // 1つでも空ならエラー
                    nittei_hissu_check = 1
                    console.log("1:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                  }
              }else{
                  // 1つでも空ならエラー
                  nittei_hissu_check = 1
                  console.log("1:hanuke_NG："+JSON.stringify(disp_nittei[dn]))
              }

            }else if(taiken_list.value.nittei_sentaku == 0){
              // 日程の選択方法が「開催日ごと」であれば格納する
              // 2・3番目の日程
              if((disp_nittei[dn].jikantai_start != "" && disp_nittei[dn].jikantai_start != null)
                    && (disp_nittei[dn].jikantai_end != "" && disp_nittei[dn].jikantai_end != null)
                   
                  ){
                  // 開催日は日程1から引用するのでそれ以外の必須項目が全て入力されていたら追加
                  
                  // 定員の扱いが時間帯ごとの場合は、定員が入力されてたらエラー
                  let jikantai_teiin_error = 0
                  if(taiken_list.value.teiin_settei == 0){
                   if(disp_nittei[dn].teiin == "" || disp_nittei[dn].teiin == null) {
                    jikantai_teiin_error = 1
                   }
                  }
                  if(jikantai_teiin_error == 0){
                    disp_nittei[dn] = {
                              "kaisai_start":disp_nittei[0].kaisai_start,
                              "kaisai_end":disp_nittei[0].kaisai_end,
                              "jikantai_start":disp_nittei[dn].jikantai_start,
                              "jikantai_end":disp_nittei[dn].jikantai_end,
                              "kaisai_youbi":disp_nittei[0].kaisai_youbi,
                              "jogai":disp_nittei[0].jogai,
                              "jogai_date":disp_nittei[0].jogai_date,
                              "teiin":disp_nittei[dn].teiin,
                              "teiin_mongon":disp_nittei[dn].teiin_mongon,
                              "comment":disp_nittei[0].comment,
                              "nittei_group":disp_nittei[0].nittei_group}

                    console.log("2or3:OK："+JSON.stringify(disp_nittei[dn]))
                    nittei_list.value[nittei_list.value.length] = disp_nittei[dn]
                  }else{
                    nittei_hissu_check = 1
                    console.log("2or3:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                  }
              }else{
                // 未入力項目が一つでもあった場合
                if((disp_nittei[dn].jikantai_start == "" || disp_nittei[dn].jikantai_start == null)
                   && (disp_nittei[dn].jikantai_end == "" || disp_nittei[dn].jikantai_end == null)
                ){
                  
                  // 定員の扱いが時間帯ごとの場合は、定員も未入力ならスルー
                  if(taiken_list.value.teiin_settei == 0){
                    //
                    if(disp_nittei[dn].teiin == "" || disp_nittei[dn].teiin == null){
                      // 全部が空の場合はスルー
                      console.log("2or3:ALL_NULL："+JSON.stringify(disp_nittei[dn]))
                    }else{
                      
                      // 定員が入力されていた場合はエラー
                      nittei_hissu_check = 1
                      console.log("2or3:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                    }
                  }
                }else{
                  // 定員の扱いが1日ごとの場合、定員以外のどれかが未入力ならエラー
                  if(taiken_list.value.teiin_settei == 1){
                    nittei_hissu_check = 1
                    console.log("2or3:hanuke_NG："+JSON.stringify(disp_nittei[dn]))
                  }else{
                    
                    console.log("2or3:hanuke_OK："+JSON.stringify(disp_nittei[dn]))
                  }
                }
              }
            }
          }
        }
        
        // サブの表示中日程（sub_disp_nittei_list）にはさらに細かく日程レコードが入っているので、細かくして日程リスト（sub_nittei_list）に入れる
        // こちらは二次元配列

        // いったん空にする
        sub_nittei_list.value = []   
        for(let s = 0;s<sub_disp_nittei_list.value.length;s++){

          
          console.log("サブ"+s+"定員設定"+sub_list.value[s].teiin_settei)
          let set_nittei = sub_disp_nittei_list.value[s]

          console.log(set_nittei)

          let all_set_nittei_list = []
          for(let d = 0;d<set_nittei.length;d++){
            let disp_nittei = set_nittei[d]

            console.log(disp_nittei)
            let set_nittei_list = []
            // 
            
            for(let dn = 0;dn<disp_nittei.length;dn++){

              if(dn == 0){

                // 1番目の日程
                if((disp_nittei[dn].kaisai_start != "" && disp_nittei[dn].kaisai_start != null)
                    && (disp_nittei[dn].kaisai_end != "" && disp_nittei[dn].kaisai_end != null)
                    && (disp_nittei[dn].jikantai_start != "" && disp_nittei[dn].jikantai_start != null)
                    && (disp_nittei[dn].jikantai_end != "" && disp_nittei[dn].jikantai_end != null)
                    ){
                    
                    // 定員の扱いが時間帯ごとの場合は、定員が未入力ならエラー
                    let jikantai_teiin_error = 0
                      
                    if(sub_list.value[s].teiin_settei == 0){
                      if(disp_nittei[dn].teiin != "" && disp_nittei[dn].teiin != null) {
                        jikantai_teiin_error = 1
                      }
                    }
                    if(jikantai_teiin_error == 0){

                      // 必須項目が全て入力されていたら追加
                      disp_nittei[dn] = {
                                  "kaisai_start":disp_nittei[0].kaisai_start,
                                  "kaisai_end":disp_nittei[0].kaisai_end,
                                  "jikantai_start":disp_nittei[dn].jikantai_start,
                                  "jikantai_end":disp_nittei[dn].jikantai_end,
                                  "kaisai_youbi":disp_nittei[0].kaisai_youbi,
                                  "jogai":disp_nittei[0].jogai,
                                  "jogai_date":disp_nittei[0].jogai_date,
                                  "teiin":disp_nittei[dn].teiin,
                                  "teiin_mongon":disp_nittei[dn].teiin_mongon,
                                  "comment":disp_nittei[0].comment,
                                  "nittei_group":disp_nittei[0].nittei_group}
                      set_nittei_list[set_nittei_list.length] = disp_nittei[dn]
                      console.log("サブ"+d+"1:OK："+JSON.stringify(disp_nittei[dn]))
                    }else{
                      // 1つでも空ならエラー
                      nittei_hissu_check = 1
                      console.log("サブ"+d+"1:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                    }
                }else{
                  // 1つでも空ならエラー
                  nittei_hissu_check = 1
                  console.log("サブ"+d+"1:hanuke_NG："+JSON.stringify(disp_nittei[dn]))
                }

            }else if(sub_list.value[s].nittei_sentaku == 0){
              // 日程の選択方法が「開催日ごと」であれば格納する
                // 2・3番目の日程
                if( (disp_nittei[dn].jikantai_start != "" && disp_nittei[dn].jikantai_start != null)
                    && (disp_nittei[dn].jikantai_end != "" && disp_nittei[dn].jikantai_end != null)
          
                    ){
                      
                    
                  // 定員の扱いが時間帯ごとの場合は、定員が未入力ならエラー
                  let jikantai_teiin_error = 0
                  if(sub_list.value[s].teiin_settei == 0){
                   if(disp_nittei[dn].teiin != "" && disp_nittei[dn].teiin != null) {
                    jikantai_teiin_error = 1
                   }
                  }
                  if(jikantai_teiin_error == 0){
                    // 開催日は日程1から引用するのでそれ以外の必須項目が全て入力されていたら追加
                    disp_nittei[dn] = {
                                "kaisai_start":disp_nittei[0].kaisai_start,
                                "kaisai_end":disp_nittei[0].kaisai_end,
                                "jikantai_start":disp_nittei[dn].jikantai_start,
                                "jikantai_end":disp_nittei[dn].jikantai_end,
                                "kaisai_youbi":disp_nittei[0].kaisai_youbi,
                                "jogai":disp_nittei[0].jogai,
                                "jogai_date":disp_nittei[0].jogai_date,
                                "teiin":disp_nittei[dn].teiin,
                                "teiin_mongon":disp_nittei[dn].teiin_mongon,
                                "comment":disp_nittei[0].comment,
                                "nittei_group":disp_nittei[0].nittei_group}
                                

                      console.log("サブ"+d+"2or3:OK："+JSON.stringify(disp_nittei[dn]))
                      set_nittei_list[set_nittei_list.length] = disp_nittei[dn]
                  }else{
                    // 1つでも空ならエラー
                    nittei_hissu_check = 1
                    console.log("サブ"+d+"2or3:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                  }
                }else{
                  // 未入力項目が一つでもあった場合
                  if((disp_nittei[dn].jikantai_start == "" || disp_nittei[dn].jikantai_start == null)
                    && (disp_nittei[dn].jikantai_end == "" || disp_nittei[dn].jikantai_end == null)
                  ){
                      
                    // 定員の扱いが時間帯ごとの場合は、定員も未入力ならスルー
                    if(sub_list.value[s].teiin_settei == 0){
                      if(disp_nittei[dn].teiin == "" || disp_nittei[dn].teiin == null){
                        // 全部が空の場合はスルー
                        console.log("サブ"+d+"2or3:ALL_NULL："+JSON.stringify(disp_nittei[dn]))
                      }else{
                        // 定員が入力されていた場合はエラー
                        nittei_hissu_check = 1
                        console.log("サブ"+d+"2or3:teiin_NG："+JSON.stringify(disp_nittei[dn]))
                      }
                    }
                  }else{
                    // 定員の扱いが1日ごとの場合、定員以外のどれかが未入力ならエラー
                    if(sub_list.value[s].teiin_settei == 1){
                      nittei_hissu_check = 1
                      console.log("サブ"+d+"2or3:hanuke_NG："+JSON.stringify(disp_nittei[dn]))
                    }else{
                      
                      console.log("サブ"+d+"2or3:hanuke_OK："+JSON.stringify(disp_nittei[dn]))
                    }
                  }
                }
              }
            }
            console.log("サブ"+d+JSON.stringify(set_nittei_list))
            // サブの日程一覧として保存
            all_set_nittei_list[all_set_nittei_list.length] = set_nittei_list
            
          }
          // 最終的に3つの日程からnullを除外したものを格納
          sub_nittei_list.value[sub_nittei_list.value.length] = all_set_nittei_list
          console.log(sub_nittei_list.value)
          console.log(sub_disp_nittei_list.value)
        }
      }else{
         // メインの表示中日程（dips_nittei_list）にはさらに細かく日程レコードが入っているので、細かくして日程リスト（nittei_list）に入れる
         
        // いったん空にする
        nittei_list.value = []

        for(let d = 0;d<disp_nittei_list.value.length;d++){
          let disp_nittei = disp_nittei_list.value[d]
          
          for(let dn = 0;dn<disp_nittei.length;dn++){
            nittei_list.value[nittei_list.value.length] = disp_nittei[dn]
          }
        }

        taiken_list.value.kaisai_start = nittei_list.value[0].kaisai_start
        taiken_list.value.kaisai_end = nittei_list.value[0].kaisai_end

          // 制作・寄付定員チェック
          if(taiken_list.value.seisaku_teiin == null || taiken_list.value.seisaku_teiin == ''){
            document.getElementById("seisaku_teiin").style.backgroundColor = "pink"
            teiin_check = 1
          }else{
            let check_teiin = taiken_list.value.seisaku_teiin
            if(isNaN(check_teiin)){
                teiin_check = 1
                document.getElementById("seisaku_teiin").style.backgroundColor = "pink"
            }else{
              // 数値でも小数点以下が含まれていたらエラー
              let check_float = parseFloat(check_teiin)
              if(!Number.isInteger(check_float)){
                teiin_check = 1
                document.getElementById("seisaku_teiin").style.backgroundColor = "pink"
              }else{
                
                // 小数点以下が「.0」の場合はスルーされるので整数に戻す
                taiken_list.value.seisaku_teiin = parseInt(taiken_list.value.seisaku_teiin)
              }
            }
          }
      }

      // メイン

      // 参加条件の順番が（自）＞（至）になっていたら１（エラー）
      sanka_joken_check = kubunCheck(disp_all_start.value,disp_all_end.value)

      console.log(sanka_joken_check+"/"+disp_all_start.value+"～"+disp_all_end.value)
      // 日程のチェック
      for(let n = 0;n<nittei_list.value.length;n++){

        let check_nittei = nittei_list.value[n]
            /*
            開催日（自）	kaisai_start
            開催日（至）	kaisai_end
            時間帯（自）	jikantai_start
            時間帯（至）	jikantai_end
            定員	teiin
            */

            // 開催日・時間帯・定員チェック
            if(
                ((check_nittei.kaisai_start != '' || check_nittei.kaisai_start != null) && (check_nittei.kaisai_end != '' || check_nittei.kaisai_end != null))
              &&
              ((check_nittei.jikantai_start != '' || check_nittei.jikantai_start != null) && (check_nittei.jikantai_end != '' || check_nittei.jikantai_end != null))
              &&
              (check_nittei.teiin != '' || check_nittei.teiin != null)
              ){
                // 全部空じゃなければOK
            }else{
              nittei_hissu_check = 1
            }
      }

      // サブ（施設・地域の場合のみ）
      if(taiken_list.value.shubetsu == 1){
        for(let s = 0;s<sub_list.value.length;s++){
          // 活動内容と開催場所・住所が空の場合はエラー
          if((sub_list.value[s].naiyou == '' || sub_list.value[s].k_jusyo == '')
          ||
          (sub_list.value[s].naiyou == null || sub_list.value[s].k_jusyo == null)){
            katsudou_jusho_check = 1
          }

          // 参加条件の順番が（自）＞（至）になっていたら１（エラー）
          // 一度でもエラーになっていたときはそちらを優先するので、ここではスルーする
          if(sanka_joken_check == 0) sanka_joken_check = kubunCheck(sub_disp_all_start.value[s],sub_disp_all_end.value[s])
        
          // 日程のチェック
          for(let n = 0;n<sub_nittei_list.value[s].length;n++){

            let check_nittei = sub_nittei_list.value[s][n]
            /*
            開催日（自）	kaisai_start
            開催日（至）	kaisai_end
            時間帯（自）	jikantai_start
            時間帯（至）	jikantai_end
            定員	teiin
            */

            // 開催日・時間帯・定員チェック
            if(
                ((check_nittei.kaisai_start != '' || check_nittei.kaisai_start != null) && (check_nittei.kaisai_end != '' || check_nittei.kaisai_end != null))
              &&
              ((check_nittei.jikantai_start != '' || check_nittei.jikantai_start != null) && (check_nittei.jikantai_end != '' || check_nittei.jikantai_end != null))
              &&
              (check_nittei.teiin != '' || check_nittei.teiin != null)
              ){
                // 全部空じゃなければOK
            }else{
              nittei_hissu_check = 1
            }
          }
        }
      }

      if(all_teiin_check == 1){
        set_error_message += "プログラム全体の定員を利用する場合、定員を必ず入力してください。";
      }

      if(katsudou_jusho_check == 1){
        if(set_error_message != "") set_error_message += "\n\n"
        set_error_message += "活動内容と開催場所・住所は必ず入力してください。";
      }


      if(nittei_hissu_check == 1){
        
        if(set_error_message != "") set_error_message += "\n\n"
        if(taiken_list.value.shubetsu == 1){
          set_error_message += "開催日、時間帯、定員のいずれかが未入力の日程があります。"
        }else{
          set_error_message += "開催日が未入力の日程があります。"
        }
      }

      if(nittei_min_max_check == 1){
        if(set_error_message != "") set_error_message += "\n\n"
        set_error_message += "開催日（自）が（至）より後の日になっている日程があります。";
      }


      if(jikan_min_max_check == 1){
        if(set_error_message != "") set_error_message += "\n\n"
        set_error_message += "時間帯（自）が（至）と同じ、または、後の時刻になっている日程があります。";
      }

      if(teiin_check == 1){
        if(set_error_message != "") set_error_message += "\n\n"

        set_error_message += "定員に整数以外が入力されている活動があります。";
      }

      if(sanka_joken_none == 1){
        if(set_error_message != "") set_error_message += "\n\n"
        set_error_message += "参加条件は必ず入力してください。";

      }
      
      if(sanka_joken_check == 1){
        if(set_error_message != "") set_error_message += "\n\n"
        set_error_message += "参加条件の区分を正確に入力してください。\n「大学」～「小学」のように逆転していると保存できません。";
      }

      console.log(sanka_joken_check+"/"+set_error_message)

      // エラーメッセージがあったら表示
      if(set_error_message != ""){
        if(all_teiin_check == 1 ){
          // 全体の定員がおかしい場合
            Page_id_focus("all_teiin")
        }else
        // 活動内容や日程関係がおかしい場合は活動タブに移動する
        if(katsudou_jusho_check == 1 ||
          nittei_hissu_check == 1 ||
          nittei_min_max_check == 1 ||
          jikan_min_max_check == 1 ||
          jogai_kaisai_youbi == 1 ||
          jogai_date_check == 1 
          
        ){

          Page_id_focus("katsudou_tabMenu")
        
        }else if(teiin_check == 1){
          // 定員の場合は、種別によって日程の一番上の定員か制作定員のどちらかに戻す
          
          if(taiken_list.value.shubetsu == 1){
            Page_id_focus("teiin_oneday")
          }else{
            Page_id_focus("seisaku_teiin")
          }
        
          
        }
        message.value =set_error_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "validation_error";
        contentMessage.value = MessageModal
        return
      }
    
    // 事前説明会を実施する場合
    if(jizen_jisshi.value == 1){
      // セットする事前説明会No
      let set_jizen = ""

      if(all_jizen_list.value != undefined){
          // 事前説明会の選択No抜き出し
          for(let j = 0;j<all_jizen_list.value.length;j++){

              if(document.jizen.jizen[j].checked){

                // set_jizen に値が入っていればカンマを挿入（カンマ区切りの文字を作っていく）
                if(set_jizen != "") set_jizen +=","
                set_jizen += document.jizen.jizen[j].value
            }
          }
      }

      taiken_list.value["jizenkensyu_no"] = set_jizen
    }

    // 事後集会を実施する場合
    if(jigo_jisshi.value == 1){
      // セットする事後集会No
      let set_jigo = ""

      if(all_jigo_list.value != undefined){
          // 事後集会の選択No抜き出し
          for(let j = 0;j<all_jigo_list.value.length;j++){

              if(document.jigo.jigo[j].checked){

                // set_jigo に値が入っていればカンマを挿入（カンマ区切りの文字を作っていく）
                if(set_jigo != "") set_jigo +=","
                set_jigo += document.jigo.jigo[j].value
            }
          }
      }

      taiken_list.value["jigosyukai_no"] = set_jigo
    }


    // 通常の保存メッセージ
    message.value = "保存しますか？";

    // 編集画面で、申込開始日より前かつ日程・参加条件の変更があった場合
    if(type == 1){
      if(delete_disp.value == false){
        if(nittei_sanka_flg.value == 1){
          message.value = '<img style="width: 40px;margin-right: 5px;" src="../../../../img/chui.png"><br><br>'
          message.value += '<div style="color:red;">「日程（開催期間等）」、又は「参加条件（対象者）」が変更されています。<br><br>'
          message.value += 'これらの変更に影響する申込済のユーザーがいる場合、参加記録処理に支障が出ます。<br>変更する場合は、「申込状況」メニューを確認し、適切な対応をお願いします。'
          message.value += '<br><br>変更を保存しますか？ </div>'
        }
      }
    }

    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "update";
    contentMessage.value = MessageModal
  
  }

  // 削除する前に確認
  let Delete_check = function(){
    message.value = "削除しますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "delete";
    contentMessage.value = MessageModal

  }

  // 未入力の必須項目があった場合はメッセージを表示してエラーがあった箇所まで移動する
  let InvalidSubmit = function({values, errors, result}){
    validation_error_id = ""
    nissu_error.value = ""
    // 施設・体験の時は活動日数をチェック
    if(taiken_list.value.shubetsu == 1){
      if(taiken_list.value.nissu_max == ''){
        taiken_list.value.nissu_max = null 
      }
      if(taiken_list.value.nissu_min == ''){
        taiken_list.value.nissu_min = null 
      }
      // 両方とも未入力ならエラー
      if((taiken_list.value.nissu_max == null || taiken_list.value.nissu_max == '') &&
        (taiken_list.value.nissu_min == null || taiken_list.value.nissu_min == '')){
        nissu_error.value = " 活動日数の上限・下限は必ずどちらかを入力してください。"
        
        document.getElementById("nissu_max").style.backgroundColor = "pink"
        document.getElementById("nissu_min").style.backgroundColor = "pink"
      }else{
        // 両方とも入力しているなら、上限が下限より小さいときはエラー
        if((taiken_list.value.nissu_max != null && taiken_list.value.nissu_max != '') &&
          (taiken_list.value.nissu_min != null && taiken_list.value.nissu_min != '')){
          if(taiken_list.value.nissu_max < taiken_list.value.nissu_min){
            nissu_error.value = " 活動日数の上限は下限と同じ、または、下限より大きい数字を入力してください。"
            document.getElementById("nissu_max").style.backgroundColor = "pink"
            document.getElementById("nissu_min").style.backgroundColor = "pink"
          }
        }
      }
    }

    // 必須項目全てのID
    let All_keys = Object.keys(values)
    // 実際にエラーとなっている項目のカラム名を配列で取得し、背景をピンクにする
    let Error_keys = Object.keys(errors)

    let Set_count = 0
    for(let e = 0;e<All_keys.length;e++){
      if(Error_keys.includes(All_keys[e])){
        if(Set_count == 0) validation_error_id = All_keys[e]
        const elements = document.getElementById(All_keys[e])
        elements.style.backgroundColor = "pink"
        Set_count++
      }

    }
    
    let nittei_hissu_check = 0// 日程の必須項目チェック（1 = エラー）
    if(taiken_list.value.teiin_settei == 1){
          if(taiken_list.value.teiin_oneday == null || taiken_list.value.teiin_oneday == ''){
            document.getElementById("teiin_oneday").style.backgroundColor = "pink"
            nittei_hissu_check = 1
          }else{
            let check_teiin = taiken_list.value.teiin_oneday
            if(isNaN(check_teiin)){
                teiin_check = 1
                document.getElementById("teiin_oneday").style.backgroundColor = "pink"
            }else{
              // 数値でも小数点以下が含まれていたらエラー
              let check_float = parseFloat(check_teiin)
              if(!Number.isInteger(check_float)){
                nittei_hissu_check = 1
                document.getElementById("teiin_oneday").style.backgroundColor = "pink"

              }
            }
          }
          if(nittei_hissu_check == 1){
            if(validation_error_id != ""){
              validation_error_id = "teiin_oneday"
            }
          }
      }else{
      // 日程の必須および除外曜日・開催曜日入力チェック、
      for(let n = 0;n<nittei_list.value.length;n++){

        // プログラムの開始日は最初の番地のものを格納
        if(n == 0){
          taiken_list.value["kaisai_start"] = nittei_list.value[n].kaisai_start
        }

        // プログラムの終了日はとりあえず格納（最終的に最後の番地のものが格納される）
        taiken_list.value["kaisai_end"] = nittei_list.value[n].kaisai_end
          
          // 制作・寄付の場合は開催日のみチェック
          if((nittei_list.value[n].kaisai_start == null || nittei_list.value[n].kaisai_start == '') 
          || (nittei_list.value[n].kaisai_end == null || nittei_list.value[n].kaisai_end == '')){
            nittei_hissu_check = 1

          }else{
            // 開催日の大小チェック
            if(nittei_list.value[n].kaisai_start > nittei_list.value[n].kaisai_end){
              nittei_min_max_check = 1
            }
          }
        }
      }


    message.value = "未入力の必須項目があります。";
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "validation_error";
    contentMessage.value = MessageModal

   // Page_id_focus(validation_error_id)
  }
    
  let EndDateTimeSetting = function(changedate){
    
    let date = Date.parse(changedate);
      let set_date = new Date(date);
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
      set_date = new Date(set_date);
      set_date.setHours(set_date.getHours()+9);

      //return date;
      return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")"+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
  }
  //年月日＋時間の表示を整える(EU時間)
  let EuDateTimeSetting = function(changedate){
     /*
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours()-8);
 */
     let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
  }

  // 指定の高さにスクロールさせる
  let Page_scroll = function(height){
    // ページの一番上にスクロールする：height＝位置（上から何pxか）
    //「behavior: 'smooth'」はスムーズなスクロール。「behavior: 'auto'」だと一瞬で移動する
    document.querySelector("#vy_main").scrollTo({
      top: height,
      behavior: 'smooth'
    })
  }

  // 指定のタグにフォーカスさせる
  let Page_id_focus = function(id){
    const elements = document.getElementById(id)
    elements.focus({preventScroll:false})

    elements.scrollIntoView({ behavior: 'instant', block: 'start' });

  }

  

  // メッセージを表示するウィンドウでOKを押された時
  let OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
    if(message_method.value == "update"){
      // 保存しますか？→OK
      Send()
    }else if(message_method.value == "validation_error"){
      // 未入力の必須項目があります→OK

//      Page_scroll(0)
    }else if(message_method.value  == "delete"){
      // 削除しますか？→OK
      Delete_set()
    }
  }

  // メッセージを表示するウィンドウを閉じる
  let Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
  }
   
  // エンター押下時のフォーカス移動
  let moveNext = function(event) {
    // enter_forcusというクラスの項目内で移動するようにする
    const elements = document.getElementsByClassName('enter_forcus')
    const index = [].findIndex.call(elements, e => e === event.target)

    // 要素数以内であれば次の項目へフォーカス
    if(elements[index + 1]){
      elements[index + 1].focus()
    }
  }
  

  // 申込める日時を配列として作成する
  let nittei_set = function(){
    set_nittei_list.value = []
    
    // 申込める日時のカウント
    let moushikomi_count = 0

    // 日程グループを格納
    let before_set_no = 0

    moushikomi_list.value = []
    let nittei_list_count = 0

    // 日程レコードから申込める日時を作成する
    nittei_list.value.forEach(function(nittei) {
      if(!moushikomi_list.value[nittei["nittei_set_no"]-1]){
          moushikomi_list.value[nittei["nittei_set_no"]-1] = []
        }

        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }

        before_set_no = nittei["nittei_set_no"]

        
      // 開催日（自・至）から日数を求める
      const start_date = new Date(nittei["kaisai_start"]);
        // カレンダーで表示する月を算出する
        // 初期値は開催日（自）と同じ年月
          if(!calendar_hyoji_date[nittei["nittei_set_no"]-1]){
            calendar_hyoji_date[nittei["nittei_set_no"]-1] = []
            calendar_hyoji_date[nittei["nittei_set_no"]-1] = new Date(start_date)
            calendar_year[nittei["nittei_set_no"]-1] = []
            calendar_year[nittei["nittei_set_no"]-1] = calendar_hyoji_date[nittei["nittei_set_no"]-1].getFullYear()
            calendar_month[nittei["nittei_set_no"]-1] = []
            calendar_month[nittei["nittei_set_no"]-1] = calendar_hyoji_date[nittei["nittei_set_no"]-1].getMonth() + 1  
            holiday_year_month[nittei["nittei_set_no"]-1] = []
            holiday_year_month[nittei["nittei_set_no"]-1] = calendar_year[nittei["nittei_set_no"]-1]+"-"+calendar_month[nittei["nittei_set_no"]-1]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(kaisai_end[nittei["nittei_set_no"]-1] == null){
              let nissu = mondate[calendar_month-1];
                  if(calendar_month[nittei["nittei_set_no"]-1]  == 2){
                    if(calendar_year[nittei["nittei_set_no"]-1] %4 == 0){
                      if(calendar_year[nittei["nittei_set_no"]-1] %100 == 0){
                        if(calendar_year[nittei["nittei_set_no"]-1] %400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              kaisai_end[nittei["nittei_set_no"]-1]  = calendar_year[nittei["nittei_set_no"]-1] +"-"+calendar_month[nittei["nittei_set_no"]-1] +"-"+nissu
            }
            
          }




      let set_kaisai_end = nittei["kaisai_end"] 

      // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
      if(nittei["kaisai_end"] == null){
        set_kaisai_end = kaisai_end
      }
      const end_date = new Date(set_kaisai_end);
      // 差日を求めた上で＋1することで日数になる
      const termDay = ((end_date - start_date) / 86400000) + 1;

      // 申込める時間帯を取得
      const jikantai_start = nittei["jikantai_start"]
      const jikantai_end = nittei["jikantai_end"]

      // この日程の各日の定員を取得
      const teiin = nittei["teiin"]

      // 開催曜日を取得
      let kaisai_list = []
      if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
        kaisai_list = nittei["kaisai_youbi"].split("、")
      }
      // 除外曜日を取得
      let jogai_list = []
      if(nittei["jogai"] != "" && nittei["jogai"] != null){
        jogai_list = nittei["jogai"].split("、")
      }
      
      // 除外日を取得
      let jogai_date = []
      if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
        jogai_date = nittei["jogai_date"].split("、")
      }


      for(let i = 0;i < termDay;i++){
        let date = new Date();
        if(i != 0) {
          date = start_date.setDate(start_date.getDate() + 1);
        }else{
          date = start_date.setDate(start_date.getDate());
        }
        let set_date = new Date(date)

        let set_year = set_date.getFullYear()
        let set_month = set_date.getMonth() + 1
        let set_day = set_date.getDate()
        let set_youbi = set_date.getDay()

        let moushikomibi = set_year+"/"+set_month+"/"+set_day
        let jogai_day = set_month+"/"+set_day
        

        // 開催曜日の指定がある場合
        if(kaisai_list.length != 0){
          // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
          if(kaisai_list.includes(youbi_list[set_youbi])) {


          }else{

            // 開催曜日に祝日がある場合
            if(kaisai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日でなければスルー
              if(!holidays_list.includes(moushikomibi)) continue
              
            }else{
              continue
            }
          }
        }

        // 除外曜日の指定がある場合
        if(jogai_list.length != 0){
          // 除外曜日に指定した曜日に該当する日の場合
          // 飛ばして次へ
          if(jogai_list.includes(youbi_list[set_youbi])) continue

          // 除外曜日に祝日がある場合
          if(jogai_list.includes("祝")){
            // 日付が祝日かどうかを確認
            // 祝日であれば飛ばして次へ
            if(holidays_list.includes(moushikomibi)) continue
            
          }
        }

        // 除外日の指定がある場合
        if(jogai_date.length){
          
          // 除外日に該当する日の場合
          // 飛ばして次へ
          if(jogai_date.includes(jogai_day)) continue
        }

        let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);
        
        // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
        let add_flg = 0
        moushikomi_list.value[nittei["nittei_set_no"]-1].filter( function (value) {
          if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
            // 同じ日時がすでにある場合は飛ばす
            add_flg = 1
          }
        })


        // 追加済みの日時であれば飛ばして次へ
        if(add_flg == 0){ 
          let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み

          // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
          moushikomi_list.value[nittei["nittei_set_no"]-1][moushikomi_count] = {"all_count":i,"moushikomi_count":moushikomi_count,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
          moushikomi_count++
        }
       
      }

        set_nittei_list.value[set_nittei_list.value.length] = nittei_list.value[nittei_list_count]
        nittei_list_count++
    });


    // 割り振った番号（日程グループ）ごとにリストを整える
    for(let n = 0;n<moushikomi_list.value.length;n++){
        
      // 時間帯順で並び替え
      moushikomi_list.value[n].sort((a, b) => b.jikantai_start - a.jikantai_start);

      // 日付順で並び替え
      moushikomi_list.value[n].sort((a, b) => a.date - b.date);

      let before_date = ""
      let date_bango = 0 // 日付ごとの番号

      // 同じ日付には同じ番号を振るようにする
      for(let md = 0;md<moushikomi_list.value[n].length;md++){
          if(moushikomi_list.value[n][md].hyoji_date != before_date){
              date_bango = date_bango + 1
          }
          //alert(before_date = moushikomi_list.value[n][md].hyoji_date)
          before_date = moushikomi_list.value[n][md].hyoji_date
          moushikomi_list.value[n][md].date_bango = date_bango
      }
    }

    let nittei_count = 0

    nittei_list.value[nittei_count]["ninzu"] = 0

    for(let n = 0;n<moushikomi_list.value.length;n++){
      // 申込状況レコードから、申込まれた日時の人数を確認する
      for(let j = 0;j<jyokyo_list.length;j++){
        
        jyokyo_list[j].forEach(function(jyokyo) {

            if(jyokyo.program_id == taiken_list.value.taiken_id){
                // 申込める日時配列内を、申込状況レコードでフィルター検索
                moushikomi_list.value[n].filter( function (value) {

                    if(taiken_list.value.teiin_settei == 1){
                        // 定員の扱いが1日ごとの場合は開催日が合致したら
                        if(jyokyo["kaisai_date"] == value.check_date){
                            // 合致した条件の人数を加算する
                            value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                        }
                    }else{
                        // 定員の扱いが時間帯ごとの場合は開催日・開催時間（自）が合致したら
                        if(jyokyo["kaisai_date"] == value.check_date 
                            && jyokyo["jikantai_start"] == value.jikantai_start
                            && jyokyo["jikantai_end"] == value.jikantai_end){
                            // 合致した条件の人数を加算する
                            value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                        }
                    }
                })
                nittei_count++
            }
        });
      }
    }
    

        // 日程ごとに選択する場合、1日目の参加人数を取得（1日目の人数＝他の日付の人数と同じ）
        for(let s2 = 0;s2<set_nittei_list.value.length;s2++){
            set_nittei_list.value[s2]["ninzu"] = 0
            jyokyo_list[0].forEach(function(jyokyo) {
                if(jyokyo["kaisai_date"] == set_nittei_list.value[s2]["kaisai_start"] 
                    && jyokyo["jikantai_start"] == set_nittei_list.value[s2]["jikantai_start"]){
                        // 合致した条件の人数を加算する
                        set_nittei_list.value[s2]["ninzu"] = jyokyo["ninzu"]
                }
            });
        }


    Calendar_set()
  }

  // カレンダーを表示する（活動１）
  let Calendar_set = function(){
    let calendarHtml = ''// HTMLを組み立てる変数

    // メインプログラムの日程をグループごとに処理する
    for(let m = 0;m<moushikomi_list.value.length;m++){
      let dayCount = 1 // 日にちのカウント
      const date = new Date(calendar_year[m],calendar_month[m],1)
      const year = date.getFullYear()
      const month = date.getMonth() 

      const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
      const endDate = new Date(year, month,  0) // 月の最後の日を取得
      const endDayCount = endDate.getDate() // 月の末日
      const startDay = startDate.getDay() // 月の最初の日の曜日を取得


      // 選択した日程ならカレンダーに写す
      if(NitteiActive.value == m) {

        calendarHtml += '<div id="calendar_button_area">';
          
        calendarHtml += '<div id="month_change_prev,'+m+'" class="month_change">＜＜前月</div>'+
                          '<div><h2 style="margin:0">'+(calendar_month[m])+' 月</h2></div>'+
                          '<div id="month_change_next,'+m+'" class="month_change">翌月＞＞</div>'+
                        '</div>'+
                        '<div id="title_area" style="border-bottom: 1px solid #000;">'+
                          '<div class="list_column_header calendar_column_left" style="color: red;">日</div>'+
                          '<div class="list_column_header calendar_column">月</div>'+
                          '<div class="list_column_header calendar_column">火</div>'+
                          '<div class="list_column_header calendar_column">水</div>'+
                          '<div class="list_column_header calendar_column">木</div>'+
                          '<div class="list_column_header calendar_column">金</div>'+
                          '<div class="list_column_header calendar_column_right" style="color:blue">土</div>'+
                        '</div></div>'

        // リスト全体の番号を割り振る
        for(let i = 0;i<moushikomi_list.value[m].length;i++){
            moushikomi_list.value[m][i].all_count = i
        }
        for (let w = 0; w < 6; w++) {

          // 1週間のうち、日付を入れたカラムを判定する
          let setCount = 0

          let set_html = '<div id="calendar_column_area" >'

            for (let d = 0; d < 7; d++) {
                  // 時間帯をいくつ配置したか
                  let datetime_count = 0
              set_html += '<div class="'
                if(d == 0) {
                  set_html += 'calendar_column_left'
                }else if(d == 6){
                  set_html += 'calendar_column_right'

                }else{
                  set_html += 'calendar_column'
                  
                }
                set_html += '">'
                if (w == 0 && d < startDay) {
                    // 1行目で1日の曜日の前
                    set_html += '<div class="column_date_blank"></div>'
                } else if (dayCount > endDayCount) {
                    // 末尾の日数を超えた
                    set_html += '<div class="column_date_blank"></div>'
                } else {


                  // 申込リスト内に日付がある場合は申込まれた人数を表示

                  // 現在表示する日付をセット
                  let setDate = calendar_year[m]+"-"+('00'+(calendar_month[m])).slice(-2)+"-"+('00'+dayCount).slice(-2)
                  let checkHoliday = calendar_year[m]+"/"+calendar_month[m] + "/"+ dayCount
                  
                  // 日付を入力
                  set_html += '<div class="column_date">'
                  set_html += '<div class="column_date_day"><span '

                    // 祝 or 日なら赤
                    if(holidays_list.includes(checkHoliday) || d == 0){
                      set_html += "style='color:red'"
                    }else if(d == 6){

                      // 土なら青
                      set_html += "style='color:blue'"
                    }
                  set_html += '/>'
                  set_html +=  dayCount
                  set_html += '</span></div>'

                  moushikomi_list.value[m].filter( function (value) {

  //                  console.log(setDate+"/"+value.check_date)

                    // 申込める日付リストに存在していたら時間帯を表示
                      if(setDate == value.check_date ){
                          // 申込人数 / 定員は定員の扱いが「1日ごと」なら時間帯の上に1つだけ表記
                          if(taiken_list.value.teiin_settei == 1 && datetime_count == 0){
                            
                                set_html += " <b style='"
                                // 申込人数が定員より少ないときは青色
                                if(value.ninzu < taiken_list.value.teiin_oneday){
                                    set_html += "color:blue"
                                }else{// 申込人数が定員のときは赤色
                                    set_html += "color:red"
                                }
                                set_html += "'>"
                                set_html += value.ninzu
                                
                                // 定員がnullの場合は表示しない
                                if(taiken_list.value.teiin_oneday!= null){
                                  set_html +=  "/"+ taiken_list.value.teiin_oneday
                                }
                                set_html += '</b>'
                                datetime_count++
                          }
                        set_html += '<div class="column_date_time">'
                          // 時間帯                 
                          // 他に申込んでいるプログラムがないなら時間帯を表示
                          if(value.moushikomi_flg == 0){

                              set_html += '<div class="set_id'+value.all_count+'" id="'+value.all_count+","+setDate+','+value.jikantai_start+','+value.jikantai_end+','+value.ninzu+','+value.teiin+','+value.date_bango+',jikantai_click" style="display: flex;align-items: center;'
                                  
                                set_html += "cursor:pointer;border-bottom:1px solid #000;"
                            

                              set_html += '">'
                                set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)
                                
                              // 申込人数 / 定員は定員の扱いが「時間帯ごと」なら時間帯の後に表記
                              if(taiken_list.value.teiin_settei == 0){

                                set_html += " <b style='margin-left:10px;"
                                
                                // 申込人数が定員より少ないときは青色
                                if(value.ninzu < value.teiin){
                                    set_html += "color:blue"
                                }else{// 申込人数が定員のときは赤色
                                    set_html += "color:red"
                                }
                                
                                set_html += "'>"
                                set_html += value.ninzu
                                
                                // 定員がnullの場合は表示しない
                                /*
                                if(value.teiin != null){
                                  set_html +=  "/"+ value.teiin
                                }*/
                                set_html += '</b>'
                              }

                              set_html += '</div>'
                            
                          }else{

                            set_html += '<span style="color:red">'
                            
                            if(value.moushikomi_flg == 1){
                              set_html += '他の体験プログラムに参加'
                            }else{
                              set_html += '事前説明会に参加'
                            }
                            
                            set_html += '</span>'
                          }
                          set_html += '</div>'
                      }
                      
                  })
                  datetime_count = 0
                  set_html += '</div>'

                  dayCount++
                  setCount++
                }
                datetime_count = 0
                set_html += '</div>'
            }
            set_html += '</div>'

            // 日付の入ったカラムが1個でもあれば行として追加
            if(setCount !=0){
              calendarHtml += set_html
            }
        }
      }
    }


    Calendar.value = calendarHtml
    
  }

  
  // カレンダーの月を加算・減算し、再度カレンダーを表示する（活動１）
  let Change_month = function(num,nittei){
    calendar_month[nittei] = calendar_month[nittei] + num

    if(calendar_month[nittei] == 0) {
      calendar_month[nittei] = 12
      calendar_year[nittei] = calendar_year[nittei] - 1
    }
    if(calendar_month[nittei] == 13) {
      calendar_month[nittei] = 1
      calendar_year[nittei] = calendar_year[nittei] + 1
    }
    Calendar_set()
  }


  // カレンダー上の時間帯をクリックした時
  let htmlColumnClick = function(e){

    let clicked = e.target.id

    if(clicked == "") return

      let Click_array = clicked.split(",")
      if(Click_array[0] == "link_katsudou_cal"){
          // 別の活動に移動する
          link_katsudou_cal(Click_array[1])
          
      }else if(Click_array[0] == "link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2])
      }else if(Click_array[0] == "month_change_prev"){
        // カレンダーの月を1つ戻す
        Change_month(-1,Click_array[1])
      }else if(Click_array[0] == "month_change_next"){
        // カレンダーの月を1つ進める
        Change_month(1,Click_array[1])
      }else if(Click_array[7] == "jikantai_click"){
        
        if(Click_array[4] == 0){
          return;
        }
        Sankasha_check(Click_array[1],Click_array[1],Click_array[2])
      }
      
  }


  // 体験プログラム詳細・選択した日時の参加者を取得する
  let Sankasha_check = function(kaisai_date0,kaisai_end0,jikantai_start0){

    let set_list = {"id":taiken_id,"shubetsu":taiken_list.value.shubetsu,"kaisai_date":kaisai_date0,"kaisai_end":kaisai_end0,"jikantai_start":jikantai_start0,
    "main":taiken_list.value,
    "katsudou":taiken_list.value}

    emit('call',{cmd:'jyokyodate',set_list0:set_list})
  }

  // 申込める日時を配列として作成する（活動２～）
  let sub_nittei_set = function(){
    
    sub_set_nittei_list.value = [] 
    // サブプログラムの数だけ日程データがある
    for(let s = 0;s<sub_nittei_list.value.length;s++){

      sub_calendar_hyoji_date[s] = []
      sub_calendar_year[s] = []
      sub_calendar_month[s] = []
      sub_holiday_year_month[s] = []
      sub_kaisai_start[s] = []
      sub_kaisai_end[s] = []

      // 申込める日時のカウント
      let moushikomi_count = 0

      // 日程グループを格納
      let before_set_no = 0

        moushikomi_list_sub.value[s] = []

      let nittei_list_count = 0
      sub_set_nittei_list.value[s] = []

      // 日程レコードから申込める日時を作成する
      sub_nittei_list.value[s].forEach(function(nittei) {
        if(!moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1]){
          moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1] = []
        }

        // 日程グループが変わったら申込カウントをリセット
        if(before_set_no != nittei["nittei_set_no"]){
          moushikomi_count = 0
        }

        before_set_no = nittei["nittei_set_no"]

        // 開催日（自・至）から日数を求める
        const start_date = new Date(nittei["kaisai_start"]);

        if(moushikomi_count == 0){
          // カレンダーで表示する月を算出する
          // 日程の最初の日付を利用する
          
          if(!sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1]){
            sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1] = new Date(start_date)
            sub_calendar_year[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_year[s][nittei["nittei_set_no"]-1] = sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1].getFullYear()
            sub_calendar_month[s][nittei["nittei_set_no"]-1] = []
            sub_calendar_month[s][nittei["nittei_set_no"]-1] = sub_calendar_hyoji_date[s][nittei["nittei_set_no"]-1].getMonth() + 1  
            sub_holiday_year_month[s][nittei["nittei_set_no"]-1] = []
            sub_holiday_year_month[s][nittei["nittei_set_no"]-1] = sub_calendar_year[s][nittei["nittei_set_no"]-1]+"-"+sub_calendar_month[s][nittei["nittei_set_no"]-1]+"-01"
            
            let mondate = [31,28,31,30,31,30,31,31,30,31,30,31];//月ごとの最終日

            // 開催日（至）がnullの場合は、その月の最後までを対象とする
            if(sub_kaisai_end[s][nittei["nittei_set_no"]-1] == null){
              let nissu = mondate[sub_calendar_month[s]-1];
                  if(sub_calendar_month[s][nittei["nittei_set_no"]-1] == 2){
                    if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%4 == 0){
                      if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%100 == 0){
                        if(sub_calendar_year[s][nittei["nittei_set_no"]-1]%400 == 0){
                          nissu = 29;
                        }
                      }else{
                        nissu = 29;
                          
                      }
                    }
                  }
              sub_kaisai_end[s][nittei["nittei_set_no"]-1] = sub_calendar_year[s][nittei["nittei_set_no"]-1]+"-"+sub_calendar_month[s][nittei["nittei_set_no"]-1]+"-"+nissu
            }
          }

        }

        let set_kaisai_end = nittei["kaisai_end"] 

        // 日程の開催日（至）が未入力の場合、全体の開催日（自）の月末を開催日（至）と判断する
        if(nittei["kaisai_end"] == null){
          set_kaisai_end = kaisai_end
        }
        const end_date = new Date(set_kaisai_end);
        // 差日を求めた上で＋1することで日数になる
        const termDay = ((end_date - start_date) / 86400000) + 1;

        // 申込める時間帯を取得
        const jikantai_start = nittei["jikantai_start"]
        const jikantai_end = nittei["jikantai_end"]

        // この日程の各日の定員を取得
        const teiin = nittei["teiin"]

        // 開催曜日を取得
        let kaisai_list = []
        if(nittei["kaisai_youbi"] != "" && nittei["kaisai_youbi"] != null){
          kaisai_list = nittei["kaisai_youbi"].split("、")
        }
        // 除外曜日を取得
        let jogai_list = []
        if(nittei["jogai"] != "" && nittei["jogai"] != null){
          jogai_list = nittei["jogai"].split("、")
        }
        
        // 除外日を取得
        let jogai_date = []
        if(nittei["jogai_date"] != "" && nittei["jogai_date"] != null){
          jogai_date = nittei["jogai_date"].split("、")
        }
        for(let i = 0;i < termDay;i++){
          let date = new Date();
          if(i != 0) {
            date = start_date.setDate(start_date.getDate() + 1);
          }else{
            date = start_date.setDate(start_date.getDate());
          }
          let set_date = new Date(date)

          let set_year = set_date.getFullYear()
          let set_month = set_date.getMonth() + 1
          let set_day = set_date.getDate()
          let set_youbi = set_date.getDay()

          let moushikomibi = set_year+"/"+set_month+"/"+set_day
          let jogai_day = set_month+"/"+set_day
          

          // 開催曜日の指定がある場合
          if(kaisai_list.length != 0){
            // 開催曜日に指定した曜日に該当する日の場合はそのまま追加
            if(kaisai_list.includes(youbi_list[set_youbi])) {


            }else{

              // 開催曜日に祝日がある場合
              if(kaisai_list.includes("祝")){
                // 日付が祝日かどうかを確認
                // 祝日でなければスルー
                if(!holidays_list.includes(moushikomibi)) continue
                
              }else{
                continue
              }
            }
          }

          // 除外曜日の指定がある場合
          if(jogai_list.length != 0){
            // 除外曜日に指定した曜日に該当する日の場合
            // 飛ばして次へ
            if(jogai_list.includes(youbi_list[set_youbi])) continue

            // 除外曜日に祝日がある場合
            if(jogai_list.includes("祝")){
              // 日付が祝日かどうかを確認
              // 祝日であれば飛ばして次へ
              if(holidays_list.includes(moushikomibi)) continue
              
            }
          }

          // 除外日の指定がある場合
          if(jogai_date.length){
            
            // 除外日に該当する日の場合
            // 飛ばして次へ
            if(jogai_date.includes(jogai_day)) continue
          }

          let check_date = set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2);

          
          // この申込日時を追加すべきかどうか（0：追加する、1：追加しない）
          let add_flg = 0
          moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1].filter( function (value) {
            if(check_date == value.check_date && nittei["jikantai_start"] == value.jikantai_start && nittei["jikantai_end"] == value.jikantai_end){
              // 同じ日時がすでにある場合は飛ばす
              add_flg = 1
            }
          })


          // 追加済みの日時であれば飛ばして次へ
          if(add_flg == 0){ 
            let moushikomi_flg = 0 // 0：申込みなし、1:体験プログラムに申込み済み、2：事前説明会に申込み済み
            // Dateは並び替え用のdate、申込み状況確認用のcheck_date、実際に表示するhyoji_dateを用意
            moushikomi_list_sub.value[s][nittei["nittei_set_no"]-1][moushikomi_count] = {"all_count":i,"moushikomi_count":moushikomi_count,"date":set_date,"check_date":check_date,"hyoji_date":moushikomibi,"youbi":youbi_list[set_youbi],"jikantai_start":jikantai_start,"jikantai_end":jikantai_end,"ninzu":0,"teiin":teiin,"moushikomi_flg":moushikomi_flg}
            moushikomi_count++
          }
        
        }
        
        sub_set_nittei_list.value[s][sub_set_nittei_list.value[s].length] = sub_nittei_list.value[s][nittei_list_count]
        nittei_list_count++
      });


      // 割り振った番号（日程グループ）ごとにリストを整える
      for(let n = 0;n<moushikomi_list_sub.value[s].length;n++){
        
      // 時間帯順で並び替え
        moushikomi_list_sub.value[s][n].sort((a, b) => b.jikantai_start - a.jikantai_start);

        // 日付順で並び替え
        moushikomi_list_sub.value[s][n].sort((a, b) => a.date - b.date);

        let before_date = ""
        let date_bango = 0 // 日付ごとの番号

        // 同じ日付には同じ番号を振るようにする
        for(let md = 0;md<moushikomi_list_sub.value[s][n].length;md++){
            if(moushikomi_list_sub.value[s][n][md].hyoji_date != before_date){
                date_bango = date_bango + 1
            }
            //alert(before_date = moushikomi_list_sub.value[s][n][md].hyoji_date)
            before_date = moushikomi_list_sub.value[s][n][md].hyoji_date
            moushikomi_list_sub.value[s][n][md].date_bango = date_bango
        }
      }

      let nittei_count = 0
        sub_nittei_list.value[s][nittei_count]["ninzu"] = 0
        // 申込状況レコードから申込まれた日時の人数を確認する
          
        for(let n = 0;n<moushikomi_list_sub.value[s].length;n++){
           // 申込状況レコードから、申込まれた日時の人数を確認する
            for(let j = 0;j<jisseki_all.length;j++){
                jisseki_all[j].forEach(function(jyokyo) {
                    if(jyokyo.program_id == sub_list.value[s].taiken_id){
                        // 申込める日時配列内を、申込状況レコードの開催日・開催時間（自）でフィルター検索
                        moushikomi_list_sub.value[s][n].filter( function (value) {
                   
                            if(sub_list.value[s].teiin_settei == 1){
                                // 定員の扱いが1日ごとの場合は開催日が合致したら
                                if(jyokyo["kaisai_date"] == value.check_date){
                                    // 合致した条件の人数を加算する
                                    value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                                    sub_nittei_list.value[s][nittei_count]["ninzu"] = jyokyo["ninzu"]
                                }
                            }else{
                                // 定員の扱いが時間帯ごとの場合は開催日・開催時間（自）が合致したら
                                if(jyokyo["kaisai_date"] == value.check_date 
                                    && jyokyo["jikantai_start"] == value.jikantai_start
                                    && jyokyo["jikantai_end"] == value.jikantai_end){
                                    // 合致した条件の人数を加算する
                                    value.ninzu =  value.ninzu + jyokyo["ninzu"] 
                                    sub_nittei_list.value[s][nittei_count]["ninzu"] = jyokyo["ninzu"]
                                }
                            }
                        })
                    nittei_count++
                    }
                });
            }
        }
         // 日程ごとに選択する場合、1日目の参加人数を取得（1日目の人数＝他の日付の人数と同じ）
        for(let s2 = 0;s2<sub_set_nittei_list.value[s].length;s2++){
            sub_set_nittei_list.value[s][s2]["ninzu"] = 0
            jyokyo_list[s+1].forEach(function(jyokyo) {
                // 申込める日時配列内を、申込状況レコードの開催日・開催時間（自）でフィルター検索
                if(jyokyo["kaisai_date"] == sub_set_nittei_list.value[s][s2]["kaisai_start"] 
                    && jyokyo["jikantai_start"] == sub_set_nittei_list.value[s][s2]["jikantai_start"]){
                        // 合致した条件の人数を加算する
                        sub_set_nittei_list.value[s][s2]["ninzu"] = jyokyo["ninzu"]
                }
            });
        }

    }

    Sub_Calendar_set(KatsudouActive_no.value)
  }
  
  // カレンダーを表示する（活動２～）
  let Sub_Calendar_set = function(program_num){
    
     let all_sub_calendar = ""

    console.log("program_num:"+program_num)
     
    // サブプログラムの数だけ日程データがある
    for(let s = 0;s<sub_nittei_list.value.length;s++){
      if(s != program_num) continue;

      let calendarHtml = '' // HTMLを組み立てる変数
      let add_flg = 0

      
      // 日程ごとに処理する
      for(let m = 0;m<moushikomi_list_sub.value[s].length;m++){
        add_flg = 0
        
      // 選択した日程ならカレンダーに写す
      if(NitteiActive.value == m) {
        add_flg = 1 // 追加していい日程かどうかフラグを立てる
        let dayCount = 1 // 日にちのカウント
        const date = new Date(sub_calendar_year[s][m],sub_calendar_month[s][m],1)
        const year = date.getFullYear()
        const month = date.getMonth() 

        const startDate = new Date(year, month - 1, 1) // 月の最初の日を取得
        const endDate = new Date(year, month,  0) // 月の最後の日を取得
        const endDayCount = endDate.getDate() // 月の末日
        const startDay = startDate.getDay() // 月の最初の日の曜日を取得
        calendarHtml += '<div id="calendar_button_area">';
        
        calendarHtml += '<div id="sub_month_change_prev,'+s+','+m+'" class="month_change">＜＜前月</div>'+
                        '<div><h2 style="margin:0">'+(sub_calendar_month[s][m])+' 月</h2></div>'+
                        '<div id="sub_month_change_next,'+s+','+m+'" class="month_change">翌月＞＞</div>'+
                      '</div>'+
                      '<div id="title_area" style="border-bottom: 1px solid #000;">'+
                        '<div class="list_column_header calendar_column_left" style="color: red;">日</div>'+
                        '<div class="list_column_header calendar_column">月</div>'+
                        '<div class="list_column_header calendar_column">火</div>'+
                        '<div class="list_column_header calendar_column">水</div>'+
                        '<div class="list_column_header calendar_column">木</div>'+
                        '<div class="list_column_header calendar_column">金</div>'+
                        '<div class="list_column_header calendar_column_right" style="color:blue">土</div>'+
                      '</div></div>'

        // リスト全体の番号を割り振る
        for(let i = 0;i<moushikomi_list_sub.value[s][m].length;i++){
            moushikomi_list_sub.value[s][m][i].all_count = i
        }
        for (let w = 0; w < 6; w++) {

        // 1週間のうち、日付を入れたカラムを判定する
        let setCount = 0


        let set_html = '<div id="calendar_column_area" >'

          for (let d = 0; d < 7; d++) {
            // 時間帯をいくつ配置したか
            let datetime_count = 0
            set_html += '<div class="'
              if(d == 0) {
                set_html += 'calendar_column_left'
              }else if(d == 6){
                set_html += 'calendar_column_right'

              }else{
                set_html += 'calendar_column'
                
              }
              set_html += '" style="height:100px">'
              if (w == 0 && d < startDay) {
                  // 1行目で1日の曜日の前
                  set_html += '<div class="column_date_blank"></div>'
              } else if (dayCount > endDayCount) {
                  // 末尾の日数を超えた
                  set_html += '<div class="column_date_blank"></div>'
              } else {


                // 申込リスト内に日付がある場合は申込まれた人数を表示

                // 現在表示する日付をセット
                let setDate = sub_calendar_year[s][m]+"-"+('00'+(sub_calendar_month[s][m])).slice(-2)+"-"+('00'+dayCount).slice(-2)
                let checkHoliday = sub_calendar_year[s][m]+"/"+sub_calendar_month[s][m] + "/"+ dayCount
                
                // 日付を入力
                set_html += '<div class="column_date">'
                set_html += '<div class="column_date_day"><span '

                  // 祝 or 日なら赤
                  if(holidays_list.includes(checkHoliday) || d == 0){
                    set_html += "style='color:red'"
                  }else if(d == 6){

                    // 土なら青
                    set_html += "style='color:blue'"
                  }
                set_html += '/>'
                set_html +=  dayCount
                set_html += '</span></div>'


                moushikomi_list_sub.value[s][m].filter( function (value) {
                  
                  // 申込める日付リストに存在していたら時間帯を表示
                    if(setDate == value.check_date ){
                      
                      // 申込人数 / 定員は定員の扱いが「1日ごと」なら時間帯の上に1つだけ表記
                      if(sub_list.value[s].teiin_settei == 1 && datetime_count == 0){
                        
                            set_html += " <b style='"
                            // 申込人数が定員より少ないときは青色
                            if(value.ninzu < sub_list.value[s].teiin_oneday){
                                set_html += "color:blue"
                            }else{// 申込人数が定員のときは赤色
                                set_html += "color:red"
                            }
                            set_html += "'>"
                            set_html += value.ninzu
                            
                            // 定員がnullの場合は表示しない
                            if(sub_list.value[s].teiin_oneday!= null){
                              set_html +=  "/"+ sub_list.value[s].teiin_oneday
                            }
                            set_html += '</b>'
                            datetime_count++
                      }
                      set_html += '<div class="column_date_time">'
                        // 時間帯                 
                        // 他に申込んでいるプログラムがないなら時間帯を表示
                        if(value.moushikomi_flg == 0){
                            set_html += '<div class="set_id'+value.all_count+'" ';
                            set_html += 'id="'+value.all_count+","+setDate+','+value.jikantai_start+','+value.jikantai_end+','+value.ninzu+','+value.teiin+','+value.date_bango+',jikantai_click,'+s+'"';
                            set_html += 'style="display: flex;align-items: center;'
                                
                            set_html += "cursor:pointer;border-bottom:1px solid #000;"

                            set_html += '">'
                              set_html += TimeSetting(value.jikantai_start) +'～'+TimeSetting(value.jikantai_end)
                              

                            // 申込人数 / 定員は定員の扱いが「時間帯ごと」なら時間帯の後に表記
                          if(sub_list.value[s].teiin_settei == 0){

                            set_html += " <b style='margin-left:10px;"
                            
                            // 申込人数が定員より少ないときは青色
                            if(value.ninzu < value.teiin){
                                set_html += "color:blue"
                            }else{// 申込人数が定員のときは赤色
                                set_html += "color:red"
                            }
                            
                            set_html += "'>"
                            set_html += value.ninzu
                            
                            // 定員がnullの場合は表示しない
                            if(value.teiin != null){
                              set_html +=  "/"+ value.teiin
                            }
                            set_html += '</b>'
                          }
                          set_html += '</div>'
                        }else{

                          set_html += '<span style="color:red">'
                          
                          if(value.moushikomi_flg == 1){
                            set_html += '他の体験プログラムに参加'
                          }else{
                            set_html += '事前説明会に参加'
                          }
                          
                          set_html += '</span>'
                        }
                        set_html += '</div>'
                    }
                })
                datetime_count = 0
                set_html += '</div>'

                dayCount++
                setCount++

              }
                datetime_count = 0
              set_html += '</div>'
          }
          set_html += '</div>'

          // 日付の入ったカラムが1個でもあれば行として追加
          if(setCount !=0){
            calendarHtml += set_html
          }
        }
      }

      if(add_flg == 1) all_sub_calendar += calendarHtml
    }
    }

    Calendar_sub.value = all_sub_calendar
    
  }

  // カレンダーの月を加算・減算し、再度カレンダーを表示する（活動２～）
  let Sub_Change_month = function(num,program_num,nittei){
    // 指定したプログラムナンバーの月を処理する
    sub_calendar_month[program_num][nittei] = sub_calendar_month[program_num][nittei] + num
    if(sub_calendar_month[program_num][nittei] == 0) {
      sub_calendar_month[program_num][nittei] = 12
      sub_calendar_year[program_num][nittei] = sub_calendar_year[program_num][nittei] - 1

    }
    if(sub_calendar_month[program_num][nittei] == 13) {
      sub_calendar_month[program_num][nittei] = 1
      sub_calendar_year[program_num][nittei] = sub_calendar_year[program_num][nittei] + 1
    }
    Sub_Calendar_set(program_num)
  }

  // v-html内の要素をクリックした時（活動2～）
  let sub_htmlColumnClick = function(e){

    let clicked = e.target.id

    if(clicked == "") return

    let Click_array = clicked.split(",")
      if(Click_array[0] == "sub_link_katsudou_cal"){
        // 別の活動に移動する
        link_katsudou_cal(Click_array[1])
      }else   if(Click_array[0] == "sub_link_katsudou_cal_nittei"){
        // 活動内の別の日程に移動する
        link_katsudou_cal_nittei(Click_array[1],Click_array[2])
      }else if(Click_array[0] == "sub_month_change_prev"){
        // カレンダーの月を1つ戻す
        Sub_Change_month(-1,Click_array[1],Click_array[2])
      }else if(Click_array[0] == "sub_month_change_next"){
        // カレンダーの月を1つ進める
        Sub_Change_month(1,Click_array[1],Click_array[2])
      }else if(Click_array[7] == "jikantai_click"){
        
        if(Click_array[4] == 0){
          return;
        }
        Sub_Sankasha_check(Click_array[1],Click_array[1],Click_array[2],Click_array[8])
      }

  }
  
  // 体験プログラム詳細・選択した日時の参加者を取得する
  let Sub_Sankasha_check = function(kaisai_date0,kaisai_end0,jikantai_start0,program_num){
    console.log(sub_list.value[program_num].taiken_id)
    let set_list = {"id":sub_list.value[program_num].taiken_id,"shubetsu":taiken_list.value.shubetsu,
    "kaisai_date":kaisai_date0,"kaisai_end":kaisai_end0,
    "jikantai_start":jikantai_start0,"main":taiken_list.value,"katsudou":sub_list.value[program_num]}
    emit('call',{cmd:'jyokyodate',set_list0:set_list})
  }

let checkin = function(){
    router.push('/'+GlobalData.shakyo + '/' + route.params.shisetsu + '/Shisetsu/checkin/' + taiken_list.value.main_taiken_id)
  
}


  /* 算出プロパティ */
  // エンターでフォーカスを当てたいクラス名を指定
  const elements = computed(() => {
    return document.getElementsByClassName("enter_forcus");
  })

  let Mail_send = function(){
    // 親コンポーネントへ、メール送信ウィンドウを開くよう命令する
    emit('call',{cmd:'mail_send',syurui:3,program_id:taiken_id});
      
  }
  
  let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/18cc0be34f8f80c68c27ca80c997c080"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

//------------------- Googlemap（外部リンク）へ
const jusho = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

//------------------- 添付資料（外部リンク）へ
const shiryo_open = (url)  => { 
    window.open(url,"_blank")

}
  /* 変数の監視 */
  watchEffect(() => {
   
  
  })


  // 編集画面の場合
  if(type == 1){
    // 〆切日時から〆切日と〆切時間を抜き出す
    if(taiken_list.value.shimekiri_date){

      let eudate = Date.parse(taiken_list.value.shimekiri_date);
      let eu_set_date = new Date(eudate);
      eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      eu_set_date = new Date(eu_set_date);
      eu_set_date.setHours(eu_set_date.getHours()-9);
  
      const set_month = eu_set_date.getMonth()+1
  
      // 日時から日と時をそれぞれ抜き出す
      let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
      let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
  
      let set_date = new Date(day + " "+time)
      set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      set_date = new Date(set_date);
 
      // 〆切日時から日と時をそれぞれ抜き出す
      shimekiri_day.value = (set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2)
      shimekiri_time.value = ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2);
    }

    if(props.param.sub != undefined){
      // サブ活動の場合は存在しているかどうかをまず確認
      for(let s = 0;s<sub_list.value.length;s++){
        // 〆切日時から〆切日と〆切時間を抜き出す
        if(sub_list.value[s].shimekiri_date){
          
          let eudate = Date.parse(sub_list.value[s].shimekiri_date);
          let eu_set_date = new Date(eudate);
          eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
          eu_set_date = new Date(eu_set_date);
          eu_set_date.setHours(eu_set_date.getHours()-9);
      
          const set_month = eu_set_date.getMonth()+1
      
          // 日時から日と時をそれぞれ抜き出す
          let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
          let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
      
          let set_date = new Date(day + " "+time)
          set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
          set_date = new Date(set_date);
    
          // 〆切日時から日と時をそれぞれ抜き出す
          sub_shimekiri_day.value[s] = (set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2)
          sub_shimekiri_time.value[s] = ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2);
        }

      }        
    }


    
    // 分類1から分類2をセット
    bunrui1_list_set()
    
    // 制作・寄付かどうかの確認（一部項目の表示・非表示）
    change_seisaku()

    // 日程データから表示用の日程を作成する（メイン・サブ両方）
    disp_nittei_list_setting()
  }

// 受入先情報取得
let Facility_Read_error = 0
let Facility_Read = function() {

    axios.post(GlobalData.$API_URL + "Facility_read",
	{
        facility_id: taiken_list.value.facility_id == null ? 0 : taiken_list.value.facility_id
	},
    GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
	.then(response => {
		//正常な結果が返ってきた場合の処理
		if(response.data["status"] == 1){

        message.value = "エラーが発生しました。\n"+response.data["message"];
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "read_error";
        contentMessage.value = MessageModal
		}else{

      if(response.data["facility_info"].length <= 0 ){
          facility = []
          facility_id = 0
          facility_name.value = ""
      } else {
          facility = response.data["facility_info"]
          facility_id = facility.facility_id
          facility_name.value = facility.facility_name
      }
    }

    })
	.catch(error => {  
        if(Facility_Read_error == 6){
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal
        }else{
            Facility_Read_error++
            setTimeout(function(){Facility_Read()},"1000")
        }
    })
}

Facility_Read()

// 受入先の選択画面表示
let Facility_select = function(){
 
  paramFacility = {'facility_id':facility_id }
  facility_area.value = true
  contentFacility.value = FacilitySelect

}

// 受入先の削除
let Facility_delete = function(){
    facility_id = 0
    facility_name.value = "選択されていません。"
}

// 申込み・申込み取消の未読チェック
let param = {
    choson_code:cityname,
    facility_code:facility_code,
    program_kbn:1,
    kubun:'1,2'
}
emit('call',{cmd:'check_moushikomi_message',param:param});

      //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
      const call = function(proc) {

          switch(proc.cmd) {
              case "close":
                  
                nittei_area.value = false
                break

              case "nittei_add":
                console.log(proc.disp_nittei_list)
                // 日程編集ウィンドウからリターン（新規追加時）
                // 編集ウィンドウから送られてきた配列を、最後の番地の配列として追加する
                if(proc.program_num == 9999){
                  // メインの場合
                  disp_nittei_list.value[disp_nittei_list.value.length] = proc.disp_nittei_list
                  console.log(disp_nittei_list.value)
                }else{
                  // サブの場合
                  sub_disp_nittei_list.value[proc.program_num][sub_disp_nittei_list.value[proc.program_num].length] = proc.disp_nittei_list
                  console.log(sub_disp_nittei_list.value[proc.program_num][proc.num])
                }
                nittei_area.value = false

                // グループ番号を振りなおす
                group_setting(proc.program_num)
                break
              case "nittei_edit":
                console.log(proc.disp_nittei_list)
                // 日程編集ウィンドウからリターン（編集時）
                // 編集ウィンドウから送られてきた配列を、同じ番地の配列へ上書きする
                if(proc.program_num == 9999){
                  // メインの場合
                  disp_nittei_list.value[proc.num] = proc.disp_nittei_list
                  console.log(disp_nittei_list.value)
                }else{
                  // サブの場合
                  sub_disp_nittei_list.value[proc.program_num][proc.num] = proc.disp_nittei_list
                  console.log(sub_disp_nittei_list.value[proc.program_num][proc.num])

                }
                nittei_area.value = false

                // グループ番号を振りなおす
                group_setting(proc.program_num)
                break
              case "nittei_calendar":
                // 日程編集ウィンドウからリターン（編集時）
                // 編集ウィンドウから送られてきた除外日と開催期間を、同じ番地の配列へ上書きする
                let return_list = proc.disp_nittei_list
                if(proc.program_num == 9999){
                  // メインの場合
                  disp_nittei_list.value[NitteiActive.value]["kaisai_start"] = return_list["kaisai_start"]
                  disp_nittei_list.value[NitteiActive.value]["kaisai_end"] = return_list["kaisai_end"]
                  disp_nittei_list.value[NitteiActive.value]["jogai_date"] = return_list["jogai_date"]
                }else{
                  // サブの場合
                  sub_disp_nittei_list.value[proc.program_num]["kaisai_start"] = return_list["kaisai_start"]
                  sub_disp_nittei_list.value[proc.program_num]["kaisai_end"] = return_list["kaisai_end"]
                  sub_disp_nittei_list.value[proc.program_num]["jogai_date"] = return_list["jogai_date"]

                }
                nittei_area.value = false
                break
              case "facility_select":
                // 受入先選択画面から受入先情報を取得

                // 受入先ID
                facility_id = proc.facility.facility_id

                // 受入先名
                facility_name.value = proc.facility.facility_name
                taiken_list.value.s_name = proc.facility.facility_name

                /*
                // プログラム側
                受入先住所	s_jusyo
                受入先連絡先電話番号	s_tel
                受入先FAX番号	s_fax
                受入先Eメールアドレス	s_email
                受入先担当者名	s_tantou
                受入先備考	s_bikou
                受入先コメント	s_comment

                // 受入先側
                施設住所	facility_jusyo
                施設連絡先電話番号	facility_tel
                施設FAX番号	facility_fax
                施設Eメールアドレス	facility_email
                施設担当者名	facility_tantou
                施設備考	facility_bikou
                施設コメント	facility_comment
                */

                console.log(proc)
                taiken_list.value.s_jusyo = proc.facility.facility_jusyo
                taiken_list.value.s_tel = proc.facility.facility_tel
                taiken_list.value.s_fax = proc.facility.facility_fax
                taiken_list.value.s_email = proc.facility.facility_email
                taiken_list.value.s_tantou = proc.facility.facility_tantou
                taiken_list.value.s_bikou = proc.facility.facility_bikou
                taiken_list.value.s_comment = proc.facility.facility_comment

                // 受入先選択画面を閉じる
                facility_area.value = false
                contentFacility.value = null
                break
              case "facility_close":
                // 受入先選択画面を閉じる
                facility_area.value = false
                contentFacility.value = null
                break
              default:
      
                  break
          }
      }
  

  //親コンポーネントで利用する関数の指定
  defineExpose({
    Update_check,
  });


  /* 初期処理 */
  
    // 祝日を取得
    const calendarId = 'japanese__ja@holiday.calendar.google.com'
    const calendarApiUrl = 'https://www.googleapis.com/calendar/v3/calendars/'
    const apiKey = GlobalData.$holiday_key

    // 祝日を格納する配列
    let holidays_list = []
    
    function loadGoogleCalendarApi() {
        gapi.client.init({
            apiKey: apiKey,
        }).then(() => {
            return gapi.client.request({
            path: calendarApiUrl + encodeURIComponent(calendarId) + '/events'
            })
        }).then((res) => {
            
            const today = new Date()
            let set_date = new Date(today);
            set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            set_date = new Date(set_date);
            
            // Googleカレンダーで祝日にされてしまっているもの
            let not_holiday = ["雛祭り","クリスマス","母の日","七五三","節分","七夕"]
            const items = res.result.items

            for(let i = 0; i < items.length; i++){
                // 今年と来年の祝日だけ取得
                if(items[i].start.date.substring(0,4) == set_date.getFullYear() ||
                    items[i].start.date.substring(0,4) == (set_date.getFullYear()+1) ){

                        if(!not_holiday.includes(items[i].summary)){
                            let set_date = new Date(items[i].start.date)
                            let set_year = set_date.getFullYear()
                            let set_month = set_date.getMonth() + 1
                            let set_day = set_date.getDate()
                            holidays_list[holidays_list.length] = set_year+"/"+set_month+"/"+set_day
                        }
                }
            }
            console.log(holidays_list)
            
          // 編集の場合のみこちら
          if(type == 1){
            TabSelect('tab_detail')
            nittei_set()
            sub_nittei_set()
          }
        }).catch(error => {
          //  alert("error:"+JSON.stringify(error))          
        })
    }
    gapi.load('client', loadGoogleCalendarApi)

    if(all_bunrui_list) shubetsu_setting()


  </script>
  
  <style scoped>
  
  
  .btn{
    font-size: 12.5px;
  }
  
  .error{
    color:red;
  }
  
  #detail_button_area{
    width:100%;
    display: flex;
      justify-content: center;
  }
  
  
  #detail_button_area button{
     width: 180px; height: 50px;padding: 0;
  }
  
  .balloon_parent:hover .balloon-top-right {
  display: inline;                /* インライン要素として表示 */
}
.balloon-top-right {
  position   : absolute;                /* 親要素を基準 */
  display: none;                        /* 要素を非表示 */
  padding: 10px;                         /* テキストの前後の余白 */
  background-color: rgb(230, 230, 230);       /* 背景色（透明度） */
  right : 20px;                           /* 表示位置 */
  bottom : 100%;                        /* 表示位置 */
  margin-bottom : 12px;                 /* 表示位置 */
  width:auto;                          /* 吹き出し全体の幅 */
  color:black;
  min-width: 400px;
  border:1px solid rgb(230, 230, 230);
  z-index:1;
}
.balloon-top-right:after{
  border-top: 12px solid rgb(230, 230, 230);    /* 吹き出し口の高さ・色 */
  border-left: 10px solid transparent;    /* 吹き出し口の幅１／２ */
  border-right: 10px solid transparent;   /* 吹き出し口の幅１／２ */
  bottom: -12px;                          /* 吹き出し口の位置調整 */
  right : 10%;                              /* 吹き出し口の横位置 */
  content: "";                       /* コンテンツの挿入 */
  position: absolute;                /* 親要素を基準 */
}

:deep(.katsudou_blue){
  border-radius:10px;background-color:blue;color:white;width:70px;height:30px
}
:deep(.katsudou_green){
  border-radius:10px;background-color:green;color:white;width:70px;height:30px
}
:deep(.katsudou_white){
  border:1px solid #000;border-radius:10px;background-color:white;color:black;width:70px;height:30px
}
  

  .TabContents {
    border:1px solid rgb(170,170,170);
    padding:15px;
    min-height: 100px;
  }
 .tabMenu {
    display: flex;
    padding: 0;
    margin-bottom:0;
   }

   .tabMenu li {
      list-style:none;
      width: 33%;
      padding: 10px 20px;
      cursor: pointer;
  }
  #tab {
        width: 100%;
        margin: auto;
        border:0
    }
    #tab_detail{
        border-radius: 5px 0 0 0;
    }
    #tab_calendar{
        border-radius: 0 5px 0 0;
    }
    #tab_list {
        border-left: 2px solid #FFF;
        border-right: 2px solid #FFF;
    }
  .tabblue{
      color: #fff;
      background-color: #06F;
  }
  .tabgray{
      color: #fff;
      background-color:#b3b3b3 ;
      cursor: pointer;
  }
  .tabgreen{
    color: #fff;
    background-color: darkgreen;
  }

  .edit_komoku_area{
    border: 1px solid rgb(170,170,170);
    padding: 0 10px 10px 10px;
    margin-bottom:10px;
  }

  .edit_tabMenu{
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin-bottom: 0;
  }

  .edit_tabMenu li{
    padding:10px 20px;
    border-radius:5px 5px 0 0;
    list-style: none;
  }
  
  /* 活動・日程のタブエリア */
  #katsudou_tabMenu{
    width: 90%;
  }
  #katsudou_tabMenu,
  #nittei_tabMenu{
    width: 100%;
    display: flex;
    padding: 0;
    margin: 0;
    
  }
  
  /* 活動・日程のタブ共通 */
  #katsudou_tabMenu li,
  #nittei_tabMenu li{
    flex: 1;
    text-align: center;
    margin-right:2px;
  }

  /* 活動・日程の最初 */
  #katsudou_tabMenu li:first-child,
  #nittei_tabMenu li:first-child{
    border-radius: 5px 0 0 0;
  }

  /* 活動・日程の最初・末尾以外 */
  #katsudou_tabMenu li:not(:first-child):not(:last-child),
  #nittei_tabMenu li:not(:first-child):not(:last-child){
    border-radius: 0;
  }
  /* 活動・日程の末尾 */
  #katsudou_tabMenu li:last-child,
  #nittei_tabMenu li:last-child{
    border-radius: 0 5px 0 0;
    margin-right:0;
  }

  /* 活動タブのみ */
  #katsudou_tabMenu li{
    min-width: 86px;
  }

  /* 日程タブのみ */
  #nittei_tabMenu li{
    min-width: 130px;
  }


  .nittei_title{
    font-size: 1.15em;
  }

  .joken_div{
    display: flex;
    align-items: center;
    margin-top:10px;
    height: 35px;
  }
  .joken_div select,
  .joken_div input{
    font-size:1em
  }
  
  .sanka_span{
    display: flex;
    align-items: center;
    padding-bottom:10px
  }

  :deep(.list_column_left){
    border-left:1px solid #000;
    border-right:1px solid #000;
    width:30%;
    flex:1 1 0%;
  } 
  :deep(.list_column_standard){
    border-right:1px solid #000;
    width:30%;
    flex:1 1 0%;
  }
  :deep(.list_column_center){
    border-right:1px solid #000;
    border-top:1px solid #000;
    width:40%;
    flex:1 1 0%;
  }
  :deep(.list_column_header){
    border-top:1px solid #000;
    border-bottom:1px solid #000;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :deep(#title_area),:deep(#list_column_area),:deep(#calendar_column_area){
    display: flex;
    align-items: center;
  }
  :deep(#list_column_area div){
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  :deep(#katsudou_area){
    text-align: left;
    padding:10px;
  }
  
  :deep(#katsudou_button_area){
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
  }
  :deep(#calendar_button_area){
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  :deep(.month_change){
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  
  :deep(.calendar_column){
    width:14%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_right){
    width:15%;
    border-right: 1px solid #000;
    border-bottom:1px solid #000;
  }
  :deep(.calendar_column_left){
    width:15%;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom:1px solid #000;
  }
  
  
  :deep(.column_date_blank){
    min-height: 100px;
  }
  :deep(.column_date){
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  }
  :deep(.column_date_day){
    height:30px;
    display: flex;
    align-items: center;
  }
  :deep(.column_date_time){
    height:20px;
    width:100%;
    font-size: 11px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  :deep(.column_date_time_left){
    width: 55%;
    text-align: left;
    padding: 0;
    display: flex;
    justify-content: center;
  }

   @media screen and (min-width: 961px) {

        /* PC版 */
        .tabMenu li {
            padding: 10px 20px;
        }
        .tabContents{
            padding: 15px;
        }

        :deep(.column_date_blank){
            min-height: 100px;
        }
        :deep(.column_date){
            min-height: 100px;
        }
        .floating_over{
            display: none
        }
        
        .pc_only{
            display:revert
        }
        .sp_only{
            display:none
        }
    }
    @media screen and (max-width: 960px) {

        /* スマホ版 */
        .tabMenu li {
            padding: 5px;
            height:50px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .tabContents{
            padding: 5px;
        }


        /* スマホの場合は項目名を大きめにする */
        label{
            font-size: 19px;
        }
        :deep(.column_date_blank){
            height: 60px;
        }
        :deep(.column_date){
            height: 60px;
        }
        
        .floating_over{
            display: flex
        }
  
        .pc_only{
            display:none
        }
        .sp_only{
            display:revert
        }
    }

  </style>